import {Output, NgModule , EventEmitter, Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {AbstractControl,FormBuilder, FormControl, FormGroup, Validators, FormArray} from '@angular/forms';
import FileUtils, {ContentType} from '../../../../../../core/services/file-utils';
import {ToastrService} from 'ngx-toastr';
import {Message} from 'src/app/core/class/message';
import {CreateContractService} from '../../../../../../core/services/create-contract.service';
import {CommonService} from '../../../../../../core/services/common.service';
import {debounceTime, distinctUntilChanged, filter, take, takeUntil, tap} from 'rxjs/operators';
import {DocumentTypeService} from '../../../../../../core/services/document-type.service';
import {ReplaySubject, Subscription} from 'rxjs';
import {WarningComponent} from '../../../../../../shared/components/warning/warning.component';
import {NavigationEnd, Router} from '@angular/router';
import {getLocaleFirstDayOfWeek, Location} from '@angular/common';
import {BlockUI, NgBlockUI} from 'ng-block-ui';
import {DigitalContractService} from '../../../../../../core/services/digital-contract.service';
import { format } from 'date-fns';
import {Common} from 'src/app/core/constants/common';
import {ViewContractComponent} from '../view-contract/view-contract.component';
import {ErrorCode} from 'src/app/core/constants/error-code';
import { DigitalCertificateService } from 'src/app/core/services/digital-certificate.service';
import { EnvService } from 'src/app/core/services/env.service';
import {TranslateService} from "@ngx-translate/core";
import {DocumentService} from "../../../../../../core/services/document.service";
import { NgxExtendedPdfViewerService, PagesLoadedEvent, pdfDefaultOptions } from 'ngx-extended-pdf-viewer';
import { HttpErrorResponse } from '@angular/common/http';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import {
  AddCustomerDialogComponent
} from "../../customer/customer/add-customer/add-customer-dialog/add-customer-dialog.component";
import { MatDialog, MatDialogRef, MatExpansionPanel, MatSort } from '@angular/material';
import {DocumentCustomerEntity} from "../../../../../../core/class/document-customer-entity";
import {CustomerService} from "../../../../../../core/services/customer.service";
import {AutoEnterpriseService} from "../../../../../../core/services/auto-enterprise.service";
import {EnterpriseEntity} from "../../../../../../core/class/enterpriseEntity";
import { DocumentEntity } from 'src/app/core/class/DocumentEntity';
import {ActivatedRoute} from '@angular/router';
import {
  EnumApproverStatus,
  EnumContractDetailType,
  EnumContractEnterpriseStatus, EnumContractStatus,
  EnumContractUserRole, EnumContractUserStatus,
  EnumSignMethod
} from "../../../../../../core/constants/contract";
import {
  ViewDocumentReferenceComponent
} from "../../../../../../shared/components/view-document-reference/view-document-reference.component";
import { CreateContractMohaService } from "src/app/core/services/create-contract-moha.service";
import { ViewPropertiesDialogComponent } from '../view-properties-dialog/view-properties-dialog.component'
import { ngModuleJitUrl, ReturnStatement } from '@angular/compiler';
import { DocumentMohaService } from 'src/app/core/services/document-moha.service';
import { forkJoin } from 'rxjs';
import { AutoUserService } from 'src/app/core/services/auto-user.service';
import * as uuid from 'uuid';
import { ProcedureComponent } from 'src/app/shared/components/procedure/procedure.component';
import { BaseComponent } from 'src/app/shared/components/base/base.component';
const FileUploadType = 1;
const LIMIT_SIZE = 10485760;
import { DocumentDTO } from 'src/app/shared/models/document-dto.model';
import data from 'src/app/shared/components/pdf-viewer/data';
import { ViewPropertiesOriginalDialogComponent } from '../../document/view-document-moha/view-properties-original-dialog/view-properties-original-dialog.component';
import { ContractService } from 'src/app/core/services/contract.service';
import { WarningDataAuthenticationComponent} from 'src/app/shared/components/warning-data-authentication/warning-data-authentication.component';
import { SignAuthenticationPopupComponent } from '../../document/add-document-moha/sign-aunthentication-popup/sign-aunthentication-popup.component';
import { RequestConfirmIdentityComponent } from '../../../../../../shared/components/request-confirm-identity/request-confirm-identity.component';
import { EnterIdentityVneidComponent } from '../../../../../../shared/components/enter-identity-vneid/enter-identity-vneid.component';
import {DeviceDetectorService} from 'ngx-device-detector';
import { BreadcrumbsService } from 'src/app/shared/components/breadcrumbs/breadcrumbs.service';
import {CancelSignFlowComponent} from '../../document/cancel-sign-flow/cancel-sign-flow.component';
import {ApprovalDocumentComponent} from '../../document/approval-document/approval-document.component';
import {DeclineApproveDocumentComponent} from '../../document/decline-approve-document/decline-approve-document.component';
import {DeclineSignDocumentComponent} from '../../document/decline-sign-document/decline-sign-document.component';
import { WaringSignatureComponent } from 'src/app/shared/components/waring-signature/waring-signature.component';


@Component({
  selector: 'app-add-contract',
  templateUrl: './add-contract.component.html',
  styleUrls: ['./add-contract.component.scss']
})
export class AddContractDigitizationMohaComponent implements OnInit, OnDestroy {
  @BlockUI() blockUI: NgBlockUI;
  @ViewChild('inputUpload', {read: '', static: false})
  inputUploadFile: ElementRef;

  MY_DOCUMENT_ROUTER_ON_BACK_LINK = '/home-enterprise/contract-digitzation-moha';

  configAutoNumber: string;
  document: DocumentEntity;

  mainFormAdd: FormGroup;

  pdfSrc;
  dataDocumentParent: any[] = [];
  listParentView: any[] = [];
  inputPartyValue: string;
  filteredPartyOptions = [];
  timeOutQueryServer = null;
  timeOutQueryServer1 = null;
  nzCheckLoadingParty = false;
  nzCheckLoadingParty1 = false;
  checkFocus = false;
  RECORD_PARTY_SIGN: EnterpriseEntity[] = [];
  contractEnterpriseCreated = [];
  selectedDocumentTypeParent: { id: string, name: string, code?: string, filePath?: string };

  isContractCreator = false;

  serviceTypeCtrl = new FormControl(null);

  serviceTypes = [];

  public filteredServiceTypes: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);

  language: string;

  filesUpload = [];

  filesUploadNew = [];

  filesSrc = [];

  filesName = [];

  filesNameHaveOrder = [];

  newFileOrders = [];

  contractAttachmentsNew = [];

  isViewParentContract = false;

  isShowParentList = true;

  listCustomer: any[] = [];

  contractView = {
    contractName: '',
    id: [],
    filesName: [],
    listFileSize: [],
    idDocument:'',
    checkMan:2,
    attachments:[]
  };

  subscriptions: Subscription = new Subscription();

  mode: string = 'create';

  featureStatus: boolean;

  statusBackup: boolean;

  activeFile = 0;

  isViewFull = false;

  docType = [];

  contractId = '';

  parentContracts = [];

  parentSelected = new FormControl();

  affiliateContract = [];

  isLoading = false;

  inforContract: any;

  contractEnterpriseList: any;
  dateField = '';
  filesAttachment = [];
  filesAttachmentOld = [];
  mainFiles = [];
  filepdfNew = [];
  newFileAttachmentOrders = [];
  listParentHeight = 0;
  mapOfExpandData: { [key: string]: boolean } = {};
  contractSignStatus: any[] = [];
  parentActive = -1;
  inputInternalDocumentsValue:string;
  private customerDialog: MatDialogRef<AddCustomerDialogComponent>;

  maxSize = 0;
  maxSizeSystem = 0;
  maxPerMainFile = 0;
  maxPerAttachFile = 0;
  enumContractEnterpriseStatus = EnumContractEnterpriseStatus;
  valueAddPartyOrder = 1;
  mesage: string = '';
  customerMohaId : any = null;
  isLocked = false;

  page: number;
  totalPages = 0;
  pageVariable = 1;
  pageCurrent = 1;
  pageSize: number;
  routeLink: string;
  enterprise: '';
  documentTypeSearch: '';
  nameOrCode: '';
  customerName: '';
  status: '';
  serviceType: '';
  serviceTypeEntity: any;
  taxCode: '';
  createdUser: '';
  createdTimeFrom: '';
  createdTimeTo: '';
  finishDateFrom: '';
  finishDateTo: '';
  sortDirection: '';
  sortColumn: '';
  thumbnail: any = [];
  receivedTimeFrom: '';
  receivedTimeTo: '';
  signRole: any;
  nameOrEmailOrPhoneUserSign: '';
  senderName: '';
  certificateNo: ''
  contractCodeName: ''
  contractCodeParam: '';
  contractName: '';
  customer: '';
  contractEnterpriseCertificateNo: '';
  negotiate: '';
  formType: '';

  warningContractQuantity: boolean = false;

  BASE_URL = 'http://localhost:8091/api';
  authorization: any
  markPdf: any
  docInfos:any
  contractStatus: any;
  isDefaultAdmin: boolean = false;
  permissions: any;
  showInfo = false;
  isUpdate = false;
  isOnAutoNumber = false;
  hasCustomerType : boolean = true;
  listDataSource: any = [];
  dialogRef: any;
  optionsMap = new Map<number, any[]>();

  mohaConfirmStatus : any;
  mohaStatus : any;
  idMoha : any;
  contractMohaErrorDescription : any = "";
  isNoSigner: boolean = false;
  isCurrentStatus: number;
  messageAuthenCode: any;
  messageAuthenDate: any;

  nzCheckLoadingUserSign:boolean = false;
  nzCheckLoadingUser:boolean = false;
  inputUserValue: string;
  filteredUserOptions = [];
  filteredUserSign = [];
  isFormChanging: boolean = false;
  userSigns: any[] = [];
  inputUserSignValue: string;
  clickSave = false;
  fileUploadArray:any[] = [];
  listSign = [];
  pageIndex = 1;
  signNeedShow: null;
  signApproverNeedShow: null;
  signSelected = null;
  isSelectPosition = false;
  zoomLevel = 100;
  documentCodeNull = false;
  form: FormGroup;
  width = 300;
  height = 136;
  maxPageCurrent;
  isMouseLeave: boolean = false;
  stopDrop = true;
  stopClose = true;
  selectedServiceType: any;
  enterpriseSign: any[] = [];
  emailPattern = Common.EMAIL_PATTERN;
  phonePattern2 = Common.PHONE_PATTERN2;
  certificateNoPattern = Common.CERTIFICATE_NO_PATTERN;
  mainContractAttachments : any []= [];
  checkTindyStatus = true;
  checkOrder : boolean = false;
  userId: any;

  listDataUpdateSource: any = [];
  titleChange: string = '';
  listColumnVersionHistory: any[] = [];
  listDataVersionHistory: any[] = [];

  dataCheckVneid = {
    typeVerify: '',
    certificateNoCCCD: '',
    timeWaitShare: 60
  }

  private stampWrapper: HTMLDivElement;
  size10MB = 10*1024*1024;

  constructor(
    private elRef: ElementRef,
    private printService: NgxExtendedPdfViewerService,
    private translateService:TranslateService,
    private documentService:DocumentService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private customerService: CustomerService,
    private message: Message,
    private createContractService: CreateContractService,
    public commonService: CommonService,
    private documentTypeService: DocumentTypeService,
    public autoEnterpriseService: AutoEnterpriseService,
    private digitalContractService: DigitalContractService,
    private router: Router,
    private location: Location,
    private dialog: MatDialog,
    private digitalCertificateService: DigitalCertificateService,
    private env: EnvService,
    public createContractMohaService: CreateContractMohaService,
    private documentMohaService: DocumentMohaService,
    private routes: ActivatedRoute,
    public autoUserService: AutoUserService,
    private contractService: ContractService,
    public deviceService: DeviceDetectorService,
    private breadcrumbsService: BreadcrumbsService
  ) {
    this.userId = localStorage.getItem('userId');
    this.createContractMohaService.recordsPartySign.next(null);
    this.createContractMohaService.contractMohaFields = [];
    this.isDefaultAdmin = this.commonService.checkDefaultAdmin();
    this.permissions = localStorage.getItem('permissions') ? JSON.parse(localStorage.getItem('permissions')) : [];
    this.language = localStorage.getItem('__language') || 'vi';
    pdfDefaultOptions.renderInteractiveForms = false;
    //pdfDefaultOptions.cursorToolOnLoad = 0;
    localStorage.removeItem('saveContract')
    //this.digitalContractService.keepFilter.next(true);
    this.blockUI.start();
    this.BASE_URL = env.is_private_app ? env.private_api_endpoint : env.public_api_endpoint;
    this.BASE_URL += '/file/view/digital/view-file';
    this.authorization = {
      Authorization: `Bearer ${sessionStorage.getItem('token')}`
    }
    this.form = this.fb.group({
      enterprises: this.fb.array([]),
    });
  }

  public isCancelDocument = false;
  public isStartSignFlow = false;
  public listPdfSrc = {};
  enterpriseId = localStorage.getItem('enterpriseId');
  isSetUpSignFlow: any;
  isSetupSignFlow: boolean;
  public isSignDocument = false;
  public isApproveDocument = false;
  public isForwarDocument = false;
  userType: any;
  goFrom: string;

  originalContractId: string = null;
  originalContract: any = null;   
  isAppendix = false;
  listOriginalContact: any[] = [];
  adjustedContents: any[] = [];
  adjustedContentSelected: any;

  @Output() hasChange: EventEmitter<boolean> = new EventEmitter();
  @Output() changePosition: EventEmitter<any> = new EventEmitter<any>();
  @Output() changeDataEnterprise: EventEmitter<any> = new EventEmitter<any>();
  @Output() resetSignPosition: EventEmitter<any> = new EventEmitter<any>();

  ngOnDestroy(): void {
    const currentFrame = document.getElementById('sample-iframe');
    if(currentFrame){
      currentFrame.remove()
    }
    this.subscriptions.unsubscribe();
    this.createContractMohaService.resetData();
    // Rời hẳn khỏi module (sang tab chức năng khác) thì xóa filter đang giữ;
    // điều hướng trong nội bộ module (create/update/view) thì vẫn giữ filter
    this.router.events.pipe(
      filter((e: any) => e instanceof NavigationEnd),
      take(1)
    ).subscribe(() => {
      if (!this.router.url.includes('contract-digitzation-moha')) {
        this.digitalContractService.keepFilter.next(null);
        this.digitalContractService.filterContract.next(null);
        this.digitalContractService.isSearch.next(null);
      }
    });
  }

  @HostListener('document:click')
  parentFocusOut() {
    if (this.mainFormAdd) {
      this.focusOut('parentSelected');
    }
  }

  async ngOnInit() {
    this.loadDataTable();
    this.blockUI.start();
    const digitalFeature = JSON.parse(localStorage.getItem('featureStatus'));
    digitalFeature.map(item => {
      if (item.permission === 10) {
        this.featureStatus = item.status;
        this.statusBackup = item.statusBackup;
      }
    });

    const param = this.router.url.split('?')[0].split('/');
    const mode = param.pop();

    switch (mode) {
      case 'create':
        this.mode = mode;
        this.blockUI.stop();
        break;
      case 'view':
        this.mode = mode;
        this.isLocked = true;
        this.blockUI.stop();
        break;
      case 'update':
        this.mode = mode;
        this.isUpdate = true;
        this.blockUI.stop();
        break;
      default:
          this.blockUI.stop();
    }

    if (this.createContractMohaService.isOnAutoNumber.getValue()) {
      this.isOnAutoNumber = this.createContractMohaService.isOnAutoNumber.getValue();
    }
    this.configAutoNumber = this.createContractMohaService.configAutoNumber.getValue();

localStorage.setItem("digitalContractCancel",this.mode);
    this.digitalContractService.checkBackup().subscribe(res => {
      if (res.message === 'OK') {
        this.statusBackup = false;
      }
      else {
        this.statusBackup = true;
        if (!this.featureStatus || (this.statusBackup && this.mode !== 'view')) {
          this.toastr.error(res.message);
          this.router.navigateByUrl('/home-enterprise/contract-digitzation-moha');
        }
      }
    })

    this.getMaxSize()
    this.initForm();
    this.documentTypeService.getServiceTypesMoha(localStorage.getItem('enterpriseId'), true).subscribe(rs => {
      if (rs == null || rs.data == null) {
        return 0;
      }
      this.serviceTypes = rs.data;
      this.docType = rs.data;
      const filteredData = rs.data.filter(item => item.isEmploymentContract === true);
      this.filteredServiceTypes.next(filteredData);
      this.createContractMohaService.pdfSrc.next(null);

      if (this.mode !== 'create') {
        this.contractId = param.pop();
        this.initData(this.contractId);
        this.getListEnterpriseUserSignByDocumentId(this.contractId);
      } else {
        const originalId = this.createContractMohaService.originalContractIdFromList;
        this.createContractMohaService.originalContractIdFromList = null; // xóa ngay sau khi đọc
        if (originalId) {
          this.initAppendixFromOriginal(originalId);
        }
      }
     // this.blockUI.stop();
    });


  }

  initForm() {
    this.mainFormAdd = this.fb.group({
      id: new FormControl(''),
      docType: new FormControl('', Validators.required),
      docParent: new FormControl(''),
      docName: new FormControl('', [Validators.required, Validators.maxLength(100)]),
      docContractType : new FormControl(''),
      docCode: new FormControl('', [Validators.required, Validators.maxLength(50), Validators.pattern(Common.DOCUMENT_CODE_PATTERN)]),
      effectiveDate: new FormControl('', Validators.required),
      expirationDate: new FormControl(''),
      description: new FormControl(''),
      checkParent:new FormControl(''),
      checkUser:new FormControl(''),
      allowReferenceCustomerView: new FormControl(false),
      editProperty: new FormControl(''),
    });

    this.serviceTypeCtrl.valueChanges
      .subscribe(
        () => {
          this.commonService.filterCertificateType(this.serviceTypes, this.serviceTypeCtrl, this.filteredServiceTypes);
        });
        this.mainFormAdd.controls['docContractType'].valueChanges.subscribe(value => {
          console.log('docContractType value:', value);

          if (value === 'button.limit_contract') {
            this.mainFormAdd.controls['expirationDate'].setValidators([Validators.required]);
          } else {
            this.mainFormAdd.controls['expirationDate'].clearValidators();
            this.createContractMohaService.employmentContractTerm.next('UNLIMITED');
          }
          this.mainFormAdd.controls['expirationDate'].updateValueAndValidity();
        });
  }

  getMaxSize(){
    const id = localStorage.getItem('enterpriseId')
    this.digitalCertificateService.getPermissionHSM(id).subscribe(res => {
      if(res && res.success){
        this.maxSize = res.data.maxSize > 0 ? res.data.maxSize : 10*1024*1024;
        this.maxSizeSystem = res.data.maxSizeSystem ? res.data.maxSizeSystem : 150*1024*1024;
        this.maxPerMainFile = res.data.maxPerMainFileDigitalContractMoha ? res.data.maxPerMainFileDigitalContractMoha : 5*1024*1024;
        this.maxPerAttachFile = res.data.maxPerAttachFile ? res.data.maxPerAttachFile : 150*1024*1024;
        this.mesage = this.message.getMessage('validation.validate_file_type_file_size_config').replace('{0}', String(Math.floor(this.maxPerMainFile / 1024 / 1024)))
      }
    })
  }
  checkExistedInternalUser(id: string) {
    const existedList = this.dataDocumentParent.filter((e) => {
      return e.id === id;
    });

    return (existedList.length > 0);
  }
  autocompleteInternalUserSelected($event: any, model: any) {
    if ($event.isUserInput) {
      if (!this.checkExistedInternalUser(model.id)) {
        this.dataDocumentParent = [
          ...this.dataDocumentParent,
          {
            code: model.code,
            name: model.name,
            id: model.id,
            typeId:model.typeId,
            contractTerminationStatus: model.contractTerminationStatus,
            status: model.status
          }
        ];
        this.mainFormAdd.controls.checkParent.setValue(JSON.stringify(this.dataDocumentParent));
      } else {
        this.toastr.error(this.commonService.format(this.message.getMessage('messages.add_document_forward_duplicate'), model.name));
      }
    }
  }
  getParentContract(e, value?: string) {
    if (e.key === 'ArrowDown') {
      this.parentActive++;
      if (this.parentActive > this.parentContracts.length - 1) {
        this.parentActive = 0;
      }
    } else if (e.key === 'ArrowUp') {
      this.parentActive--;
      if (this.parentActive < 0) {
        this.parentActive = this.parentContracts.length - 1;
      }
    } else if (e.key === 'Enter') {
      if (this.parentActive >= 0 && this.parentActive <= this.parentContracts.length - 1) {
        this.parentContractChange('', true);
        return;
      }
    }
    if (/^([a-zA-Z0-9\s/"':;`~!@#$%^&*()_+=.?\[\]\}\{|\\><,-])$/.test(e.key) || e.key === 'Backspace' || value === '') {
      this.reset('docParent');
      if (!this.parentSelected.value) {
        this.parentContracts = [];
        return;
      }
      const data = {
        nameOrCode: this.parentSelected.value.trim(),
        contractId: this.contractId
      };
      this.isLoading = true;
      this.nzCheckLoadingParty1 = true;
      this.digitalContractService.getContractParent(data)
        .subscribe(res => {
          if (res.data && res.success) {
            this.parentContracts = res.data;
            console.log('parentContracts:', this.parentContracts)
            const height = 45 * this.parentContracts.length;
            if (this.parentContracts.length) {
              if (height <= 250) {
                this.listParentHeight = -(height + 2 - 30);
              } else {
                this.listParentHeight = -220;
              }
            } else {
              this.listParentHeight = -17;
            }
          } else {
            this.toastr.error(res.message);
          }
          this.isLoading = false;
          this.nzCheckLoadingParty1 = false;
        });
    } else return;
  }
  get isFromSSO(){
    if( localStorage.getItem('isFromSSO') =='true'){
      return true
    }
    return false
  }
  public getCustomerById(id, isEdit = false, callback?: (customer) => void) {
    this.customerService.getCustomer(id).subscribe(rs => {
      if (rs != null && rs.data != null) {
        const customer: DocumentCustomerEntity = {
          customerAccountNumber: rs.data.accountNumber ? rs.data.accountNumber : '',
          customerAddress: rs.data.address ? rs.data.address : '',
          customerAdminUser: rs.data.adminUser ? rs.data.adminUser : '',
          customerAttachments: rs.data.attachments ? rs.data.attachments : '',
          customerBankBranch: rs.data.bankBranch ? rs.data.bankBranch : '',
          customerBankName: rs.data.bankName ? rs.data.bankName : '',
          customerBank: `${rs.data.bankName ? rs.data.bankName + ', ' : ''}${rs.data.bankBranch ? rs.data.bankBranch : ''}`,
          customerBirthday: rs.data.birthday ? this.commonService.formatDate(new Date(rs.data.birthday)) : null,
          customerCertificateId: rs.data.certificateId ? rs.data.certificateId : '',
          customerCertificateNo: rs.data.certificateNo && rs.data.customerType ? rs.data.certificateNo : '',
          customerCityId: rs.data.cityId ? rs.data.cityId : '',
          customerType: rs.data.customerType ? rs.data.customerType : '',
          customerDistrictId: rs.data.districtId ? rs.data.districtId : '',
          customerEmail: '',
          customerPhone: '',
          customerReceiverEmail: rs.data.email ? rs.data.email : '',
          customerEnterpriseId: rs.data.enterpriseId ? rs.data.enterpriseId : '',
          customerFax: rs.data.fax ? rs.data.fax : '',
          customerId: rs.data.customerId ? rs.data.customerId : '',
          customerIssuedAt: '',
          customerIssuedDate: '',
          customerIssuedDay: null,
          customerIssuedMonth: null,
          customerIssuedYear: null,
          customerName: rs.data.name ? rs.data.name : '',
          customerReceiverPhone: rs.data.phone ? rs.data.phone : '',
          customerPosition: rs.data.position ? rs.data.position : '',
          customerPrimaryEmail: rs.data.primaryEmail ? rs.data.primaryEmail : '',
          customerRepresentative: rs.data.representative
            ? this.commonService.capitalizeFirstLetter(rs.data.representative)
            : '',
          customerRepresentativeCertificateId: rs.data.representativeCertificateId ? rs.data.representativeCertificateId : '',
          customerRepresentativeCertificateNo: rs.data.representativeCertificateNo ? rs.data.representativeCertificateNo : '',
          customerRepresentativeIssuedAt: rs.data.representativeIssuedAt ? rs.data.representativeIssuedAt : '',
          customerRepresentativeIssuedDate: rs.data.representativeIssuedDate
            ? this.commonService.formatDate(new Date(rs.data.representativeIssuedDate))
            : null,
          customerSex: (typeof rs.data.sex !== 'undefined') ? (rs.data.sex ? 'Nam' : 'Nữ') : '',
          customerTaxCode: rs.data.taxCode ? rs.data.taxCode : '',
          customerWardId: rs.data.wardId ? rs.data.wardId : '',
          customerAddressUsing: rs.data.address ? rs.data.address : '',
          customerContacter: rs.data.name ? this.commonService.capitalizeFirstLetter(rs.data.name) : '',

          customerIndividualOrRepresentativeCertificate: rs.data.customerType === 10000
            ? rs.data.certificateNo
            : rs.data.representativeCertificateNo,
          customerIndividualOrRepresentativeIssuedAt: rs.data.customerType === 10000
            ? rs.data.issuedAt
            : rs.data.representativeIssuedAt,
          customerIndividualOrRepresentativeIssuedDate: rs.data.customerType === 10000
            ? this.commonService.formatDate(new Date(rs.data.issuedDate))
            : this.commonService.formatDate(new Date(rs.data.representativeIssuedDate)),
          customerIndividualOrRepresentativeIssuedDay: null,
          customerIndividualOrRepresentativeIssuedMonth: null,
          customerIndividualOrRepresentativeIssuedYear: null,
          customerIndividualOrRepresentativeIssuedShortYear: null,
          customerBusinessCertificateNo: rs.data.customerType !== 10000 ? rs.data.certificateNo : '',
          customerBusinessCertificateIssuedAt: rs.data.customerType !== 10000 ? rs.data.issuedAt : '',
          customerBusinessCertificateIssuedDate: rs.data.customerType !== 10000
            ? this.commonService.formatDate(new Date(rs.data.issuedDate))
            : '',
          customerBusinessCertificateIssuedDay: '',
          customerBusinessCertificateIssuedMonth: '',
          customerBusinessCertificateIssuedYear: '',
          customerTaxCode_01: '',
          customerTaxCode_02: '',
          customerTaxCode_03: '',
          customerTaxCode_04: '',
          customerTaxCode_05: '',
          customerTaxCode_06: '',
          customerTaxCode_07: '',
          customerTaxCode_08: '',
          customerTaxCode_09: '',
          customerTaxCode_10: '',
          customerTaxCode_11: '',
          customerTaxCode_12: '',
          customerTaxCode_13: '',
          customerTaxCode_14: '',
          customerContacterApartmantNumber: '',
          customerContacterStreetName: '',
          customerContacterGroup: '',
          customerContacterWard: '',
          customerContacterDistrict: '',
          customerContacterCity: '',
          customerContacterPhone: '',
          customerContacterEmail: '',
        }


          customer.customerEmail = rs.data.email ? rs.data.email : '';
          customer.customerPhone = rs.data.phone ? rs.data.phone : '';


        // If customer is enterprise
        if (customer.customerType !== 10000) {
          customer.customerIssuedAt = rs.data.issuedAt ? rs.data.issuedAt : '';
          customer.customerIssuedDate = rs.data.issuedDate ? this.commonService.formatDate(new Date(rs.data.issuedDate)) : null;
          customer.customerIssuedDay = rs.data.issuedDate
            ? new Date(rs.data.issuedDate).getDate()
            : null;
          customer.customerIssuedMonth = rs.data.issuedDate
            ? new Date(rs.data.issuedDate).getMonth() + 1
            : null;
          customer.customerIssuedYear = rs.data.issuedDate
            ? new Date(rs.data.issuedDate).getFullYear().toString()
            : null;
        } else {
          customer.customerIssuedAt = '';
          customer.customerIssuedDate = '';
          customer.customerIssuedDay = null;
          customer.customerIssuedMonth = null;
          customer.customerIssuedYear = null;

        }
        // Generate splitted customerTaxCode
        for (let i = 0; i < 14; i++) {
          const key = `customerTaxCode_${i < 9 ? '0' + (i + 1) : i + 1}`;
          customer[key] = customer.customerTaxCode ? customer.customerTaxCode.charAt(i) : '';
        }

        if (customer.customerIndividualOrRepresentativeIssuedDate
          || customer.customerIndividualOrRepresentativeIssuedDate !== '') {
          const customerIndividualOrRepresentativeIssuedDate = customer.customerIndividualOrRepresentativeIssuedDate.split('/');
          customer.customerIndividualOrRepresentativeIssuedDay = customerIndividualOrRepresentativeIssuedDate[0];
          customer.customerIndividualOrRepresentativeIssuedMonth = customerIndividualOrRepresentativeIssuedDate[1];
          customer.customerIndividualOrRepresentativeIssuedYear = customerIndividualOrRepresentativeIssuedDate[2];
          customer.customerIndividualOrRepresentativeIssuedShortYear = customerIndividualOrRepresentativeIssuedDate[2].slice(-2);
        }


        if (customer.customerBusinessCertificateIssuedDate || customer.customerBusinessCertificateIssuedDate !== '') {
          const customerBusinessCertificateIssuedDate = customer.customerBusinessCertificateIssuedDate.split('/');
          customer.customerBusinessCertificateIssuedDay = customerBusinessCertificateIssuedDate[0];
          customer.customerBusinessCertificateIssuedMonth = customerBusinessCertificateIssuedDate[1];
          customer.customerBusinessCertificateIssuedYear = customerBusinessCertificateIssuedDate[2];
        } else {
          customer.customerBusinessCertificateIssuedDay = '';
          customer.customerBusinessCertificateIssuedMonth = '';
          customer.customerBusinessCertificateIssuedYear = '';
        }

        if (callback) {
          callback(customer);
        }
      }
    });
  }
  public openAddCustomer() {
    this.customerDialog = this.dialog.open(AddCustomerDialogComponent, {
      width: '70%',
      data: true
    });

    this.customerDialog.componentInstance.createSuccess.asObservable().subscribe(() => {
      this.getCustomerById(this.documentService.getCustomerId(), false, (customer) => {
        this.RECORD_PARTY_SIGN = [
          ...this.RECORD_PARTY_SIGN,
          {
            enterpriseId: customer.customerId,
            order: this.valueAddPartyOrder,
            email: customer.customerEmail,
            enterpriseName: '',
            phone: customer.customerPhone,
            status: this.enumContractEnterpriseStatus.NO_PROCESS,
            isCreatedSide: false,
            customerId: this.documentService.getCustomerId(),
            name: customer.customerName,
            certificateNo: (customer.customerTaxCode.length > 0) ? customer.customerTaxCode : customer.customerCertificateNo,
            useDataForTemplate: false,
            isSignNoLogin: false,
            customerType : customer.customerType
          }
        ];
        this.mainFormAdd.controls.checkUser.setValue(JSON.stringify(this.RECORD_PARTY_SIGN));
        this.createContractMohaService.isDirty = true;
      });
    });
  }
  autocompletePartySelected($event: any, model: any) {
    console.log('model data:', JSON.stringify(model, null, 2));
    if ($event.isUserInput) {
      if (!this.checkExistedParty(model.enterpriseId, model.customerId)) {
        this.RECORD_PARTY_SIGN = [
          ...this.RECORD_PARTY_SIGN,
          {
            enterpriseId: model.enterpriseId,
            order: this.valueAddPartyOrder,
            email: model.email,
            enterpriseName: '',
            phone: model.phone,
            status: this.enumContractEnterpriseStatus.NO_PROCESS,
            isCreatedSide: model.isCreatedSide,
            customerId: model.customerId,
            name: model.name,
            certificateNo: (model.taxCode) ? model.taxCode : model.certificateNo,
            useDataForTemplate: false,
            isSignNoLogin: false,
            customerType : model.customerType,
          }
        ];
        this.mainFormAdd.controls.checkUser.setValue(JSON.stringify(this.RECORD_PARTY_SIGN));
        this.inputPartyValue = '';
        this.filteredPartyOptions = [];
        //this.createContractMohaService.customerMohaId = model.customerId;
        this.createContractMohaService.recordsPartySign.next(this.RECORD_PARTY_SIGN);
        // this.createContractMohaService.prevStep.next(1);
        this.createContractMohaService.createContractType.next(1);
        this.valueAddPartyOrder = Math.max.apply(Math, this.RECORD_PARTY_SIGN.map((o) => {
          return o.order;
        })) + 1;

      } else {
        this.toastr.error(this.commonService.format(this.message.getMessage('messages.add_party_apostrophe_duplicate'), model.name));
      }
    }
  }

  checkExistedCreatorParty(): boolean {
    const existedList = this.RECORD_PARTY_SIGN.filter((e) => {
      return e.isCreatedSide === true;
    });

    return existedList.length > 0;
  }
  checkExistedParty(enterpriseId: string, customerId: string) {
    const existedList = this.RECORD_PARTY_SIGN.filter(d => d.customerId === customerId)

    return existedList.length > 0;
  }
  onChangePartySignSearch($event: any): void {
    this.filteredPartyOptions = [];
    if ($event.inputType.includes('insert') || $event.inputType.includes('delete')) {
      if (this.timeOutQueryServer) {
        clearTimeout(this.timeOutQueryServer);
      }
      this.timeOutQueryServer = setTimeout(() => {
        if (this.inputPartyValue.trim().length > 0) {
          this.nzCheckLoadingParty = true;
          this.autoEnterpriseService.fetchAuto(this.inputPartyValue.trim())
            .then(result => {
              // console.log('record party sign result', result);

              this.filteredPartyOptions = [];
              if (result) {
                for (const item of result) {
                  if(!item.isCreatedSide && item.customerType == 10000){
                    this.filteredPartyOptions.push(item);
                  }
                }
              }
              // this.filteredPartyOptions = result;
            }).finally(() => {
            this.nzCheckLoadingParty = false;
          });
        } else {
          this.inputPartyValue = '';
        }
      }, 500);

    }
  }

  onClickDeleteElementRecordInternalUser(id: any): void {
    this.dataDocumentParent = this.dataDocumentParent.filter(d => d.id !== id);
    this.mainFormAdd.controls.checkParent.setValue(JSON.stringify(this.dataDocumentParent));
    console.log("this.createContractMohaService.customerMohaId = DELETE: "+ this.createContractMohaService.customerMohaId);
  }

  onClickDeleteElementRecordInternalUserNew(id: any): void {

    this.RECORD_PARTY_SIGN = this.RECORD_PARTY_SIGN.filter(d => d.customerId !== id);
    this.createContractMohaService.recordsPartySign.next(this.RECORD_PARTY_SIGN);
    this.mainFormAdd.controls.checkUser.setValue(JSON.stringify(this.RECORD_PARTY_SIGN));
    console.log("this.createContractMohaService.customerMohaId = DELETE NEW: "+ this.createContractMohaService.customerMohaId);
  }
  getParentContractNew(e, value?: string) {
    this.parentContracts = [];
    if (e.inputType.includes('insert') || e.inputType.includes('delete')) {
      if (!this.inputInternalDocumentsValue) {
        this.parentContracts = [];
        return;
      }
      if (this.timeOutQueryServer1) {
        clearTimeout(this.timeOutQueryServer1);
      }
      this.timeOutQueryServer1 = setTimeout(() => {
      const data = {
        nameOrCode: this.inputInternalDocumentsValue.trim(),
        contractId: this.contractId
      };
      this.isLoading = true;
      this.nzCheckLoadingParty1 = true;
      this.digitalContractService.getContractParent(data)
        .subscribe(res => {
          if (res.data && res.success) {
            this.parentContracts = res.data.filter(item => !item.isContractShare);
            const height = 45 * this.parentContracts.length;
            if (this.parentContracts.length) {
              if (height <= 250) {
                this.listParentHeight = -(height + 2 - 30);
              } else {
                this.listParentHeight = -220;
              }
            } else {
              this.listParentHeight = -17;
            }
          } else {
            this.toastr.error(res.message);
          }
          this.nzCheckLoadingParty1 = false;
          this.isLoading = false;

        });
  },500);
    } else return;
  }

  parentContractChange(id, index?: boolean) {
    if (index) {
      this.mainFormAdd.controls.docParent.patchValue(this.parentContracts[this.parentActive].id);
      this.parentSelected.patchValue(this.parentContracts[this.parentActive].code + ' - ' + this.parentContracts[this.parentActive].name)
    } else {
      this.mainFormAdd.controls.docParent.patchValue(id);
      const parentSelected = this.parentContracts.filter(item => item.id === id);
      if (parentSelected.length > 0) {
        this.parentSelected.patchValue(parentSelected[0].code + ' - ' + parentSelected[0].name);
      }
    }

    if (this.mainFormAdd.controls.docParent.value) {
      this.digitalContractService.getContractMohaById(this.mainFormAdd.controls.docParent.value).subscribe(res => {
        if (res.success) {
          this.mainFormAdd.controls.docType.patchValue(res.data.serviceType);
          this.mainFormAdd.controls.docType.disable();
        }
      })
    }
    this.mainFormAdd.markAsDirty();
  }

  dateFocusOut(field: string) {
    if (this.mainFormAdd.controls[field].errors
        && this.mainFormAdd.controls[field].errors.matDatepickerParse
        && this.mainFormAdd.controls[field].errors.matDatepickerParse.text === ''
    ) {
      this.mainFormAdd.controls[field].patchValue(null);
      if (field === 'expirationDate') {
        this.mainFormAdd.controls[field].setErrors(null);
      }
    }
  }

  async onSelectedUpload(event) {
    await this.getFile(event);
    event.target.value = null;
  }

  public async getFile(e) {
    this.blockUI.start();

    if (typeof FileReader !== 'undefined') {
      const files = e.target.files;
      let size = 0;
      const filesUpload = this.filesUpload ? this.filesUpload : [];
      const filesSrc = this.filesSrc ? this.filesSrc : [];
      const oldFiles = this.contractId ? this.mainFormAdd.controls.contractAttachments.value : [];
      let isErrorFileSize = false
      oldFiles.forEach(item => {
        size += item.fileSize;
      });
      filesUpload.forEach(item => {
        size += item.size;
      });
      files.forEach(item => {
        if(item.size > this.maxPerMainFile){
          isErrorFileSize = true
          return;
        }
        size += item.size;
      })
      if(isErrorFileSize){
        this.toastr.error(this.message.getMessage('validation.max_size_file_upload').replace('{0}', String(Math.floor(this.maxPerMainFile / 1024 / 1024))));
        this.blockUI.stop();
        return;
      }

      let filesName = this.filesName ? this.filesName : [];

      let error: 'type' | 'size' | 'count' = null;
      const type = ['application/pdf'];
      const tails = ['pdf'];
      if (files.length + filesUpload.length + oldFiles.length > 20) {
        error = 'count';
      } else if (size <= this.maxSizeSystem) {
        for (let file of files) {
          const fileName = file.name;
          const dotIndex = fileName.lastIndexOf('.');
          const namePart = fileName.substring(0, dotIndex);
          const extPart = fileName.substring(dotIndex + 1).toLowerCase();
          const newFileName  = `${namePart}.${extPart}`;
          file = new File([file], `${newFileName}`, { type: file.type })
          const isPdfExtension = dotIndex > 0 && extPart === 'pdf';
          const isPdfMimeType = file.type === 'application/pdf' || file.type === '';
          const src = isPdfExtension && isPdfMimeType
            ? await this.checkContentTypeThenAddFile(file)
            : null;
          if (!src) {
            error = 'type';
            break;
          } else {
            const name = this.checkmatched(this.filesName, file.name);
            filesName.push(name);
            this.filesNameHaveOrder = [...this.filesName.map((fileName, index) => ({
              order: index,
              fileName: fileName
            }))];
            filesUpload.push(file);

            if (file.type === 'application/pdf') {
              const src = await this.checkContentTypeThenAddFile(file);
              filesSrc.push(src);
            } else {
              filesSrc.push('notPDF');
            }
          }
        }
      } else {
        error = 'size';
      }

      if (error) {
        switch (error) {
          case 'type':
            if (!this.toastr.findDuplicate(this.message.getMessage('messages.only_accept_pdf'), true, true)) {
              this.toastr.error(this.message.getMessage('messages.only_accept_pdf'));
              this.blockUI.stop();
            }
            break;
          case 'size':
            if (!this.toastr.findDuplicate(this.message.getMessage('validation.max_size_file_contract'), true, true)) {
              this.toastr.error(this.message.getMessage('validation.max_size_file_contract').replace('{0}', String(Math.floor(this.maxSizeSystem / 1024 / 1024))));
              this.blockUI.stop();
            }
            break;
          case 'count':
            if (!this.toastr.findDuplicate(this.message.getMessage('messages.files_less_20'), true, true)) {
              this.toastr.error(this.message.getMessage('messages.files_less_20'));
              this.blockUI.stop();
            }
            break;
          default:
            break;
        }
        this.blockUI.stop();
        return;
      } else {
        this.filesUpload = filesUpload;
        this.filesSrc = filesSrc;
        this.filesName = filesName;
        this.filesNameHaveOrder = [...this.filesName.map((fileName, index) => ({
          order: index,
          fileName: fileName
        }))];
        const fileOld = this.contractId ? this.mainFormAdd.controls['contractAttachments'].value : [];
        this.mainFiles = [...fileOld, ...this.filesUpload]
        // this.upLoadFilepdf(fileOld);
      }
    }

    if (this.filesSrc.length > 0) {
      this.pdfSrc = this.filesSrc[this.activeFile];
    }

    this.blockUI.stop();
    return true;
  }

  public reset(feild: string) {
    this.mainFormAdd.controls[feild].reset('');

    if (feild === 'docParent') {
      this.mainFormAdd.controls.docType.enable();
    }
  }

  private checkmatched(listFileName: string[], name: string) {
    const filenameSplit = name.split('.')
    const type = filenameSplit.pop();
    const fileName = filenameSplit.join('.');
    let fileNameConverted = fileName + '.' + type;
    let k = 1;
    if (listFileName.length > 0) {
      while (listFileName.includes(fileNameConverted)) {
        fileNameConverted = fileName + '(' + k + ').' + type;
        k++;
      }
    }


    return fileNameConverted;
  }

  private async checkContentTypeThenAddFile(file: File): Promise<boolean> {
    const ct = await FileUtils.getContentType(file);
    let r = null;
    if (ContentType.PDF === ct) {
      r = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        // tslint:disable-next-line:no-shadowed-variable
        reader.onload = (e: any) => {
          resolve(e.target.result);
        };
        reader.readAsArrayBuffer(file);
      });
    }
    return new Promise((resolve, reject) => resolve(r));
  }

  focusOut(field: string) {
    if (field !== 'parentSelected') {
      const value = this.mainFormAdd.controls[field].value.trim();
      this.mainFormAdd.controls[field].patchValue(value ? value : '');
      this.mainFormAdd.controls[field].markAllAsTouched();
    } else {
      if (!this.mainFormAdd.controls.docParent.value) {
        this.parentSelected.reset('');
        // this.parentContracts = [];
      }
    }
  }

  checkSignPosition(): Promise<boolean> {
    return new Promise((resolve) => {
      if (this.createContractService.signPositions.getValue() && this.createContractService.signPositions.getValue().length > 0) {
        resolve(true);
      } else {
        const dialogRef = this.dialog.open(WaringSignatureComponent, {
          data: this
        });
        dialogRef.afterClosed().subscribe((result) => {
          resolve(result === true); // true khi bấm "Tiếp tục", undefined/false khi "Quay lại"
        });
      }
    });
  }

  onClickNext(){

  }

  async nexttab(){

    const canContinue = await this.checkSignPosition();
  if (!canContinue) {
    return; // Bấm "Quay lại" -> dừng luôn, không chạy code tiếp
  }

    console.log("this.createContractMohaService.customerMohaId = nexttab: "+ this.createContractMohaService.customerMohaId);
    this.createContractMohaService.validateData();
    this.mainFormAdd.markAllAsTouched();
    if (this.mainFormAdd.invalid) {
      this.isViewFull = false;
      return;
    }else{
      const partySignData = this.createContractMohaService.recordsPartySign.getValue();
      if (!partySignData || partySignData.length === 0) {
        this.toastr.error(this.message.getMessage('add_document_moha.employment_sign'));
        return;
      }
      const missingCustomerType = partySignData.filter(element => !element.customerType);

      // check user ky ket
      const hasSigner = this.userSigns && this.userSigns.some(user => user.role == 1);

    // const hasApprover = this.userSigns && this.userSigns.some(user => user.role === '2');

    if (!hasSigner) {
      this.toastr.error(this.message.getMessage('validation.error_user_no_set_up'));
      return;
    }

    // if (!hasApprover) {
    //   this.toastr.error('Bạn chưa chọn người phê hợp đồng/văn bản');
    //   return;
    // }

    if (missingCustomerType.length > 0) {
      await forkJoin(
        missingCustomerType.map(element =>
          this.customerService.getCustomer(element.customerId).pipe(
            tap(rs => element.customerType = rs.data.customerType)
          )
        )
      ).toPromise();
    }
      if(( this.createContractMohaService.recordsPartySign.getValue() && this.createContractMohaService.recordsPartySign.getValue().length) &&
              !this.createContractMohaService.checkHasOneCustomerType10000()){
              this.toastr.error(this.message.getMessage('add_document_moha.employment_sign'))
              return;
            }
      if (!this.pdfSrc) {
      if (!this.toastr.findDuplicate(this.message.getMessage('messages.error_contract_quickly'), true, true)) {
        this.toastr.error(this.message.getMessage('messages.error_contract_quickly'));
      }
      const listBtn = document.querySelectorAll("button");
      listBtn.forEach((btn) => {
        if (btn.className.includes('mat-stroked-button-create-document')) {
          btn.classList.add("btn_glowing");
        }
      });
      setTimeout(() => {
        listBtn.forEach((btn) => {
          btn.classList.remove("btn_glowing");
        });
      }, 5000);

      console.log("this.createContractMohaService.customerMohaId = nexttab: "+ this.createContractMohaService.customerMohaId);
      return;
    }

    this.createContractMohaService.expirationDate = this.mainFormAdd.controls.expirationDate.value;
    this.createContractMohaService.effectiveDate = this.mainFormAdd.controls.effectiveDate.value;
    this.createContractMohaService.docCode = this.mainFormAdd.controls.docCode.value;

    if (this.isAppendix) {
      if (!this.adjustedContentSelected) {
        this.mainFormAdd.controls['editProperty'].markAsTouched();
        return;
      }
      this.createContractMohaService.originalContract.next(this.originalContractId);
      this.createContractMohaService.adjustedContentSelected.next(this.adjustedContentSelected);
      this.createContractMohaService.createContractType.next(1);
      this.createContractMohaService.effectiveDate = null;
      this.createContractMohaService.expirationDate = null;
      // if(this.mode === 'create'){
      //   this.createContractMohaService.contractMohaUpdateFields = [];
      // }
    }

    this.createContractMohaService.firstUpdate = true;

    const param = this.router.url.split('/');
    const mode = param.pop();

        //this.createContractMohaService.docContractType = this.mainFormAdd.controls.docContractType.value;

    //this.createContractMohaService.expirationDate = this.mainFormAdd.controls.expirationDate.value
    this.showInfo = true;
    }
  }

  getListEnterpriseUserSignByDocumentId(id) {
    localStorage.removeItem('typeAllowCheck');
    localStorage.removeItem('enterprisePhoneProcessing');
    localStorage.removeItem('enterpriseNameProcessing');
    this.documentMohaService.getListEnterpriseUserSignBydocumentIdService(id).subscribe(rs => {
      if (rs.data) {
        this.contractEnterpriseList = rs.data.enterpriseSign;
        rs.data.enterpriseSign.map(enter => {
          // trạng thái đang xử lý status = 2
          if (enter.status === 2 && enter.enterpriseId === localStorage.getItem('enterpriseId')) {
            localStorage.setItem('typeAllowCheck', enter.type);
            localStorage.setItem('enterprisePhoneProcessing', enter.enterprisePhone);
            localStorage.setItem('enterpriseNameProcessing', enter.enterpriseName);
          }
        });

        // bug 1:   Chức năng Xem thông tin hợp đồng/Văn bản: Nếu bên lập thiết lập luồng ký cho khách hàng
        //this.document.isHaveNoCreatedSide = rs.data.isHaveNoCreatedSide;
        const {enterpriseSign, userSign, initial, enterpriseSignIdInFlow, userApproves,isSetUpSignFlow, userSignAll} = rs.data;
        this.isSetUpSignFlow = isSetUpSignFlow;
        // if(isSetUpSignFlow && !this.)
        // const userSignNew = rs.data && rs.data.userSignNew ?  rs.data.userSignNew : undefined

        this.enterpriseSign = enterpriseSign;
        //this.userApproves = userApproves;
      }
    }
    , (error) => console.log(error));
  }

  checkViewAuthenStatus() {
    if (this.mode !== 'view' || !this.document) {
      return;
    }
  
    const onCancelPopup = () => this.location.back();
  
    if (this.document.status == 2) {
      this.authenticateTindyVneid(() => {}, onCancelPopup);
    } else if (this.document.status == 4) {
      this.documentMohaService.checkMessageAuthen(this.document.id).subscribe(res => {
        if (!res.data.isDoneMessageAuthen) {
          this.checkTindy(undefined, onCancelPopup);
        }
      });
    }
  }

  checkOrderUnique(): boolean {
    const orders = this.userSigns
      .filter((item: any) => item.role == 2 || item.role == '2')
      .map((item: any) => item.order)
      .filter((order: any) => order !== null && order !== undefined);

    const countMap = new Map<number, number>();
    let checkCount = false;

    for (const order of orders) {
      countMap.set(order, (countMap.get(order) || 0) + 1);
      if (countMap.get(order)! > 1) {
        checkCount = true;
      }
    }

    return checkCount;
  }


  openViewProperties() {
    const parties = this.createContractMohaService.recordsPartySign.getValue() || this.contractEnterpriseList || [];
    const customerSign = parties.find(
      (c: any) => c.customerId == this.createContractMohaService.customerMohaId || c.customerType == 10000
    );
  
    const dialogComponent: any = this.document.formType === 'CONTRACT_APPENDIX'
      ? ViewPropertiesDialogComponent
      : ViewPropertiesOriginalDialogComponent;
  
    this.dialogRef = this.dialog.open(dialogComponent, {
      width: '80vw',
      data: {
        listDataSource: this.listDataSource,
        listDataUpdateSource: this.listDataUpdateSource,
        customerMohaId: this.createContractMohaService.customerMohaId,
        customerMohaName: customerSign.enterpriseName || customerSign.name || '',
        listCustomer: this.listCustomer,
        optionsMap: this.optionsMap,
        isOriginalContract: this.document.formType === 'CONTRACT_APPENDIX' ? true : false,
        titleChange: this.titleChange,
        listColumnVersionHistory: this.document.formType === 'CONTRACT_APPENDIX' ? [] : this.listColumnVersionHistory,
        listDataVersionHistory: this.document.formType === 'CONTRACT_APPENDIX' ? [] : this.listDataVersionHistory
      }
    });
  
    this.dialogRef.afterClosed().subscribe(rs => {
      if (rs) {
        // callback after close if needed
      }
    });
  }

  async loadDataTable() {
    let dataApi = await this.documentTypeService.getInfoProperties(null, false).toPromise()
    if (!dataApi || !dataApi.data) return;
    let res: any = dataApi.data

    let listProperties = this.mapDataMergeField(res)
    this.listDataSource = listProperties;
    this.buildOptions();

    this.listDataSource.forEach((item: any) => {
    });
  }


  private buildOptions() {

    this.listDataSource.forEach((item: any) => {

      if (item.inputType == "DROPDOWN" && item.metadata) {
        const parsed = JSON.parse(item.metadata);
        this.optionsMap.set(item.id, parsed);
      } else {
        console.log(`→ SKIP: inputType=${item.inputType} | metadata=${item.metadata}`);
      }
    });
  }

  mapDataMergeField(data: any){
    if(!data || !data.length) return
    let dataPropertiesConvert = []
    data.forEach((field: any, idx: number) => {
      let propertiesInfo: any = {
        ...field,
        stt: idx + 1,
        dataDropDown: [],
        controlField: field.isRequired ? new FormControl('', [Validators.required]) : new FormControl()
      }
      propertiesInfo.controlField.disable()
      dataPropertiesConvert.push(propertiesInfo)
    });
    return dataPropertiesConvert
  }

  async getDataUpdate(data: any) {
    const res: any = await this.contractService.getPropertiesForUpdate().toPromise();
    const listProperTies = res.data.map((content: any) => {
      return {
        ...content,
        title: this.createContractMohaService.convertTitleContent(content.type)
      }
    });
    const dataUpdateFields = listProperTies.find((ele: any) => ele.type === data.editProperty);
    if (dataUpdateFields) {
      this.titleChange = this.createContractMohaService.convertTitleContent(dataUpdateFields.type);
      let listProperties = this.mapDataMergeField(dataUpdateFields.properties);
      this.listDataUpdateSource = listProperties;
      this.buildOptionsUpdate();
      if (data.contractMohaUpdateFields) {
        this.mappingDataMFFormService(data.contractMohaUpdateFields, 'UPDATE');
      }
    }
  }

  private buildOptionsUpdate() {
    this.listDataUpdateSource.forEach((item: any) => {
      if (item.inputType == "DROPDOWN" && item.metadata) {
        this.optionsMap.set(item.id, JSON.parse(item.metadata));
      }
    });
  }

  async getListVersionHistory(id: string) {
    forkJoin([
      this.contractService.getListVersionHistory(id),
      this.contractService.getPropertiesForUpdate(),
      this.documentTypeService.getInfoProperties(null, false)
    ]).subscribe((response: any[]) => {
      if (!response || !response.length) return;
      const listVersion: any[] = response[0].data;
      let dataStandard = [...response[2].data];
      const configStandard = [
        { code: 'contractVersionName', name: 'Tên HĐ/PL', value: '', id: uuid.v4() },
        { code: 'contractVersionCode', name: 'Mã HĐ/PL', value: '', id: uuid.v4() },
        { code: 'version', name: 'Phiên bản', value: '', id: uuid.v4() },
        { code: 'createdTimeVersion', name: 'Ngày áp dụng', value: '', id: uuid.v4(), inputType: 'DATETIME' },
        {
          code: 'isContractOriginal', name: 'Hình thức', value: '', id: uuid.v4(), inputType: 'DROPDOWN',
          metadata: '[{"value":"true", "name":"Hợp đồng"}, {"value":"false", "name":"Phụ lục"}]'
        },
      ];
      if (response[1].data && response[1].data.length > 0) {
        response[1].data.forEach((element: any) => {
          if (element.properties && element.properties.length > 0) {
            dataStandard = [...dataStandard, ...element.properties];
          }
        });
        dataStandard = [...configStandard, ...this.uniqueById(dataStandard)];
      }
      this.listColumnVersionHistory = [...dataStandard];
      if (listVersion) {
        this.listDataVersionHistory = this.mapFull(listVersion, dataStandard);
      }
    });
  }

  uniqueById(arr: any[]): any[] {
    const seen = new Set();
    return arr.filter((item: any) => {
      if (seen.has(item.id)) return false;
      seen.add(item.id);
      return true;
    });
  }
  

  mapFull(versions: any[], configFields: any[]): any[] {
    return versions.map((version: any) => {
      const fieldMap: any = {};
      version.contractMohaVersionFields.forEach((f: any) => { fieldMap[f.key] = f.value; });
      const result: any = {};
      configFields.forEach((field: any) => {
        const code = field.code;
        if (fieldMap[code] != null) result[code] = fieldMap[code];
        else if (version.contractMohaVersion && version.contractMohaVersion[code] != null) result[code] = version.contractMohaVersion[code];
        else result[code] = '';
      });
      return result;
    });
  }


  private focusFirstInvalidField(): void {
    setTimeout(() => {
      const formEl: HTMLElement = this.elRef.nativeElement.querySelector('form');
      if (!formEl) return;

      const invalidEl = formEl.querySelector(
        'input.ng-invalid, textarea.ng-invalid, mat-select.ng-invalid, nz-select.ng-invalid, nz-date-picker.ng-invalid'
      ) as HTMLElement;

      if (!invalidEl) return;

      invalidEl.scrollIntoView({ behavior: 'smooth', block: 'center' });

      const focusable =
        (invalidEl.matches('input, textarea') ? invalidEl : invalidEl.querySelector('input, [tabindex]')) as HTMLElement;

      setTimeout(() => (focusable || invalidEl).focus(), 300);
    }, 0);
  }

  saveContract(isSign: boolean = false) {
    this.mainFormAdd.markAllAsTouched();

    if (this.mainFormAdd.controls.docCode.hasError('matched')) {
      this.mainFormAdd.controls.docCode.setErrors(null);
    }



    // Validate bước khai báo dữ liệu HĐ Bộ Nội vụ trước khi gọi API backup.
    this.createContractMohaService.saveStep3.next(true);

    const step3ErrorMessage = this.createContractMohaService.getErrorMessageStep3();
    if (step3ErrorMessage) {
      this.isViewFull = false;
      this.focusFirstInvalidField();
      return;
    }

    if (this.mainFormAdd.invalid || !this.createContractMohaService.isSuccessStep3.getValue()) {
      this.isViewFull = false;
      this.focusFirstInvalidField();
      return;
    }

    this.digitalContractService.checkBackup().subscribe(backupStatus => {
      if (backupStatus.message === 'OK') {
        if (!this.pdfSrc) {
          if (!this.toastr.findDuplicate(this.message.getMessage('messages.error_contract_quickly'), true, true)) {
            this.toastr.error(this.message.getMessage('messages.error_contract_quickly'));
          }
          const listBtn = document.querySelectorAll("button");
          listBtn.forEach((btn) => {
            if (btn.className.includes('mat-stroked-button-create-document')) {
              btn.classList.add("btn_glowing");
            }
          });
          setTimeout(() => {
            listBtn.forEach((btn) => {
              btn.classList.remove("btn_glowing");
            });
          }, 5000);
          return;
        }

        const contractAttachments = this.contractId ? this.mainFormAdd.controls.contractAttachments.value : [];
        if (this.mainFormAdd.valid && (this.filesUpload.length > 0 || contractAttachments.length > 0)) {
          this.newFileOrders = [...[]];
          this.filesNameHaveOrder.forEach((fileNameHaveOrder) => {
            this.filesUpload.forEach((fileUpload) => {
              if(fileNameHaveOrder.fileName === fileUpload.name) {
                this.newFileOrders.push(fileNameHaveOrder.order);
              }
            });
          });

          const mainContractAttachments = [];
          this.filesNameHaveOrder.forEach((fileNameHaveOrder) => {
            this.filesUpload.forEach((fileMain) => {
              if(fileNameHaveOrder.fileName === fileMain.fileName || fileNameHaveOrder.fileName === fileMain.name) {
                mainContractAttachments.push({
                  attachmentOrder: fileNameHaveOrder.order,
                  id: fileMain.id,
                  fileName: fileMain.fileName || fileMain.name,
                  fileSize: fileMain.fileSize || fileMain.size
                });
              }
            });
          });
          this.mainContractAttachments = mainContractAttachments;

          this.filesAttachment.forEach((item, index) => {
            this.newFileAttachmentOrders.push(index)
          })
          const controls = this.mainFormAdd.controls;
          const listParentId = [];
          if(this.dataDocumentParent.length >0){
            this.dataDocumentParent.forEach(ele =>{
              listParentId.push(ele.id);
            })
          }
          if(this.RECORD_PARTY_SIGN.length >0){
            this.RECORD_PARTY_SIGN.forEach(ele =>{
              delete ele.enterpriseName;
              delete ele.status;
              delete ele.customerType;
              delete ele.customerCode;
            })
          }
          for (let item of this.userSigns) {
            // Nếu signConfig đang là object thì convert về string trước
            if (item.signConfig && typeof item.signConfig !== 'string') {
                item.signConfig = JSON.stringify(item.signConfig);
            }

            item.signConfig = JSON.stringify(
                item.signConfig
                    ? this.setDataSignConfig(JSON.parse(item.signConfig))
                    : { resize: false, showImage: item.isSignDigitalCertificate ? true : false }
            );
        }
        this.userSigns = this.userSigns.map(item => {
          let configObj;
          if (item.signConfig) {
            const parsed = typeof item.signConfig === 'string'
              ? JSON.parse(item.signConfig)
              : item.signConfig;
            configObj = this.setDataSignConfig(parsed);
          } else {
            configObj = {
              resize: false,
              showImage: item.isSignDigitalCertificate
                ? true
                :  false
            };
          }
          return {
            ...item,
            signConfig: JSON.stringify(configObj)
          };
        });

        this.listSign = this.listSign.map(item => {
          let configObj;
          if (item.signConfig) {
            const parsed = typeof item.signConfig === 'string'
              ? JSON.parse(item.signConfig)
              : item.signConfig;
            configObj = this.setDataSignConfig(parsed);
          } else {
            configObj = {
              resize: false,
              showImage: item.isSignDigitalCertificate
                ? true
                :false
            };
          }
          return {
            ...item,
            signConfig: JSON.stringify(configObj)
          };
        });
          const formContract = {
            id: controls.id.value,
            code: controls.docCode.value,
            name: controls.docName.value,
            lstReferenceContractId: listParentId,
            enterpriseSign:this.RECORD_PARTY_SIGN,
            enterpriseId: localStorage.getItem('enterpriseId'),
            effectiveDate: controls.effectiveDate.value || null,
            expiredDate: controls.expirationDate.value || null,
            contractMohaFields: this.isAppendix ? [] : this.createContractMohaService.contractMohaFields,
            serviceType: controls.docType.value,
            description: controls.description.value,
            allowReferenceCustomerView: controls.allowReferenceCustomerView.value,
            newFileAttachmentOrders: this.newFileAttachmentOrders,
            customerMohaId : this.createContractMohaService.customerMohaId,
            userSign: this.userSigns,
            mainContractAttachments: this.mainContractAttachments,
            signPositions: this.listSign,
            editProperty: this.isAppendix ? controls.editProperty.value : null,
            originalContractId: this.isAppendix ? this.originalContractId : null,
            contractMohaUpdateFields: this.isAppendix
            ? (this.createContractMohaService.contractMohaUpdateFields || [])
            .map(f => ({ key: f.key, value: f.value == null ? null : String(f.value) }))
            : [],
            };
          if (this.contractId !== '') {
            formContract['listFileDelete'] = controls.listFileDelete.value;
            // formContract['contractAttachments'] = controls.contractAttachments.value;

            let contractAttachmentsNew = [];

            this.filesNameHaveOrder.forEach((fileNameHaveOrder) => {
              controls.contractAttachments.value.forEach((contractAttachment) => {
                if(fileNameHaveOrder.fileName === contractAttachment.fileName) {
                  contractAttachmentsNew.push({
                    ...contractAttachment,
                    attachmentOrder: fileNameHaveOrder.order
                  })
                }
              })
            });
            const listAttachments = [...contractAttachmentsNew];
            listAttachments.forEach(ele =>{
              delete ele.idDecrypt;
            });
            formContract['contractAttachments'] = listAttachments;
            formContract['newFileOrders'] = [...this.newFileOrders];

            this.handleCreateContract(false ,formContract, isSign, controls);
          } else {
            this.handleCreateContract(true ,formContract, isSign, controls);
          }

        } else if (this.filesUpload.length === 0 && contractAttachments.length === 0) {
          this.toastr.error(this.message.getMessage('digital_contract.error.no_file_selected'));
        }
      }
      else {
        this.toastr.error(backupStatus.message)
        this.createContractMohaService.firstUpdate = true;
        this.router.navigateByUrl('/home-enterprise/contract-digitzation-moha');
      }
    })

  }

  updateContract(formContract : any, isSign : boolean){
    this.digitalContractService.updateContractMoha(JSON.stringify(formContract), this.filesUpload, this.filesAttachment)
              .subscribe(result => {
                if (result.data && result.success) {
                  this.createContractMohaService.effectiveDate = null;
                  this.createContractMohaService.expirationDate = null;
                  this.createContractMohaService.effectiveDateKeep = null;
                  this.createContractMohaService.expirationDateKeep = null;
                  this.createContractMohaService.updateDateKeep = true;
                  localStorage.setItem('saveContract', 'true');
                  this.createContractMohaService.firstUpdate = true;
                  if(isSign){
                    // this.createContractMohaService.contractMohaFields = null;
                    //this.createContractMohaService.saveStep3.next(false);

                    this.signFlowDetail();

                    //this.router.navigate([`/home-enterprise/sign-digital-flow/${this.contractId}`], {queryParams: {goFrom: 'digitalMyEmployment'}})
                  } else {
                    this.toastr.success(this.message.getMessage('messages.update_success'));
                    // this.createContractMohaService.contractMohaFields = null;
                    //this.createContractMohaService.saveStep3.next(false);
                    this.router.navigateByUrl('/home-enterprise/contract-digitzation-moha');
                  }
                  //this.createContractMohaService.saveStep3.next(false);
                  // this.createContractMohaService.contractMohaFields = null;
                } else if (result.code === ErrorCode.ActiveContract1) {
                  this.toastr.error(result.message);
                  this.mainFormAdd.controls.docCode.setErrors({matched: true});
                } else if(result.code === ErrorCode.MaxSizeError){
                  this.maxSize = result.data > 0 ? result.data : 10*1024*1024;
                  this.toastr.error(result.message);
                  this.mesage = this.message.getMessage('validation.validate_file_type_file_size_config').replace('{0}', String(Math.floor(this.maxPerMainFile / 1024 / 1024)))
                } else {
                  this.toastr.error(result.message);
                }
              });
  }

  createContract(formContract : any, isSign : boolean,controls : any){
            this.digitalContractService.effectiveDateNewContract.next(null);
            console.log(this.filesUpload);
            formContract['newFileOrders'] = [...this.newFileOrders];

            console.log('userSigns trước khi gửi:', JSON.parse(JSON.stringify(this.userSigns)));
            this.digitalContractService.createContractMoha(JSON.stringify(formContract), this.filesUpload, this.filesAttachment)
              .subscribe(result => {
                if (result.data && result.success) {
                  this.createContractMohaService.effectiveDate = null;
                  this.createContractMohaService.expirationDate = null;
                  this.createContractMohaService.effectiveDateKeep = null;
                  this.createContractMohaService.expirationDateKeep = null;
                  this.createContractMohaService.updateDateKeep = true;
                  localStorage.setItem('saveContract', 'true')
                  this.createContractMohaService.firstUpdate = true;
                  this.digitalContractService.effectiveDateNewContract.next(controls.effectiveDate.value);
                  if(isSign){

                    const data = {} as DocumentEntity;
                    data.id = result.data;
                    data.name = this.mainFormAdd.controls.docName.value;

                        this.signFlowDetail(data);
                    //this.router.navigate([`/home-enterprise/sign-digital-flow/${result.data}`], {queryParams: {goFrom: 'digitalMyEmployment'}})
                  } else {
                    //this.createContractMohaService.saveStep3.next(false);
                    // this.createContractMohaService.contractMohaFields = null;
                    this.toastr.success(this.message.getMessage('messages.add_success'));
                    this.router.navigateByUrl('/home-enterprise/contract-digitzation-moha');
                  }
                  //this.createContractMohaService.saveStep3.next(false);
                  // this.createContractMohaService.contractMohaFields = null;
                } else if (result.code === ErrorCode.ActiveContract1) {
                  this.toastr.error(result.message);
                  this.mainFormAdd.controls.docCode.setErrors({matched: true});
                } else if(result.code === ErrorCode.MaxSizeError){
                  this.maxSize = result.data > 0 ? result.data : 10*1024*1024;
                  this.toastr.error(this.message.getMessage('validation.digital_file').replace('{0}', String(Math.floor(this.maxSize / 1024 / 1024))));
                  this.mesage = this.message.getMessage('validation.validate_file_type_file_size_config').replace('{0}', String(Math.floor(this.maxPerMainFile / 1024 / 1024)))
                } else {
                  this.toastr.error(result.message);
                }
              });
  }

  cancelAdd() {
    this.digitalContractService.effectiveDateNewContract.next(null);
    this.createContractMohaService.effectiveDate = null;
    this.createContractMohaService.expirationDate = null;
    this.createContractMohaService.effectiveDateKeep = null;
    this.createContractMohaService.expirationDateKeep = null;
    this.createContractMohaService.updateDateKeep = true;
    this.digitalContractService.isSearch.next(null);
    if (this.mainFormAdd.dirty) {
      const dialog = this.dialog.open(WarningComponent, {
        data: this.message.getMessage('messages.config_is_change'),
        width: '27vw'
      });
      dialog.afterClosed().subscribe(ref => {
        if (ref) {
          if (!window.history.length) {
            this.blockUI.start();
            this.createContractMohaService.firstUpdate = true;
            this.router.navigateByUrl('/home-enterprise/contract-digitzation-moha');
          } else {
            this.blockUI.start();
            this.location.back();
          }
        }
      });
      return;
    }
    if (!window.history.length) {
      this.createContractMohaService.firstUpdate = true;
      this.blockUI.start();
      this.router.navigateByUrl('/home-enterprise/contract-digitzation-moha');
    } else {
      this.blockUI.start();
      this.location.back();
    }
  }

  backTab(){
    this.createContractMohaService.effectiveDate = null;
    this.createContractMohaService.expirationDate = null;
    // this.createContractMohaService.effectiveDateKeep = null;
    // this.createContractMohaService.expirationDateKeep = null;
    this.createContractMohaService.firstUpdate = true;
    const url = this.router.url
    if(this.router.url.includes('create')){
      this.createContractMohaService.customerMohaId = null;
    }
    console.log("this.createContractMohaService.customerMohaId: "+ this.createContractMohaService.customerMohaId);
    this.showInfo = false;
  }

  changeFile(index: number) {
    this.pageIndex = 1;
    this.pdfSrc = this.filesSrc[index];
    this.activeFile = index;
  }

  removeFile(index: number) {
    if (this.contractId) {
      const oldFiles = this.mainFormAdd.controls.contractAttachments.value;
      const fileDeletes = this.mainFormAdd.controls.listFileDelete.value;
      if (index > oldFiles.length - 1) {
        this.mainFiles.splice(index - oldFiles.length, 1);
      } else {
        const fileDelete = oldFiles.splice(index, 1);
        this.mainFormAdd.controls.contractAttachments.patchValue(oldFiles);
        fileDeletes.push(fileDelete[0]);
        this.mainFormAdd.controls.listFileDelete.patchValue(fileDeletes);
        this.mainFiles.splice(index, 1);
      }
    } else {
      this.mainFiles.splice(index, 1);
    }
    this.filesName.splice(index, 1);
    this.filesUpload.splice(index, 1);

    this.filesNameHaveOrder = [...this.filesName.map((fileName, index) => ({
      order: index,
      fileName: fileName
    }))];

    this.newFileOrders = [...[]];
    this.filesNameHaveOrder.forEach((fileNameHaveOrder) => {
      this.mainFiles.forEach((fileUpload) => {
        if(fileNameHaveOrder.fileName === fileUpload.name) {
          this.newFileOrders.push(fileNameHaveOrder.order)
        }
      });
    });
    const fileOld = this.contractId ? this.mainFormAdd.controls['contractAttachments'].value : []
    //this.mainFiles = [...this.mainFiles]

    const newListSign = [];
    this.listSign.forEach(sign => {
      let exists = false;

      this.mainFiles.forEach(mainFile => {
        if (mainFile.fileName === sign.fileName || mainFile.name === sign.fileName) {
          exists = true;
        }
      });

      if (exists) {
        newListSign.push(sign);
      }
    });

    this.listSign = newListSign;

    this.filesSrc.splice(index, 1);
    if (this.activeFile === index) {
      this.pdfSrc = this.filesSrc[0];
      this.activeFile = 0;
    } else if (this.activeFile > index) {
      this.activeFile -= 1;
    }
    this.pdfSrc = this.filesSrc[this.activeFile];
    if (this.filesSrc.length === 0) {
      this.pdfSrc = null;
    }
  }

  async initData(id: string) {
    if (this.mode === 'view') {
      this.isViewFull = true;
    }
    this.blockUI.start();
    this.digitalContractService.getContractMohaById(id).subscribe(async res => {
      if (res.data && res.success) {
        this.document = res.data;
        if (res.data.formType === 'CONTRACT_APPENDIX') {
          await this.initAppendixForUpdateOrView(res.data);
        }
        this.checkViewAuthenStatus();
        if(res.data.contractMohaFields){
          this.mappingDataMFFormService(res.data.contractMohaFields,'ADD');
        }
        if (res.data.contractEnterprise) {
          const enterprises = res.data.contractEnterprise;

          if (Array.isArray(enterprises) && enterprises.length > 0) {
            await forkJoin(
              enterprises.map(element =>
                this.customerService.getCustomer(element.customerId).pipe(
                  tap(rs => element.customerType = rs.data.customerType)
                )
              )
            ).toPromise();
          }
          this.contractEnterpriseList = res.data.contractEnterprise;
        }

          if(res.data.customerMohaId){
               this.createContractMohaService.customerMohaId= res.data.customerMohaId;
               this.createContractMohaService.idCustomerDefault = this.createContractMohaService.customerMohaId;
              }

          this.getDataUpdate(res.data);
          if (res.data.formType !== 'CONTRACT_APPENDIX') {
              this.getListVersionHistory(res.data.id);
          }    

        const data = res.data;
        this.updateViewBreadcrumb(data);
        this.createContractMohaService.contractMohaFields = data.contractMohaFields;
        const objectServiceType = this.serviceTypes.find(item => item.id == data.serviceType);
        this.createContractMohaService.selectedServiceType.next(objectServiceType);
        if(objectServiceType && objectServiceType.employmentContractTerm){
         this.mainFormAdd.controls['docContractType'].setValue(
         objectServiceType.employmentContractTerm == 'LIMITED'
          ? 'button.limit_contract'
          : 'button.unlimit_contract')
         }

        this.isOnAutoNumber = objectServiceType.isOnAutoNumber;
        if (this.isOnAutoNumber) {
        this.mainFormAdd.controls['docCode'].setValue('');
        this.mainFormAdd.controls['docCode'].disable();
        } else {
        this.mainFormAdd.controls['docCode'].enable();
        }

        if (data.parentId) {
          this.parentSelected.patchValue(data.parentCode + ' - ' + data.parentName);
          this.affiliateContract.push({code: data.parentCode, name: data.parentName, id: data.parentId});
        } else if (this.mode !== 'create') {
          this.affiliateContract = [{code: data.parentCode, name: data.parentName, id: data.parentId}]
        }
        const serviceType = this.docType.filter(type => type.id === data.serviceType)
        const attachments = res.data.contractAttachments.filter(item => item.AttachmentType == 40000);
        this.docInfos = res.data.contractAttachments.filter(item => item.AttachmentType == 40000);
        this.filesAttachment = res.data.contractAttachments.filter(item => item.AttachmentType !== 40000);
        this.filesAttachmentOld = res.data.contractAttachments.filter(item => item.AttachmentType !== 40000);
        this.contractStatus = res.data.status;
        this.contractSignStatus = Array.isArray(res.data.contractSignStatus) ? res.data.contractSignStatus : [];
        this.mohaConfirmStatus = res.data.mohaConfirmStatus;
        this.isContractCreator = res.data.isCreator;
        this.mohaStatus = res.data.mohaStatus;
        this.idMoha = res.data.idMoha ? res.data.idMoha : "";
        this.contractMohaErrorDescription = res.data.contractMohaErrorDescription ? res.data.contractMohaErrorDescription : "";
        this.messageAuthenCode = res.data.messageAuthenCode ? res.data.messageAuthenCode : "";
        this.messageAuthenDate = res.data.messageAuthenDate ? res.data.messageAuthenDate : "";    
        this.mainFiles = res.data.contractAttachments.filter(item => item.AttachmentType == 40000)
        if(res.data.contractEnterpriseCreated){
          this.contractEnterpriseCreated = [{
            ...res.data.contractEnterpriseCreated,
            signMetadata: res.data.contractEnterpriseCreated.signMetadata ? JSON.parse(res.data.contractEnterpriseCreated.signMetadata) : {}
          }]
        }

        this.dataDocumentParent = res.data.parents;
        this.mainFormAdd.controls.checkParent.setValue(JSON.stringify(res.data.parents));
        const listUser = [];
        if(res.data.contractEnterprise && res.data.contractEnterprise.length > 0){
          res.data.contractEnterprise.forEach(ele =>{
            listUser.push({
              enterpriseId: ele.enterpriseId || "",
              order: ele.order|| "",
              email: ele.enterpriseEmail|| "",
              enterpriseName: "",
              phone: ele.enterprisePhone || "",
              status: 1,
              isCreatedSide: ele.createdSide || "",
              customerId: ele.customerId || "",
              customerCode:ele.customerCode || "",
              name: ele.enterpriseName || "",
              certificateNo: ele.certificateNo || "",
              useDataForTemplate: false,
              isSignNoLogin: ele.isSignNoLogin || "",
              signConfig: ele.signConfig || "",
              customerType : ele.customerType})
          })
        }

        if (res.data.userSign && res.data.userSign.length > 0) {
          res.data.userSign.forEach(ele => {
            this.userSigns.push({
              order: ele.order || "",
              userId: ele.userId || "",
              enterpriseId: ele.enterpriseId || "",
              enterpriseSignId: ele.enterpriseSignId || "",
              name: ele.name || "",
              userName: ele.userName || "",
              phone: ele.phone || "",
              userPhone: ele.userPhone || "",
              email: ele.email || "",
              userEmail: ele.userEmail || "",
              role: ele.role || "",
              isCreatedSide: ele.isCreatedSide || false,
              departmentName: ele.departmentName || null,
              departmentId: ele.departmentId || null,
              isSignDigitalCertificate: ele.isSignDigitalCertificate || false,
              signConfig: ele.signConfig ? JSON.parse(ele.signConfig) : {},
              userPosition: ele.userPosition || "",
              createdBy: ele.createdBy || "",
              status: ele.status != null ? ele.status : 1,
              contractUserId: ele.contractUserId || ""
            })
          })
        }

        if (res.data.signPositions && res.data.signPositions.length > 0) {
          res.data.signPositions.forEach(ele => {
            this.listSign.push({
              //order: ele.order || "",
              userId: ele.userId || "",
              enterpriseId: ele.enterpriseId || "",
              enterpriseSignId: ele.enterpriseSignId || "",
              name: ele.name || "",
              userName: ele.userName || "",
              phone: ele.phone || "",
              userPhone: ele.userPhone || "",
              email: ele.email || "",
              userEmail: ele.userEmail || "",
              //role: ele.role || "",
              isCreatedSide: ele.isCreatedSide || false,
              departmentName: ele.departmentName || null,
              departmentId: ele.departmentId || null,
              isSignDigitalCertificate: ele.isSignDigitalCertificate || false,
              signConfig: ele.signConfig ? JSON.parse(ele.signConfig) : {},
              userPosition: ele.userPosition || "",
              createdBy: ele.createdBy || "",
              status: ele.status != null ? ele.status : 1,
              contractUserId: ele.contractUserId || "",
              idNumber: ele.idNumber || "",
              row_number: ele.row_number || "",
              stampPositionLeft: ele.stampPositionLeft || 0,
              stampPositionTop: ele.stampPositionTop || 0,
              x: ele.x || 0,
              y: ele.y || 0,
              pageNumber: ele.pageNumber || "",
              pageIndex: ele.pageNumber || "",
              zoom: ele.zoom || 1,
              pdfSrc: ele.pdfSrc || {},
              width: ele.width || 0,
              height: ele.height || 0,
              fileId: ele.fileId || "",
              contractSignId: ele.contractSignId || null,
              isDelete: false,
              fileName: ele.fileName,
              isNewUpload: false
            })
          })
        }
        this.changeDataToTable();
        this.RECORD_PARTY_SIGN = listUser;
        this.createContractMohaService.recordsPartySign.next(listUser);
        this.createContractMohaService.prevStep.next(1);
        this.createContractMohaService.createContractType.next(1);
        this.mainFormAdd.controls.checkUser.setValue(JSON.stringify(listUser));
        const formatWay = this.mode === 'view' ? 'DD/MM/YYYY' : null;
        this.mainFormAdd.patchValue({
          id,
          docType: this.mode === 'view' ? serviceType[0].name : data.serviceType,
          docParent: null,
          docName: data.name,
          docCode: data.code,
          effectiveDate: data.effectiveDate ? new Date(data.effectiveDate) : null,
          expirationDate: data.expiredDate ? new Date(data.expiredDate) : null,
          description: data.description,
          allowReferenceCustomerView: data.allowReferenceCustomerView,
          editProperty: data.editProperty
        });
        // debugger
        if (attachments.length > 0) {
          for (let file of attachments) {
            this.filesName.push(this.checkmatched(this.filesName, file.fileName));
            this.filesNameHaveOrder = [...this.filesName.map((fileName, index) => ({
              order: index,
              fileName: fileName
            }))];
            const type = file.fileName.split('.').pop();
            if (type === 'pdf') {
              const pdfSrc = await this.viewDocumentUpload(file.id, file.fileName, file.fileSize);
              this.filesSrc.push(pdfSrc);
              this.pdfSrc = this.filesSrc[0];
            } else {
              this.filesSrc.push('notPDF');
              this.pdfSrc = this.filesSrc[0];
            }
          }
        }


        if (this.mainFormAdd.controls.docParent.value) {
          this.mainFormAdd.controls.docType.disable();
        }

        this.mainFormAdd.addControl('contractAttachments', new FormControl(data.contractAttachments.filter(item => item.AttachmentType == 40000)));
        this.mainFormAdd.addControl('listFileDelete', new FormControl([]));
      } else {
        this.toastr.error(res.message);
        this.router.navigateByUrl('/home-enterprise/contract-digitzation-moha');
        this.blockUI.stop();
      }
      this.checkPermissionNewFlow();
      this.blockUI.stop();
    });
    this.blockUI.stop();
  }

  private updateViewBreadcrumb(data: any) {
    if (this.mode !== 'view' || !data) {
      return;
    }

    this.breadcrumbsService.store([
      {label: 'breadcrumbs.home', url: 'analysis-report', params: [], highlight: false},
      {label: 'breadcrumbs.my_contracts', url: '', params: [], highlight: false},
      {label: 'breadcrumbs.document_moha', url: 'contract-digitzation-moha', params: [], highlight: false},
      {
        label: this.message.getMessage('breadcrumbs.document_digitization_view_moha') + (data.name ? ' ' + data.name : ''),
        url: `contract-digitzation-moha/${this.contractId}/view`,
        params: [],
        highlight: false
      }
    ]);
  }

  public viewDocumentReference(res) {
  // public getParentDocumentById() {
      this.documentService.getDocumentById(res.id).subscribe(rs => {
        if(!rs.success){
          this.toastr.error(rs.message);
        }
        else {
          this.selectedDocumentTypeParent = {
            id: rs.data.contractDTO.id,
            name: rs.data.contractDTO.name,
            code: rs.data.contractDTO.code,
            filePath: rs.data.contractDTO.filePath
          };
          const data: ViewDocumentReferenceDto = {
            mainContractId: null,
            referenceContractId: res.id,
            pdfFilePath: this.selectedDocumentTypeParent.filePath
          };
          this.isViewParentContract = true;
          if (this.selectedDocumentTypeParent && this.selectedDocumentTypeParent.id) {
            const dialogRef = this.dialog.open(ViewDocumentReferenceComponent, {
              width: '90%',
              minHeight: '90%',
              data,
            });
            dialogRef.afterClosed().subscribe(rs => {
              this.isViewParentContract = false;
            });
          } else {
            if (!this.toastr.findDuplicate(this.message.getMessage('messages.not_documentId'), true, true)) {
              this.toastr.error(this.message.getMessage('messages.not_documentId'));
            }
          }
        }
      });
    // }

  }

  hasRequiredValidator(controlName: string): boolean {
    const control = this.mainFormAdd.get(controlName);
    if (!control || !control.validator) return false;

    const validator = control.validator({} as AbstractControl);
    return validator && validator['required'];
}

  viewContract(ala,data?) {
    if(ala.typeId == 2){
      this.blockUI.start();
      this.digitalContractService.getContractMohaById(ala.id).subscribe(async res => {
        if (res.data && res.success) {
          this.contractView.contractName = res.data.code + ' - ' + res.data.name;
          const attachments = res.data.contractAttachments;
          if (attachments.length > 0) {
            this.blockUI.start();
            const nameList = [];
            const idList = [];
            const listFileSize = [];

            for (let file of attachments) {
              nameList.push(this.checkmatched(nameList, file.fileName));
              idList.push(file.id)
              listFileSize.push(file.fileSize)
              console.log(file, 'file file');
              if (idList.length === attachments.length) {
                this.blockUI.stop();
              }
            }
            this.contractView.filesName = nameList;
            this.contractView.id = idList;
            this.contractView.listFileSize = listFileSize;
            this.isViewParentContract = true;
            this.contractView.idDocument = ala.id;
            this.contractView.attachments = attachments;
            if(data){
              this.contractView.checkMan = data;
            }
            const dialog = this.dialog.open(ViewContractComponent, {
              data: this.contractView,
              width: '90%',
              minHeight: '90%'
            });
            dialog.afterClosed().subscribe(res => {
              this.isViewParentContract = false;
            })
            // this.blockUI.stop();

          }
        } else {
          this.toastr.error(res.message);
        }
      });
      this.blockUI.stop();

    }
    else{
      this.viewDocumentReference(ala);
    }

  }

  async viewDocumentUpload(id, fileName, size?) {
    let pdfSrc;
    if (!this.env.pdfViewFullDownload && size && size > LIMIT_SIZE) {
      pdfSrc = `${this.BASE_URL}/${id}`;
    } else {
      const res = await this.digitalContractService.getContractFiles(id).toPromise();
      pdfSrc = await this.showPdf(res, fileName);
    }
    return pdfSrc;
  }

  public blobToFile = (theBlob: Blob, fileName: string): File => {
    const b: any = theBlob;
    // A Blob() is almost a File() - it's just missing the two properties below which we will add
    b.lastModifiedDate = new Date();
    b.name = fileName;

    // Cast to a File() type
    return theBlob as File;
  };

  async showPdf(blob: any, fileName: string) {
    const file = this.blobToFile(blob, fileName);
    const pdfSrc = await this.commonService.readFileAsync(file);
    this.listPdfSrc[fileName] = pdfSrc;
    return pdfSrc;
  }

  downloadContract() {
    this.digitalContractService.downloadContractFail(this.contractId).subscribe(error => {
      if (error.success === false) {
        this.toastr.error(error.message);
        return;
      }
      if (error) {
        this.digitalContractService.downloadContract(this.contractId).subscribe(res => {
          if (window.top.navigator.msSaveOrOpenBlob) {
            // Store Blob in IE
            window.top.navigator.msSaveOrOpenBlob(res, this.mainFormAdd.controls.docName.value + '.zip');
          } else {
            // Store Blob in others
            const tA = document.body.appendChild(document.createElement('a'));
            tA.href = window.URL.createObjectURL(res);
            tA.download = this.mainFormAdd.controls.docCode.value + ' - ' + this.mainFormAdd.controls.docName.value + '.zip';
            tA.style.display = 'none';
            tA.click();
            tA.parentNode.removeChild(tA);
          }
        });
      }
    })
  }

  someMethod(e) {}

  moveToUpdate() {
    this.router.navigateByUrl(`/home-enterprise/contract-digitzation-moha/${this.contractId}/update`);
  }


  selectedChange(event) {
    // if(this.configAutoNumber){
    //   this.document.code = this.configAutoNumber;
    // }
    this.createContractMohaService.exampleContractCodeAutoNumber.next('');
    const objectServiceType = this.serviceTypes.find(item => item.id == event.value);
    this.createContractMohaService.selectedServiceType.next(objectServiceType);
    this.isOnAutoNumber = objectServiceType.isOnAutoNumber;
    if (this.isOnAutoNumber) {
      this.mainFormAdd.controls['docCode'].setValue('');
      this.mainFormAdd.controls['docCode'].disable();
    } else {
      this.mainFormAdd.controls['docCode'].enable();
    }
    if(objectServiceType && objectServiceType.employmentContractTerm){
      //this.document.employmentContractTerm = objectServiceType.employmentContractTerm
      this.mainFormAdd.controls['docContractType'].setValue(
        objectServiceType.employmentContractTerm == 'LIMITED'
          ? 'button.limit_contract'
          : 'button.unlimit_contract'
      );
      // Trong selectedChange(), sau khi setValue docContractType
      if (objectServiceType.employmentContractTerm === 'LIMITED') {
        this.mainFormAdd.controls['expirationDate'].setValidators([Validators.required]);
      } else {
      this.mainFormAdd.controls['expirationDate'].clearValidators();
      }
this.mainFormAdd.controls['expirationDate'].updateValueAndValidity();
      this.createContractMohaService.employmentContractTerm.next(objectServiceType.employmentContractTerm)
    }
    // if(objectServiceType){
    //   this.isOnAutoNumber = objectServiceType.isOnAutoNumber;
    // }
    if (objectServiceType && objectServiceType.isOnAutoNumber) {
      if (!this.configAutoNumber) {
        if (this.document.code && this.isUpdate) {
          this.createContractMohaService.configAutoNumber.next(this.document.code);
        } else {
          this.createContractMohaService.configAutoNumber.next(this.commonService.convertConfigAutoNumber(objectServiceType.configAutoNumber));
        }
      }
      if (!this.isUpdate) {
        this.document.code = '';
        this.createContractMohaService.configAutoNumber.next(this.commonService.convertConfigAutoNumber(objectServiceType.configAutoNumber));
      }
      else if (this.isUpdate) {
        //cap nhat doi loai thi quay ve ma ban dau
        if(this.configAutoNumber) {
          this.document.code = this.configAutoNumber;
        }
        if(this.document.backUpCode) {
          this.document.code = this.document.backUpCode;
        }
      }
    } else {
      if (!this.isUpdate) {
        this.createContractMohaService.configAutoNumber.next('');
      }
    }
    if(this.document &&this.document.code && this.isUpdate){
      this.createContractMohaService.configAutoNumber.next(this.document.code);
    }
    this.checkFocus = false;
    this.createContractMohaService.isInvalidFieldTypeContract.next(false);
    this.createContractMohaService.isOnAutoNumber.next(this.isOnAutoNumber);
  }

  async doPrint() {

    this.isLoading = true;
    this.nzCheckLoadingParty1 = true;
    const currentFrame = document.getElementById('sample-iframe');
    if(currentFrame){
      currentFrame.remove()
    }

    if(this.isString(this.pdfSrc)){
      if(this.pdfSrc =='notPDF'){
        this.toastr.error(this.translateService.instant('messages.notPdf'))
        return
      }else if(this.pdfSrc.includes('view/digital/view-file')&&this.docInfos[this.activeFile].fileSize > LIMIT_SIZE){
        this.callApiWaterMark();
        return
      }
    }

     if(this.pdfSrc.byteLength == undefined||this.pdfSrc.byteLength == 0){
      this.toastr.error(this.translateService.instant('messages.errorPdf'))
      return
    }

      this.pdfSrc = this.filesSrc[this.activeFile];
      const buffer = this.pdfSrc;
      const blob = new Blob([buffer], {
        type: 'application/pdf'
      });
      const objectURL = URL.createObjectURL(blob);

      // Create an iframe to demonstrate it:
      const iframe = document.createElement('iframe');
      iframe.id = 'sample-iframe';
      iframe.src = objectURL;
      document.body.appendChild(iframe);
      iframe.contentWindow.print();
      this.isLoading = false;
    this.nzCheckLoadingParty1 = false;
      iframe.hidden = true

  }

  async callApiWaterMark(){
    const currentFrame = document.getElementById('sample-iframe');
    if(currentFrame){
      currentFrame.remove()
    }

    let a = this.mainFormAdd.value.contractAttachments[this.activeFile].id

   await this.documentService.getDocWithWaterMarkV2(this.contractId,a).subscribe( async (response: any) => {
      if(await response){
        this.markPdf =  await this.commonService.readFileAsync(response);
      }
      // Create the Blob URL:
      const buffer = this.markPdf;
      const blob = new Blob([buffer], {
        type: 'application/pdf'
      });
      const objectURL = URL.createObjectURL(blob);

      // Create an iframe to demonstrate it:
      const iframe = document.createElement('iframe');
      iframe.id = 'sample-iframe';
      iframe.src = objectURL;
      document.body.appendChild(iframe);
      iframe.contentWindow.print();
      iframe.hidden = true
    },(error:HttpErrorResponse)=>{
      this.toastr.error(this.translateService.instant('messages.notGetPdf'))
    });
  }

   isString(value) {
    return typeof value === "string";
  }

  drop(event: CdkDragDrop<string[]>) {
    let arraySrcBeforeMoveFile = [...[]];
    let arraySrcAfterMoveFile = [...[]];
    let filesUploadNew = [...[]];
    let mainFiles = [...[]];

    this.filesName.forEach((fileName, indexFileName) => {
      this.filesSrc.forEach((fileSrc, indexFileSrc) => {
        if(indexFileName === indexFileSrc) {
          arraySrcBeforeMoveFile.push({
            src: fileSrc,
            fileName: fileName
          });
        }
      })
    });
    const checkIndexFile = !!(this.activeFile === event.previousIndex);
    const activeFileOld = this.activeFile;

    moveItemInArray(this.filesName, event.previousIndex, event.currentIndex);
    // moveItemInArray(this.mainFiles, event.previousIndex, event.currentIndex);
    if(this.activeFile === event.previousIndex) {
      this.activeFile = event.currentIndex;
    } else if(event.previousIndex > this.activeFile && event.currentIndex <= this.activeFile) {
      this.activeFile = this.activeFile + 1;
    } else if(event.previousIndex < this.activeFile && event.currentIndex >= this.activeFile) {
      this.activeFile = this.activeFile - 1;
    } else {
      console.log(this.filesName);
    }

    this.filesNameHaveOrder = [...this.filesName.map((fileName, index) => ({
      order: index,
      fileName: fileName
    }))];

    this.filesName.forEach((fileName) => {
      this.filesUpload.forEach((fileUpload) => {
        if(fileName === fileUpload.name) {
          filesUploadNew.push(fileUpload);
        }
      })
    });
    this.filesName.forEach((fileName) => {
      this.mainFiles.forEach((fileMain) => {
        if(fileName === fileMain.name || fileName === fileMain.fileName) {
          mainFiles.push(fileMain);
        }
      });
    })

    this.mainFiles = mainFiles;
    for (let i=1; i <= this.maxPageCurrent; i++) {
      // console.log(`text-pdf-layer-${i}-${checkIndexFile ? event.previousIndex : this.activeFile}`)
      const element: any = document.getElementById(`text-pdf-layer-${i}-${checkIndexFile ? event.previousIndex : activeFileOld}`);
      if (element) {
        element.setAttribute('id', `text-pdf-layer-${i}-${this.activeFile}`);
      }
    }

    this.filesName.forEach((fileName) => {
      arraySrcBeforeMoveFile.forEach((fileSrc) => {
        if(fileName === fileSrc.fileName) {
          arraySrcAfterMoveFile.push(fileSrc.src);
        }
      })
    });

    this.newFileOrders = [...[]];
    this.filesNameHaveOrder.forEach((fileNameHaveOrder2) => {
      this.filesUpload.forEach((fileUpload2) => {
        if(fileNameHaveOrder2.fileName === fileUpload2.name) {
          this.newFileOrders.push(fileNameHaveOrder2.order);
        }
      });
    });

    if(this.contractId) {
      this.filesNameHaveOrder.forEach((fileNameHaveOrder) => {
        this.docInfos.forEach((contractAttachment) => {
          if(fileNameHaveOrder.fileName === contractAttachment.fileName) {
            this.contractAttachmentsNew.push({
              ...contractAttachment,
              attachmentOrder: fileNameHaveOrder.order
            });
          }
        })
      });
    }

    this.filesUpload = [...filesUploadNew];
    this.filesSrc = [...arraySrcAfterMoveFile];
    // this.changeFile(this.activeFile);
  }



  checkDisplayBtnAddCustomer() {
    if(this.isDefaultAdmin) {
      return true;
    }
    if(this.permissions.includes(401) || this.permissions.includes(4)) {
      return true;
    }
    return false;
  }

  changeFileAttachment(event){
    if(event && event.length > 0){
      this.filesAttachment = event
    }
  }

  deleteFileAttachment(event){
    if(event){
      const fileDeletes = this.mainFormAdd.controls.listFileDelete.value;
      fileDeletes.push(event)
      this.mainFormAdd.controls.listFileDelete.patchValue(fileDeletes);
    }
  }

  downloadFile(id, name) {
    this.commonService.downloadDocumentFile(id,'?type=DIGITAL').subscribe(rs => {
      this.downLoadFile(rs, 'application/octet-stream', name);
    });
  }

  /**
   * Method is use to download file.
   * @param data - Array Buffer data
   * @param type - type of the document.
   * @param fileName - file name of file
   */
  downLoadFile(data: any, type: string, fileName: string) {
    const blob = new Blob([data], {type});
    if (window.top.navigator.msSaveOrOpenBlob) {
      // Store Blob in IE
      window.top.navigator.msSaveOrOpenBlob(blob, fileName);
    } else {
      // Store Blob in others
      const tA = document.body.appendChild(document.createElement('a'));
      tA.href = URL.createObjectURL(blob);
      tA.download = fileName;
      tA.style.display = 'none';
      tA.click();
      tA.parentNode.removeChild(tA);
    }
  }

  mappingDataMFFormService(dataMF: any, type: string = 'ADD') {
    if (dataMF && Array.isArray(dataMF) && dataMF.length) {
      dataMF.forEach((mfData: any) => {
        if (type === 'ADD') {
          let existIdx = this.listDataSource.findIndex((row: any) => row.code == mfData.key);
          if (existIdx >= 0 && this.listDataSource[existIdx].controlField) {
            if (mfData.value) this.listDataSource[existIdx].controlField.patchValue(mfData.value);
          }
        } else {
          let existIdx = this.listDataUpdateSource.findIndex((row: any) => row.code == mfData.key);
          if (existIdx >= 0 && this.listDataUpdateSource[existIdx].controlField) {
            if (mfData.value) this.listDataUpdateSource[existIdx].controlField.patchValue(mfData.value);
          }
        }
      });
    }
  }

  goToSign(){
    this.documentMohaService.checkMessageAuthen(this.document.id).subscribe(res => {
      if (!res.success) {
        this.toastr.error(res.message);
        return;
      }else{
        this.router.navigate([`/home-enterprise/sign-document-digital/${this.contractId}`], {queryParams: {goFrom: 'waitSignDigital'}})
      }
    });
  }

   // Hàm tìm kiếm người dùng ký duyệt
   onChangeUserSignSearch(event): void {
    this.setFormChanging();
    if (event.target.value.trim().length > 0) {
      this.nzCheckLoadingUserSign = true;
      this.autoUserService.fetchAutoDepartment(this.inputUserValue.trim())
        .then(result => {
          if (this.inputUserValue.trim().length > 0) {
            this.filteredUserOptions = result.sort(function (a, b) {
              return a.type.localeCompare(b.type)
            });
          } else {
            this.filteredUserOptions = [];
          }
        }).finally(() => {
          this.nzCheckLoadingUserSign = false;
        });
    } else {
      this.inputUserValue = '';
      this.filteredUserOptions = [];
    }
  }

  checkPermissionNewFlow() {
    // Nếu là người lập và trạng thái là PROCESSING (2) hoặc WAIT_CONFIRM_ENTERPRISE_NO_MOIT (9) thì hiển thị button Hủy luòng
    if (this.document.createdBy == this.userId && (this.document.status == EnumContractStatus.PROCESSING || this.document.status == EnumContractStatus.WAIT_CONFIRM_ENTERPRISE_NO_MOIT)) {
      this.isCancelDocument = true;
    } else {
      this.isCancelDocument = false;
    }

    if (this.document.createdBy == this.userId && this.document.status == EnumContractStatus.DRAFT) {
      this.isStartSignFlow = true;
    } else {
      this.isStartSignFlow = false;
    }

    // isSignDocument
    const listUserSignOfCurrent = this.userSigns.filter(p => p.enterpriseId === this.enterpriseId);
    this.isSetupSignFlow = listUserSignOfCurrent.length === 0;
    this.userSigns.forEach((item) => {

      // chỉ xét thằng user đang đăng nhập thôi
      if (item.userId == this.userId) {
        // kiểm tra quyền phê duyệt
        // tslint:disable-next-line:max-line-length
        this.isApproveDocument = item.role == EnumContractUserRole.APPROVE && item.status == EnumContractUserStatus.PROCESSING && this.document.status == EnumContractStatus.PROCESSING;
        // kiểm tra quyền ký duyệt
        this.isSignDocument = item.role == EnumContractUserRole.SIGN && item.status == EnumContractUserStatus.PROCESSING && this.document.status == EnumContractStatus.PROCESSING;

        // Check role to forward initial
        // this.isForwarDocument = (this.isSignDocument || this.isApproveDocument) &&
        //   (this.userType == PermissionConfig.USER_ENTERPRISE_ADMIN_TYPE || this.userType == PermissionConfig.USER_ENTERPRISE_STAFF_TYPE)
        //   && this.document.status == EnumContractStatus.PROCESSING;

      }
    });
    // kiểm tra quyền ký nháy
    // this.initialList.forEach(item => {
    //   if (item.userId == this.userId) {
    //     if (item.role == EnumContractUserRole.INITIAL && item.status == EnumContractStatus.PROCESSING
    //       && !(this.userId in this.initialList.map(p => p.userId))
    //       && this.document.status == EnumContractStatus.PROCESSING) {
    //       this.isInitialDocument = true;
    //     } else {
    //       this.isInitialDocument = false;
    //     }
    //   }
    // });

    // if (this.deviceService.isMobile() || this.deviceService.isTablet() || this.deviceService.isDesktop()) {
    //   this.isGotoSignPageDocument = true;
    // }
  }

  onChangeUserSign(event): void {
    this.setFormChanging();
    if (event.target.value.trim().length > 0) {
      this.nzCheckLoadingUser = true;
      this.autoUserService.fetchAutoDepartment(this.inputUserSignValue.trim())
        .then(result => {
          if (this.inputUserSignValue.trim().length > 0) {
            this.filteredUserSign = result.sort(function (a, b) {
              return a.type.localeCompare(b.type)
            });
          } else {
            this.filteredUserSign = [];
          }
        }).finally(() => {
          this.nzCheckLoadingUser = false;
        });
    } else {
      this.inputUserSignValue = '';
      this.filteredUserSign = [];
    }
  }

  openDialogRefuseSignDocument() {
    this.dialogRef = this.dialog.open(DeclineSignDocumentComponent, {
      width: '500px',
      data: {
        document: this.document
      }
    });
    this.dialogHandleAfterClose(this.dialogRef);
  }

  openDialogCancelSignFlow() {
    const id = this.document.id;
    const dialogWarningRef = this.dialog.open(WarningComponent, {
      width: '500px',
      data: this.commonService.format(this.message.getMessage('messages.confirm_cancel_flow'), this.document.code, this.document.name),
      // data: `Bạn chọn hủy luồng ký kết hợp đồng ${this.document.code}-${this.document.name}. Thực hiện hủy luồng hệ thống sẽ hủy tất cả các yêu cầu phê duyệt / ký với hợp đồng được chọn, bạn chắc chắn thực hiện chức năng này?`,
    });
    dialogWarningRef.afterClosed().subscribe(rs => {
      if (rs) {
        if (id) {
          this.dialogRef = this.dialog.open(CancelSignFlowComponent, {
            width: '500px',
            data: {
              id,
              document: this.document
            }
          });
          this.dialogHandleAfterClose(this.dialogRef);
        }
      }
      // dialogWarningRef.close();
    });
  }

  dialogHandleAfterClose(dialogRef: any) {
    if (this.stampWrapper) {
      this.stampWrapper.remove();
    }
    return dialogRef.afterClosed().subscribe((rs) => {
      if (rs) {
        this.isCurrentStatus = rs;
      }
      if (dialogRef.componentInstance.success) {
        this.onBackClick(this.isCurrentStatus);
      }
    });
  }

  onBackClick(isCurrentStatus?) {
    if (window.location.pathname.includes('contract-digitzation-moha')) {
      this.routeLink = '/home-enterprise/contract-digitzation-moha';
    }
    if (isCurrentStatus) {
      this.router.navigate([this.routeLink], {
        queryParams: {
          page: this.page,
          pageSize: this.pageSize,
          enterprise: this.enterprise,
          documentType: this.documentTypeSearch,
          nameOrCode: this.nameOrCode,
          customerName: this.customerName,
          status: this.status,
          // status: isCurrentStatus,
          serviceType: this.serviceType,
          taxCode: this.taxCode,
          createdUser: this.createdUser,
          createdTimeFrom: this.createdTimeFrom,
          createdTimeTo: this.createdTimeTo,
          finishDateFrom: this.finishDateFrom,
          finishDateTo: this.finishDateTo,
          sortColumn: this.sortColumn,
          sortDirection: this.sortDirection,
          certificateNo: this.certificateNo,
          contractCodeName: this.contractCodeName,
        }
      });
    } else {
      if (!this.routeLink || this.routeLink == '') {
        this.routeLink = this.MY_DOCUMENT_ROUTER_ON_BACK_LINK;
      }
      this.router.navigate([this.routeLink], {
        queryParams: {
          page: this.page,
          pageSize: this.pageSize,
          enterprise: this.enterprise,
          documentType: this.documentTypeSearch,
          nameOrCode: this.nameOrCode,
          customerName: this.customerName,
          status: this.status,
          serviceType: this.serviceType,
          taxCode: this.taxCode,
          createdUser: this.createdUser,
          createdTimeFrom: this.createdTimeFrom,
          createdTimeTo: this.createdTimeTo,
          finishDateFrom: this.finishDateFrom,
          finishDateTo: this.finishDateTo,
          sortColumn: this.sortColumn,
          sortDirection: this.sortDirection,
          receivedTimeFrom: this.receivedTimeFrom,
          receivedTimeTo: this.receivedTimeTo,
          signRole: this.signRole,
          nameOrEmailOrPhoneUserSign: this.nameOrEmailOrPhoneUserSign,
          senderName: this.senderName,
          certificateNo: this.certificateNo,
          contractCodeName: this.contractCodeName,
          contractCode: this.contractCodeParam,
          contractName: this.contractName,
          customer: this.customer,
          contractEnterpriseCertificateNo: this.contractEnterpriseCertificateNo,
          negotiate: this.negotiate,
        }
      });
    }
  }



  openDialogApprovalDocument() {
    const userId = localStorage.getItem('userId');
    const approver = this.userSigns.find(res => res.userId === userId);
    if (approver.isSignDigitalCertificate) {
    this.documentMohaService.checkMessageAuthen(this.document.id).subscribe(res => {
      if (!res.success) {
        this.toastr.error(res.message);
        return;
      }else{
        this.processApprove();
      }
    });
  }else{
    this.dialogRef = this.dialog.open(ApprovalDocumentComponent, {
      width: '500px',
      data: {
        document: this.document
      }
    });
    this.dialogHandleAfterClose(this.dialogRef);
  }
  }

  processApprove(){
    const userId = localStorage.getItem('userId');
    const approver = this.userSigns.find(res => res.userId === userId && res.role === 2);
    if (approver.isSignDigitalCertificate) {
      this.documentService.setContractInfo(this.document);
      this.documentService.setContractFileInfo(this.listPdfSrc);
      this.router.navigate(['/home-enterprise/sign-document-digital/' + this.document.id], {
        queryParams: {
          flagCopy: true,
          page: this.page,
          pageSize: this.pageSize,
          routeLink: this.routeLink,
          enterprise: this.enterprise,
          documentType: this.documentTypeSearch,
          nameOrCode: this.nameOrCode,
          customerName: this.customerName,
          status: this.status,
          serviceType: this.serviceType,
          taxCode: this.taxCode,
          createdUser: this.createdUser,
          createdTimeFrom: this.createdTimeFrom,
          createdTimeTo: this.createdTimeTo,
          finishDateFrom: this.finishDateFrom,
          finishDateTo: this.finishDateTo,
          pageView: true,
          sortColumn: this.sortColumn,
          sortDirection: this.sortDirection,
          signPage: this.document.signPage,
          goFrom: "waitApproveDigital"
        }
      });
    } else {
      this.dialogRef = this.dialog.open(ApprovalDocumentComponent, {
        width: '500px',
        data: {
          document: this.document
        }
      });
      this.dialogHandleAfterClose(this.dialogRef);
    }
  }

  openDialogRefuseApprovalDocument() {
    this.dialogRef = this.dialog.open(DeclineApproveDocumentComponent, {
      width: '500px',
      data: {
        document: this.document
      }
    });
    this.dialogHandleAfterClose(this.dialogRef);
  }

setFormChanging() {
    this.isFormChanging = true;
  }

  isSignRole(user: any): boolean {
    return user && String(user.role) === String(this.roleUser.SIGN);
  }

  autocompleteUserSelected($event: any, model: any) {
    if ($event.isUserInput) {
      this.setFormChanging();
      if ((!model.representativeId || !model.representativeIsActive) && model.type === 'DEPARTMENT') {
        if (!model.representativeId) {
          this.toastr.error(this.message.getMessage('messages.no_representative'));
        } else {
          this.toastr.error(this.message.getMessage('messages.representative_inactive'));
        }
        return;
      }

      const userId = model.type === 'USER' ? model.id : model.representativeId;
      const userName = model.name;
      const departmentName = model.type === 'DEPARTMENT' ? model.departmentName : null;
      const departmentId = model.type === 'DEPARTMENT' ? model.departmentId : null;
      const email = model.email;

      if (!this.checkExistedUserOrDepartment(userName, departmentName, userId, departmentId, email, 'approve')) {
        let userSigns = this.userSigns
        const USER_SIGN = userSigns.filter(item => this.isSignRole(item))[0];
        if (USER_SIGN) {
          userSigns.splice(userSigns.indexOf(USER_SIGN), 1);
        }

        userSigns = [
          ...userSigns,
          {
            order: userSigns.length ? userSigns[userSigns.length - 1].order + 1 : 1,
            userId: model.type === 'USER' ? model.id : model.representativeId,
            enterpriseId: model.enterpriseId,
            enterpriseSignId: localStorage.getItem('enterpriseId'),
            name: model.name,
            userName: model.name,
            userPhone: model.phone,
            userEmail: model.email,
            email: model.email,
            role: this.roleUser.APPROVE + '',
            phone: model.phone,
            isCreatedSide: true,
            departmentName: model.type === 'DEPARTMENT' ? model.departmentName : null,
            departmentId: model.type === 'DEPARTMENT' ? model.departmentId : null,
            isSignDigitalCertificate: model.isSignDigitalCertificate ? model.isSignDigitalCertificate : false,
            signConfig: model.signConfig ? this.setDataSignConfig(JSON.parse(model.signConfig)) : { resize: false, showImage: model.isSignDigitalCertificate ? true : false },
            userPosition: model.userPosition,
            createdBy: localStorage.getItem('userId'),
            status: 1,
            contractUserId: String(Math.floor(1000000 + Math.random() * 9000000))
          }
        ];
        if (USER_SIGN) {
          USER_SIGN.order = userSigns.length + 1;
          userSigns.push(USER_SIGN);
        }
        this.userSigns = userSigns;
        this.inputUserValue = '';
        this.inputUserSignValue = '';
      }
    }
  }

  checkExistedUserOrDepartment(userName: string, departmentName: string, userId: string, departmentId?: string, email?: string, role?: string) {
    let userExist = 0;
    let departmentExist = 0;
    let roleType = false;

    const existedList = this.userSigns.filter((e) => {
      if (departmentId && e.departmentId === departmentId) {
        departmentExist++;
        if (this.isSignRole(e)) {
          roleType = true;
        }
        return true;
      } else if (e.userId === userId) {
        userExist++;
        if (this.isSignRole(e)) {
          roleType = true;
        }
        return true;
      }
    });

    if (existedList.length > 0) {
      if (departmentExist > 0) {
        if (role === 'sign') {
          this.toastr.error(this.commonService.format(this.message.getMessage('messages.add_department_apostrophe_duplicate_approve'), [departmentName]));
        } else {
          if (roleType) {
            this.toastr.error(this.commonService.format(this.message.getMessage('messages.add_department_apostrophe_duplicate_sign'), [departmentName]));
          } else {
            this.toastr.error(this.commonService.format(this.message.getMessage('messages.add_department_apostrophe_duplicate_approve'), [departmentName]));
          }
        }
      } else if (userExist > 0) {
        if (role === 'sign') {
          this.toastr.error(this.commonService.format(this.message.getMessage('messages.add_user_apostrophe_duplicate_approve'), [userName + ' - ' + email]));
        } else {
          if (roleType) {
            this.toastr.error(this.commonService.format(this.message.getMessage('messages.add_user_apostrophe_duplicate_sign'), [userName + ' - ' + email]));
          } else {
            this.toastr.error(this.commonService.format(this.message.getMessage('messages.add_user_apostrophe_duplicate_approve'), [userName + ' - ' + email]));
          }
        }
      }
      return true;
    } else {
      return false;
    }
  }

  setDataSignConfig(signConfig: any) {
    let newDataSignConfig = { ...signConfig };
    if(newDataSignConfig.resize === null || newDataSignConfig.resize === undefined) {
      newDataSignConfig = { ...newDataSignConfig, resize: false };
    }
    if(newDataSignConfig.showImage === null || newDataSignConfig.showImage === undefined) {
      newDataSignConfig = { ...newDataSignConfig, showImage: false };
    }
    return newDataSignConfig;
  }

  autocompleteUserSignSelected($event: any, model: any) {
    if ($event.isUserInput) {
      this.setFormChanging();
      if (this.hasRoleOneSelected()) {
        this.inputUserValue = '';
        this.inputUserSignValue = '';
        this.filteredUserSign = [];
        return;
      }
      if ((!model.representativeId || !model.representativeIsActive) && model.type === 'DEPARTMENT') {
        if (!model.representativeId) {
          this.toastr.error(this.message.getMessage('messages.no_representative'));
        } else {
          this.toastr.error(this.message.getMessage('messages.representative_inactive'));
        }
        return;
      }

      const userId = model.type === 'USER' ? model.id : model.representativeId;
      const userName = model.name;
      const departmentName = model.type === 'DEPARTMENT' ? model.departmentName : null;
      const departmentId = model.type === 'DEPARTMENT' ? model.departmentId : null;
      const email = model.email;

      if (!this.checkExistedUserOrDepartment(userName, departmentName, userId, departmentId, email, 'sign')) {
        // Re-set all old members to "APPROVE" role
        let userSigns = this.userSigns
        userSigns = [
          ...userSigns,
          {
            order: userSigns.length + 1,
            userId: model.type === 'USER' ? model.id : model.representativeId,
            enterpriseId: model.enterpriseId,
            enterpriseSignId: localStorage.getItem('enterpriseId'),
            name: model.name,
            userName: model.name,
            email: model.email,
            userEmail: model.email,
            role: this.roleUser.SIGN + '',
            phone: model.phone,
            userPhone : model.phone,
            isCreatedSide: true,
            departmentName: model.type === 'DEPARTMENT' ? model.departmentName : null,
            departmentId: model.type === 'DEPARTMENT' ? model.departmentId : null,
            isSignDigitalCertificate: model.isSignDigitalCertificate ? model.isSignDigitalCertificate : false,
            signConfig: model.signConfig ? this.setDataSignConfig(JSON.parse(model.signConfig)) : { resize: false, showImage: true },
            userPosition: model.userPosition,
            createdBy: localStorage.getItem('userId'),
            status: 1,
            contractUserId: String(Math.floor(1000000 + Math.random() * 9000000))
          }
        ];
        this.userSigns = userSigns;
        this.inputUserValue = '';
        this.inputUserSignValue = '';
        this.clickSave = false;
      }
    }
  }



  //Thêm khung ký tên doanh nghiệp
  addSign(item: any) {
    // Lay so thu tu chan ky
    const idNumber = uuid.v4();
    // if(item.customerId){
    //   idNumber = this.listSign.filter(res=> res.customerId == item.customerId).length + 1
    // } else {
    //   idNumber = this.listSign.filter(res=> res.enterpriseId == item.enterpriseId).length + 1
    // }

    if (!this.pdfSrc) {
      if (!this.toastr.findDuplicate(this.message.getMessage('messages.error_contract_quickly'), true, true)) {
        this.toastr.error(this.message.getMessage('messages.error_contract_quickly'));
      }
      const listBtn = document.querySelectorAll("button");
      console.log(listBtn);
      listBtn.forEach((btn) => {
        if (btn.className.includes('mat-stroked-button-create-document')) {
          btn.classList.add("btn_glowing");
        }
      });
      setTimeout(() => {
        listBtn.forEach((btn) => {
          btn.classList.remove("btn_glowing");
        });
      }, 5000);
      return;
    }
    // console.log(`text-pdf-layer-${this.pageIndex}-${this.activeFile}`);
    if (!document.getElementById(`text-pdf-layer-${this.pageIndex}-${this.activeFile}`)) {
      setTimeout(() => {
        this.addSign(item);
      }, 100);
      return;
    }
    this.returnToPrevPosition();
    if (!this.isSelectPosition) {
      const itemNew = JSON.parse(JSON.stringify(item));
      itemNew.idNumber = idNumber
      itemNew.row_number = 1
      if(itemNew.enterpriseId == null || itemNew.enterpriseId == ""){
        itemNew.enterpriseId = localStorage.getItem("enterpriseId")
      }
      const element: any = document.getElementById(`text-pdf-layer-${this.pageIndex}-${this.activeFile}`);
      const view: any = document.getElementById('viewerContainer');
      const elementBounding = element.getBoundingClientRect();
      const viewBounding = view.getBoundingClientRect();
      const offsetParent = element.offsetParent.dataset;
      const { pageNumber } = offsetParent;
      let signatureWidth = this.width * this.zoomLevel / 100;
      let height = this.height * this.zoomLevel / 100;
      let signZoom = this.zoomLevel / 100;
      const widthHeightRatio = this.width / this.height;
      const wrapperLeft = 0;
      let wrapperTop = 0;
      if (viewBounding.y - elementBounding.y > height) {
        wrapperTop = viewBounding.y - elementBounding.y;
      }
      const newDiv = document.createElement('div');
      // Sua Id chu ky

      newDiv.setAttribute('id', `${idNumber}-sign-${itemNew.enterpriseId || itemNew.customerId }-approver-${itemNew.userId}`);
      newDiv.style.left = `${wrapperLeft}px`;
      newDiv.style.top = `${wrapperTop}px`;
      newDiv.style.width = `${signatureWidth}px`;
      newDiv.style.height = `${height}px`;
      newDiv.style.background = 'rgb(0,0,0,0.2)';
      newDiv.style.zIndex = '1';
      newDiv.style.border = '1px solid #999999';
      newDiv.style.lineHeight = '1.9';
      newDiv.style.color = '#00f';
      newDiv.style.fontFamily = '\"Times New Roman\", Times, serif';
      newDiv.style.padding = `${10 * signZoom}px`;
      newDiv.style.position = 'absolute';
      newDiv.style.minWidth = (300 / 10 * 3 * signZoom) + 'px';
      newDiv.style.minHeight = (136 / 10 * 3 * signZoom) + 'px';
      this.getOffClose(itemNew);
      if(itemNew.row_number && this.mode != "view"){
        newDiv.innerHTML = `<span class="mat-icon material-icons"style="font-size: ${30 * signZoom}px; position: absolute; top: 0; right: 0; cursor: pointer; height: unset; width: unset; color: red;">close</span>
      <div style="font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; text-align: center; height: 100%; color: #00f; cursor: move;">
            ${this.message.getMessage('signature')} ${itemNew.name} ${this.message.getMessage('number_sign')} ${itemNew.row_number}
          </div>
          `;
      }else {
        newDiv.innerHTML = `
      <div style="font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; text-align: center; height: 100%; color: #00f; cursor: move;">
            ${this.message.getMessage('signature')} ${itemNew.name}
          </div>
          `;
      }
      // <div class="resize-div-bot-right" style="--zoom: ${this.zoomLevel}"></div>
      newDiv.className = 'no-user-select';
      const zoomLevel = this.zoomLevel;
      itemNew.stampPositionLeft = 0;
      itemNew.stampPositionTop = 0;
      itemNew.x = Math.round(100 * wrapperLeft / zoomLevel);
      itemNew.y = Math.round(100 * wrapperTop / zoomLevel);
      itemNew.pageIndex = this.pageIndex;
      itemNew.zoom = this.zoomLevel / 100;
      itemNew.pdfSrc = this.pdfSrc;
      itemNew.pageNumber = Number(pageNumber);
      itemNew.width = Math.round(this.width);
      itemNew.height = Math.round(this.height);
      itemNew.status = 1;
      const genFileIdFake = () =>
      `FKE_${Math.random().toString(36).substr(2, 9)}-${Math.random().toString(36).substr(2, 9)}`;

      // Duyệt qua từng hàng, hàng nào chưa có id thì gán fileIdFake riêng
      this.mainFiles = (this.mainFiles || []).map((item: any) => {
      if (!item.id) {
        item.id = genFileIdFake(); // mỗi lần gọi -> id khác nhau
       }
          return item;
       });
      const files = this.mainFiles;
      let find;
      if (files && files.length && files[this.activeFile]) {
        const file = files[this.activeFile] as any;
        //let fileIdFake = `FKE_${Math.random().toString(36).substr(2, 9)}-${Math.random().toString(36).substr(2, 9)}`;
        itemNew.fileId = file.id ? file.id : null;
        itemNew.isNewUpload = this.filesUpload.some((item) => item.id === itemNew.fileId);
        itemNew.fileName = file.fileName ? file.fileName : (file.name ? file.name : null);
        // Them nhieu chan ky
        // if (file) {
        //   if (item.enterpriseId) {
        //     find = this.listSign.find(sign => sign.fileId === file.id && sign.enterpriseId === item.enterpriseId && sign.userId === item.userId);
        //   } else {
        //     find = this.listSign.find(sign => sign.fileId === file.id &&  sign.customerId === item.customerId && sign.userId === item.userId);
        //   }
        // }
      }
      if (!find) {
        const resizer = document.createElement('div');
        // resizer.setAttribute('class', 'resize-div-bot-right');
        if(this.mode != "view"){
          resizer.setAttribute('class', 'resize-div-bot-right');
        }
        resizer.style.setProperty('--zoom', signZoom.toString());
        newDiv.appendChild(resizer);
        element.appendChild(newDiv);

        let startX, startY;
        let signId;
        let userId;
        let indexApprover;
        let idNumber;
        let signUuid;
        resizer.addEventListener('mousedown', (e) => {
          e.stopPropagation();
          startX = e.clientX;
          startY = e.clientY;
          document.documentElement.addEventListener('mousemove', doDrag);
          document.documentElement.addEventListener('mouseup', stopDrag);
          const targetSignId = e.target as Element;


          indexApprover = targetSignId.parentElement.id.indexOf('-approver-');
          const indexSign = targetSignId.parentElement.id.indexOf('-sign-');
          signId = targetSignId.parentElement.id.slice(indexSign + 6, indexApprover);
          userId = targetSignId.parentElement.id.slice(indexApprover + 10);
          signUuid = targetSignId.parentElement.id.slice(0, indexSign);

        });

        // const signSelected = this.listSign.filter(item => item.enterpriseId === signId);

        let baseWidth = newDiv.offsetWidth;
        let baseHeight = newDiv.offsetHeight;
        const rerenderSign = () => {
          const signSelected = this.listSign.filter(item => (item.enterpriseId === signId || item.customerId === signId) && ((signUuid === item.idNumber && item.idNumber) || (signUuid === item.contractSignId && item.contractSignId)));
          this.getOffClose(signSelected[0]);
          if(signSelected[0].row_number && this.mode != "view"){
            newDiv.innerHTML = `<span class="mat-icon material-icons"style="font-size: ${30 * signZoom}px; position: absolute; top: 0; right: 0; cursor: pointer; height: unset; width: unset; color: red;">close</span>
              <div style="font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; text-align: center; height: 100%; color: #00f; cursor: move;">
                ${this.message.getMessage('signature')} ${signSelected[0].name} ${this.message.getMessage('number_sign')} ${signSelected[0].row_number}
              </div>
          `;
          }else {
            newDiv.innerHTML = `
              <div style="font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; text-align: center; height: 100%; color: #00f; cursor: move;">
                ${this.message.getMessage('signature')} ${signSelected[0].name}
              </div>
          `;
          }
          newDiv.appendChild(resizer);
          resizer.style.removeProperty('--zoom');
          resizer.style.setProperty('--zoom', (signZoom).toString());
          return;
        }

        const doDrag = (e) => {
          e.stopPropagation();
          const signSelected = this.listSign.filter(item => (item.enterpriseId === signId || item.customerId === signId) && ((signUuid === item.idNumber && item.idNumber) || (signUuid === item.contractSignId && item.contractSignId)));
          signatureWidth = signSelected[0].width * this.zoomLevel / 100;
          height = signSelected[0].height * this.zoomLevel / 100;

          newDiv.style.width = (signatureWidth + e.clientX - startX) + 'px';
          newDiv.style.height = (signatureWidth + e.clientY - startY) + 'px';
          newDiv.style.maxWidth = (element.offsetWidth - wrapperLeft) + 'px';
          newDiv.style.maxHeight = (element.offsetHeight - wrapperTop) + 'px';
          let widthHeightRatio_Drag = newDiv.offsetWidth / newDiv.offsetHeight;
          if (widthHeightRatio !== widthHeightRatio_Drag) {
            newDiv.style.height = (newDiv.offsetWidth / widthHeightRatio) + 'px';
            newDiv.style.width = (newDiv.offsetHeight * widthHeightRatio) + 'px';
          }
          rerenderSign();
        }

        const stopDrag = (e) => {
          e.stopPropagation();
          if (newDiv.offsetWidth / 2 + wrapperLeft < 0 || newDiv.offsetHeight / 2 + wrapperTop < 0) {
            newDiv.style.width = baseWidth + 'px';
            newDiv.style.height = baseHeight + 'px';
          } else {
            baseWidth = newDiv.offsetWidth;
            baseHeight = newDiv.offsetHeight;
          }
          rerenderSign();

          this.listSign.forEach(item => {
            if ((item.enterpriseId === signId || item.customerId === signId) && ((signUuid === item.idNumber && item.idNumber) || (signUuid === item.contractSignId && item.contractSignId))) {
              item.width = newDiv.offsetWidth * 100 / this.zoomLevel;
              item.height = newDiv.offsetHeight * 100 / this.zoomLevel;
            }
          });
          this.createContractService.signPositions.next(this.listSign);
          document.documentElement.removeEventListener('mousemove', doDrag);
          document.documentElement.removeEventListener('mouseup', stopDrag);
        }

        this.listSign.push(itemNew);
        this.createContractService.signPositions.next(this.listSign);
        this.changeDataToTable()
      }
    }
  }

  goToPage(enterpriseId: string, userId: string, signData ,customerId) {
    this.returnToPrevPosition();
    const a = this.userSigns;
    const files = this.mainFiles;
    let id;
    if (files && files.length && files[this.activeFile]) {
      const file = files[this.activeFile] as any;
      id = file.id ? file.id : file.fileId;
    }
    let idSign = signData.contractSignId || signData.idNumber
    const node = enterpriseId ? document.getElementById(`${idSign}-sign-${enterpriseId}-approver-${userId}`) : document.getElementById(`${idSign}-sign-${customerId}-approver-${userId}`);
    const sign = this.listSign.find(sign => (sign.enterpriseId === enterpriseId || sign.customerId === enterpriseId ||sign.customerId === customerId) && sign.userId === userId && sign.fileId === id);
    this.pageIndex = sign ? sign.pageIndex : 1;
    if (node) {
      setTimeout(() => {
        node.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
      });
    } else {
      this.signNeedShow = sign.enterpriseId || sign.customerId;
      this.signApproverNeedShow = sign.userId;
    }
  }

  returnToPrevPosition() {
    if (Object.keys(this.signSelected || {}).length) {
      const position = this.signSelected;
      const element = document.getElementById(`text-pdf-layer-${position.pageIndex}-${this.activeFile}`);
      const x = position.x;
      const y = position.y;
      const _width = position.width;
      const _height = position.height;
      const name = position.name;
      const id = position.enterpriseId || position.customerId;
      const userId = position.userId;
      const elWidth = element.offsetWidth;
      const elHeight = element.offsetHeight;
      const htmlNode = this.getStampWrapper(x, y, _width, _height, name, id, elWidth, elHeight, userId, null, null, [], false, (this.signSelected.idNumber || this.signSelected.contractSignId), this.signSelected.row_number);
      element.appendChild(htmlNode);
      this.signSelected = null;
      this.isSelectPosition = false;
      document.body.style.userSelect = 'none';
    }
  }

  getOffClose(data){
    const stopDropOld = [];
    if(data.userId == 'undefined'){
      this.stopDrop = false;
    }
    else{
      this.listSign.filter(ele => {
        if (!ele.role) {
          stopDropOld.push(ele)
        }
      });
if(stopDropOld.length >0){if(stopDropOld[0].userId == data.userId) {
  this.stopClose = false;
} else {
  this.stopClose = true;
}}
else {
  this.stopDrop = true;
}

  }
  }

  // tạo một thẻ điv với thông tin đc truyền vào để tạo ra khung ký
  getStampWrapper(x: number, y: number, width: number, height: number, name: string, id: number, elWidth: number, elHeight: number, idUser?: any, fontSize?: any, fontFamily?: any, fontStyle?: any[], isContractCodeConfig = false, uuid: string = '', row_number:any = '') {
    const stampNode = document.createElement('div');
    if (!isContractCodeConfig) {
      stampNode.setAttribute('id', `${uuid}-sign-${id}-approver-${idUser}`);
    } else {
      //neu la cau hinh ma hop dong
      stampNode.setAttribute('id', `${id}`);
    }


    // stampNode.innerHTML = this.genStampContent();
    let signatureWidth = width * this.zoomLevel / 100;
    let signatureHeight = height * this.zoomLevel / 100;

    const wrapperLeft = (x * this.zoomLevel) / 100;
    const wrapperTop = (y * this.zoomLevel) / 100;
    let signZoom = this.zoomLevel / 100;
    const widthHeightRatio = width / height;
    const isViewMode = this.mode === 'view';
    const closeIconHtml = isViewMode ? '' : `<span class="mat-icon material-icons"style="font-size: ${30 * signZoom}px; position: absolute; top: 0; right: 0; cursor: pointer; height: unset; width: unset; color: red;">close</span>`;
    const signatureCursor = isViewMode ? 'default' : 'move';
    stampNode.style.position = 'absolute';
    stampNode.style.left = `${wrapperLeft}px`;
    stampNode.style.top = `${wrapperTop}px`;
    if (!isContractCodeConfig) {
      stampNode.style.width = `${signatureWidth}px`;
      stampNode.style.height = `${signatureHeight}px`;
      // stampNode.style.color = '#00f';
    }
    stampNode.style.minWidth = `calc(300px / 10 * 3 * ${this.zoomLevel / 100})`;
    stampNode.style.minHeight = `calc(136px / 10 * 3 * ${this.zoomLevel / 100})`;
    stampNode.style.background = 'rgb(0,0,0,0.2)';
    stampNode.style.zIndex = '1';
    stampNode.style.border = '1px solid #999999';
    stampNode.style.lineHeight = '1.9';
    stampNode.style.color = '#00f';

    if (fontSize) {
      stampNode.style.fontSize = fontSize;
    };
    if (fontFamily) {
      stampNode.style.fontFamily = fontFamily;
    } else {
      stampNode.style.fontFamily = '\"Times New Roman\", Times, serif';
    };
    if (fontStyle && fontStyle.includes('bold')) {
      stampNode.style.fontWeight = 'bold';
    }
    if (fontStyle && fontStyle.includes('italic')) {
      stampNode.style.fontStyle = 'italic';
    }
    if (fontStyle && fontStyle.includes('underline')) {
      stampNode.style.textDecoration = 'underline';
    }
    stampNode.style.padding = `${10 * signZoom}px`;
    stampNode.className = 'no-user-select';
    if (isContractCodeConfig) {
      stampNode.style.width = `${signatureWidth}px`;
      stampNode.style.height = `${signatureHeight}px`;
      if (this.documentCodeNull && !this.isOnAutoNumber) {
        stampNode.style.color = 'red';
      }
      // stampNode.style.whiteSpace = 'nowrap';
      // stampNode.style.minWidth ='fit-content';
      stampNode.style.wordBreak = 'break-word';
      if (this.documentCodeNull && !this.isOnAutoNumber) {
        stampNode.innerHTML = `${closeIconHtml}
        <div class="text-danger" style="font-size: ${(fontSize ? fontSize : 12) * (4 / 3) * signZoom}px;display: flex; flex-direction: column; justify-content: start; text-align: left; height: 100%; cursor: ${signatureCursor};">
          ${name}
        </div>
        `;
      } else {
        stampNode.innerHTML = `${closeIconHtml}
        <div style="font-size: ${(fontSize ? fontSize : 12) * (4 / 3) * signZoom}px;display: flex; flex-direction: column; justify-content: start; text-align: left; height: 100%; color: #00f; cursor: ${signatureCursor};">
          ${name}
        </div>
        `;
      }

    } else {
      stampNode.innerHTML = `${closeIconHtml}
    <div style="font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; text-align: center; height: 100%; color: #00f; cursor: ${signatureCursor};">
      ${this.message.getMessage('signature')} ${name} ${this.message.getMessage('number_sign')} ${row_number}
    </div>
    `;
      stampNode.style.display = 'flex';
      stampNode.style.justifyContent = 'center';
      stampNode.style.flexDirection = 'column';
      stampNode.style.textAlign = 'center';
      stampNode.style.fontWeight = 'bold';
    };
    // stampNode.innerHTML = `${name}`
    //         Thay dổi kích thước chân ký

    const resizer = document.createElement('div');
    resizer.setAttribute('class', 'resize-div-bot-right');
    resizer.style.setProperty('--zoom', (signZoom).toString());
    if (!isViewMode) {
      stampNode.appendChild(resizer);
    }
    let startX, startY, signId, userId, indexApprover, idSignature, signUuid;
    if (!isViewMode) {
      resizer.addEventListener('mousedown', (e) => {
        e.stopPropagation();
        startX = e.clientX;
        startY = e.clientY;
        document.documentElement.addEventListener('mousemove', doDrag);
        document.documentElement.addEventListener('mouseup', stopDrag);
        const targetSignId = e.target as Element;
        indexApprover = targetSignId.parentElement.id.indexOf('-approver-');
        const indexSign = targetSignId.parentElement.id.indexOf('-sign-');
        signId = targetSignId.parentElement.id.slice(indexSign + 6, indexApprover);
        userId = targetSignId.parentElement.id.slice(indexApprover + 10);
        signUuid = targetSignId.parentElement.id.slice(0, indexSign);
      });
    }

    let baseWidth = signatureWidth;
    let baseHeight = signatureHeight;

    const rerenderSign = () => {
      let signSelected, signatureSelected;
      if (this.listSign.length) {
        if (userId !== null && userId !== undefined && userId !== 'undefined') {
          signSelected = this.listSign.filter(item => (item.enterpriseId === signId || item.idCustomer === signId ) && ((item.idNumber && signUuid == item.idNumber) || (signUuid == item.contractSignId && item.contractSignId)));
        } else {
          signSelected = this.listSign.filter(item => (item.enterpriseId === signId || item.idCustomer === signId && ((item.idNumber && signUuid == item.idNumber) || (signUuid == item.contractSignId && item.contractSignId))));
        };
      }
      stampNode.innerHTML = `${closeIconHtml}
      <div style="font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; text-align: center; height: 100%; color: #00f; cursor: ${signatureCursor};">
        ${this.message.getMessage('signature')} ${signSelected[0].name} ${this.message.getMessage('number_sign')} ${signSelected[0].row_number}
      </div>
      `;
      stampNode.appendChild(resizer);
      resizer.style.removeProperty('--zoom');
      resizer.style.setProperty('--zoom', (signZoom).toString());
      return;
    }

    const doDrag = (e) => {
      e.stopPropagation();
      let signSelected, signatureSelected;
      if (this.listSign.length) {
        if (userId !== null && userId !== undefined && userId !== 'undefined') {
          signSelected = this.listSign.filter(item => (item.enterpriseId === signId || item.customerId === signId ) && ((item.idNumber && signUuid == item.idNumber) || signUuid == item.contractSignId));
        } else {
          signSelected = this.listSign.filter(item => (item.enterpriseId === signId || item.customerId === signId) && ((item.idNumber && signUuid == item.idNumber) || signUuid == item.contractSignId));
        }
      }
      signatureHeight = signSelected[0].height * this.zoomLevel / 100;
      signatureWidth = signSelected[0].width * this.zoomLevel / 100;
      stampNode.style.width = (signatureWidth + e.clientX - startX) + 'px';
      stampNode.style.height = (signatureHeight + e.clientY - startY) + 'px';
      let widthHeightRatio_Drag = stampNode.offsetWidth / stampNode.offsetHeight;
      if (widthHeightRatio !== widthHeightRatio_Drag) {
        stampNode.style.height = (stampNode.offsetWidth / widthHeightRatio) + 'px';
        stampNode.style.width = (stampNode.offsetHeight * widthHeightRatio) + 'px';
      }
      stampNode.style.maxWidth = (elWidth - stampNode.offsetLeft) + 'px';
      stampNode.style.maxHeight = (elHeight - stampNode.offsetTop) + 'px';

      rerenderSign();
    }

    const stopDrag = (e) => {
      e.stopPropagation();
      if (stampNode.offsetWidth / 2 + wrapperLeft < 0 || stampNode.offsetHeight / 2 + wrapperTop < 0) {
        stampNode.style.width = baseWidth + 'px';
        stampNode.style.height = baseHeight + 'px';
      } else {
        baseWidth = stampNode.offsetWidth;
        baseHeight = stampNode.offsetHeight;
      }

      rerenderSign();
      if (this.listSign.length) {
        this.listSign.forEach(item => {
          if ((item.enterpriseId === signId || item.customerId === signId ) && ((item.idNumber && signUuid == item.idNumber) || (signUuid == item.contractSignId && item.contractSignId))) {
            item.width = stampNode.offsetWidth * 100 / this.zoomLevel;
            item.height = stampNode.offsetHeight * 100 / this.zoomLevel;
          }
        });
      }
      document.documentElement.removeEventListener('mousemove', doDrag);
      document.documentElement.removeEventListener('mouseup', stopDrag);
    }

    return stampNode;
  }

  changeDataToTable(){
    this.userSigns.map(res=>{
      let changeDataUser = this.listSign.filter(sign => sign.userId == res.userId)
      this.tranformDataUser(changeDataUser)
    });
    if (this.enterprises.value.length > 0) {
      this.enterprises.value.map(res=>{
        let changeDataCustomer = this.listSign.filter(sign => sign.idCustomer == res.idCustomer)
        this.tranformDataUser(changeDataCustomer)
      })
    }
    // sortData
    this.listSign.sort((a, b) => a.x - b.x);
    this.listSign.sort((a, b) => a.y - b.y);
    this.listSign.sort((a, b) => a.pageIndex - b.pageIndex);
    // render lai khung chan ky
    this.listSign.forEach(res=>{
      let idSign = (res.contractSignId || res.idNumber) +  '-sign-' + (res.enterpriseId || res.idCustomer) + '-approver-' + res.userId
      let sign = document.getElementById(idSign)
      if (res.isDelete) {
        if (sign) {
          sign.remove();
        }
      } else {
        if (sign) {
          const elements = sign.getElementsByTagName('div');
          if (elements.length) {
            elements.item(0).innerHTML = `${this.message.getMessage('signature')} ${res.name} ${this.message.getMessage('number_sign')} ${res.row_number}`
          }
        }
      }
    });
    this.listSign = this.listSign.filter(sign => !sign.isDelete);
  }

  tranformDataUser(data){
    this.sortData(this.mainFiles,data)
    return data
  }

  get enterprises(): FormArray {
    return this.form.get('enterprises') as FormArray;
  }

  // Sap xep thu tu chan ky
  sortData(listFile, listSignSort){
    const getFileIndex = (fileId: string): number => {
      return listFile.findIndex((file) => file.fileId === fileId);
    };

    const listSign: any[] = [];

    if (Array.isArray(listSignSort)) {
      listSign.push(...listSignSort);
    }

    listSign.sort((a, b) => a.x - b.x);
    listSign.sort((a, b) => a.y - b.y);
    listSign.sort((a, b) => a.pageIndex - b.pageIndex);

    listSign.sort((prev, next) => {
      return (
        getFileIndex(prev.fileId) - getFileIndex(next.fileId)
      );
    });
    this.mainFiles.map((res: any)=>{
      let signFile = listSign.filter(sign => sign.fileId == res.fileId || sign.fileId == res.id)
      signFile.forEach((row, index) =>{
        row.row_number = index +1;
    });
    })
    return listSign;
  }

  checkHaveSign(item: any, signData) {
    const files = this.mainFiles;
    let id;
    let check;
    let idSign = signData.contractSignId || signData.idNumber
    if (files && files.length && files[this.activeFile]) {
      const file = files[this.activeFile] as any;
      id = file.id ? file.id : file.fileId;
    }
    if (item.enterpriseId || item.enterpriseSignId) {
      check = this.listSign.find(sign =>
        (sign.enterpriseId === item.enterpriseSignId || sign.enterpriseId === item.enterpriseId || sign.idCustomer === item.idCustomer) && sign.userId === item.userId && sign.fileId === id && (idSign === sign.contractSignId || idSign === sign.idNumber)
       );
       return check ? true : false;
    }
    check = this.listSign.find(sign =>
      sign.idCustomer === item.idCustomer && sign.userId === item.userId && sign.fileId === id && (idSign === sign.contractSignId || idSign === sign.idNumber)
    );
    return check ? true : false;
  }

  textLayerRendered(e) {
    const element = e.source.textLayerDiv;
    const pageIndex = e.source.pageNumber
    // lấy các chữ ở trang pageNumber
    let signPosition;
    if (this.shouldRenderSignaturePlaceholders() && (this.listSign && this.listSign.length > 0)) {
      const files = this.mainFiles;
      let id;
      if (files && files.length && files[this.activeFile]) {
        const file = files[this.activeFile] as any;
        id = file.id ? file.id : file.fileId;
      }
      if (this.listSign && this.listSign.length > 0) {
        signPosition = this.listSign.filter((item) => {
          return item.pageIndex === pageIndex && item.fileId === id && !(item.id && item.id.includes('contract-code-config-'));
        });
      }
    }

    if (signPosition && signPosition.length > 0) {

      for (const position of signPosition) {

        const x = position.x;
        const y = position.y;
        const _width = position.width;
        const _height = position.height;
        const name = position.name;
        const id = position.enterpriseId || position.idCustomer;
        const userId = position.userId;
        const elWidth = element.offsetWidth;
        const elHeight = element.offsetHeight;
        const htmlNode = this.getStampWrapper(x, y, _width, _height, name, id, elWidth, elHeight, userId, null, null, [], false, (position.contractSignId || position.idNumber), position.row_number);
        element.appendChild(htmlNode);
        if (position.enterpriseId) {
          if (position.enterpriseId === this.signNeedShow && position.userId === this.signApproverNeedShow) {
            const node = document.getElementById(`${position.contractSignId}-sign-${this.signNeedShow}-approver-${this.signApproverNeedShow}`);
            node.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
          }
          this.signNeedShow = null;
          this.signApproverNeedShow = null;
        } else {
          if (position.customerId === this.signNeedShow && position.userId === this.signApproverNeedShow) {
            const node = document.getElementById(`${position.contractSignId}-sign-${this.signNeedShow}-approver-${this.signApproverNeedShow}`);
            node.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });

          }
          this.signNeedShow = null;
          this.signApproverNeedShow = null;
        }

      }
    }

    element.addEventListener('mousedown', (eventMousedown) => {
      if (this.isLocked) return;
      if (!this.isSelectPosition) {
        const target: HTMLElement = eventMousedown.target;
        if (target.id.includes('sign-') || (target.parentElement && target.parentElement.id && (target.parentElement.id.includes('sign-')))) {
          const id = target.id ? target.id : target.parentElement.id;
          const indexApprover = id.indexOf('-approver-');
          const indexSign = id.indexOf('-sign-');
          const signId = id.slice(indexSign + 6, indexApprover);
          const userId = id.slice(indexApprover + 10);
          const signUuid = id.slice(0, indexSign);

          if (target.className.includes('mat-icon')) {
            this.deleteSign(signId, userId, signUuid,null);
            return;
          }
          this.isSelectPosition = true;
          document.body.style.userSelect = 'none';
          const files = this.mainFiles;
          let idFile;
          if (files && files.length && files[this.activeFile]) {
            const file = files[this.activeFile] as any;
            idFile = file.id ? file.id : null;
          }

          // this.listSign.forEach(item => {
          //   if (item.fileId === null || item.fileId === undefined) {
          //     item.fileId = idFile;
          //   }
          // });

          this.signSelected = this.listSign.find(item => (item.enterpriseId == signId || item.idCustomer == signId) && item.fileId === idFile && ((item.idNumber && signUuid == item.idNumber) || signUuid == item.contractSignId));
          if (this.listSign.length) {
            if (userId !== null && userId !== undefined && userId !== 'undefined') {
              this.signSelected = this.listSign.find(item => {
                return (item.enterpriseId == signId || item.idCustomer == signId) && item.userId === userId && item.fileId === idFile && ((item.idNumber && signUuid == item.idNumber) || signUuid == item.contractSignId)
              });
            } else {
              this.signSelected = this.listSign.find(item => (item.enterpriseId === signId ||  item.idCustomer == signId) && item.fileId === idFile && ((item.idNumber && signUuid == item.idNumber) || signUuid == item.contractSignId));
            }
          }

          let sign = null;
          let idSign = (this.signSelected.contractSignId || this.signSelected.idNumber) +  '-sign-' + (this.signSelected.enterpriseId || this.signSelected.idCustomer) + '-approver-' + this.signSelected.userId
          sign = document.getElementById(idSign)

          let position = {
            top: Number(sign.style.top.slice(0, -2)),
            left: Number(sign.style.left.slice(0, -2))
          }

          const node = document.getElementById(id);
          if (node) {
            node.remove();
          }
          if (Object.keys(this.signSelected || {}).length) {
            this.showFramesNotification(this.signSelected, position);
          }
        }
      }
    });

    element.addEventListener('mouseup', (eventMouseup) => {
      if (this.isLocked) return;
      if (this.isSelectPosition) {
        this.isSelectPosition = false;
        document.body.style.userSelect = 'auto';
        // xoá dòng chọn vị trí
        const framesNotification = document.getElementById('show-frames-notification');
        if (framesNotification) {
          framesNotification.remove();
        }
        const offsetParent = element.offsetParent.dataset;
        const { pageNumber } = offsetParent;
        const boundingClient = element.getBoundingClientRect();
        const { top, left } = boundingClient;
        let signatureWidth, signatureHeight, widthHeightRatio;
        widthHeightRatio = this.width / this.height;
        if (Object.keys(this.signSelected || {}).length) {
          signatureWidth = this.signSelected.width * this.zoomLevel / 100;
          signatureHeight = this.signSelected.height * this.zoomLevel / 100;
        }
        let signZoom = this.zoomLevel / 100;
        let wrapperLeft = eventMouseup.clientX - signatureWidth / 2 - left;
        let wrapperTop = eventMouseup.clientY - signatureHeight / 2 - top;
        const newDiv = document.createElement('div');
        if (Object.keys(this.signSelected || {}).length) {
          let contractSignId = this.signSelected.contractSignId || this.signSelected.idNumber

          newDiv.setAttribute('id', `${contractSignId}-sign-${this.signSelected.enterpriseId || this.signSelected.idCustomer}-approver-${this.signSelected.userId}`);
          newDiv.style.width = `${signatureWidth}px`;
          newDiv.style.height = `${signatureHeight}px`;
          newDiv.style.fontFamily = '\"Times New Roman\", Times, serif';
        }
        if (wrapperLeft > 0) {
          newDiv.style.left = `${wrapperLeft}px`;
        }
        if (wrapperTop > 0) {
          newDiv.style.top = `${wrapperTop}px`;
        }
        newDiv.style.background = 'rgb(0,0,0,0.2)';
        newDiv.style.zIndex = '1';
        newDiv.style.border = '1px solid #999999';
        newDiv.style.lineHeight = '1.9';
        newDiv.style.color = '#00f';
        if (this.documentCodeNull && !this.isOnAutoNumber) {
          newDiv.style.color = 'red';
        } else {
          newDiv.style.color = '#00f';
        }
        newDiv.style.padding = `${10 * signZoom}px`;
        newDiv.style.position = 'absolute';
        newDiv.style.minWidth = `calc(300px / 10 * 3 * ${this.zoomLevel / 100})`;
        newDiv.style.minHeight = `calc(136px / 10 * 3 * ${this.zoomLevel / 100})`;
        newDiv.className = 'no-user-select';
        if (Object.keys(this.signSelected || {}).length) {
          newDiv.innerHTML = `<span class="mat-icon material-icons"style="font-size: ${30 * signZoom}px; position: absolute; top: 0; right: 0; cursor: pointer; height: unset; width: unset; color: red;">close</span>
          <div style="font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; align-items: center; text-align: center; height: 100%; color: #00f; cursor: move;">
            ${this.message.getMessage('signature')} ${this.signSelected.name} ${this.message.getMessage('number_sign')} ${this.signSelected.row_number}
          </div>
        `;
        }
        this.changeDataToTable()
        //         Thay dổi kích thước chân ký
        const resizer = document.createElement('div');
        resizer.setAttribute('class', 'resize-div-bot-right');
        resizer.style.setProperty('--zoom', (signZoom).toString());
        newDiv.appendChild(resizer);
        element.appendChild(newDiv);

        let startX, startY;
        let signId;
        let indexApprover;
        let userId;
        let idSignature;
        let signUuid;

        resizer.addEventListener('mousedown', (e) => {
          if (this.isLocked) return;
          e.stopPropagation();
          startX = e.clientX;
          startY = e.clientY;
          document.documentElement.addEventListener('mousemove', doDrag);
          document.documentElement.addEventListener('mouseup', stopDrag);
          const targetSignId = e.target as Element;
          if (targetSignId.parentElement.id && targetSignId.parentElement.id.includes('contract-code-config-')) {
            idSignature = targetSignId.parentElement.id;
          }

           indexApprover = targetSignId.parentElement.id.indexOf('-approver-');
           const indexSign = targetSignId.parentElement.id.indexOf('-sign-');
           signId = targetSignId.parentElement.id.slice(indexSign + 6, indexApprover);
           userId = targetSignId.parentElement.id.slice(indexApprover + 10);
           signUuid = targetSignId.parentElement.id.slice(0, indexSign);
        });

        // const signSelected = this.listSign.filter(item => item.enterpriseId === signId);

        let baseWidth = newDiv.offsetWidth;
        let baseHeight = newDiv.offsetHeight;

        const rerenderSign = () => {
          let signSelected, signatureSelected;
          if (this.listSign.length) {
            if (userId !== null && userId !== undefined && userId !== 'undefined') {
              signSelected = this.listSign.filter(item => (item.enterpriseId === signId || item.idCustomer === signId) && item.userId === userId && ((item.idNumber && signUuid == item.idNumber) || (signUuid == item.contractSignId && item.contractSignId)));
            } else {
              signSelected = this.listSign.filter(item => (item.enterpriseId === signId || item.idCustomer === signId) && ((item.idNumber && signUuid == item.idNumber) || (signUuid == item.contractSignId && item.contractSignId)));
            }
          }
          if (Object.keys(signSelected || {}).length && !Object.keys(signatureSelected || {}).length) {
            newDiv.innerHTML = `<span class="mat-icon material-icons"style="font-size: ${30 * signZoom}px; position: absolute; top: 0; right: 0; cursor: pointer; height: unset; width: unset; color: red;">close</span>
            <div style="font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; align-items: center; text-align: center; height: 100%; color: #00f; cursor: move;">
              ${this.message.getMessage('signature')} ${signSelected[0].name} ${this.message.getMessage('number_sign')} ${signSelected[0].row_number}
            </div>
        `;
          }

          newDiv.appendChild(resizer);
          resizer.style.removeProperty('--zoom');
          resizer.style.setProperty('--zoom', (signZoom).toString());
          return;
        }

        const doDrag = (e) => {
          e.stopPropagation();
          let signSelected, signatureSelected;
          if (this.listSign.length) {
            if (userId !== null && userId !== undefined && userId !== 'undefined') {
              signSelected = this.listSign.filter(item => (item.enterpriseId === signId || item.idCustomer === signId) && ((item.idNumber && signUuid == item.idNumber) || (signUuid == item.contractSignId && item.contractSignId)));
            } else {
              signSelected = this.listSign.filter(item => (item.enterpriseId === signId || item.idCustomer === signId) && ((item.idNumber && signUuid == item.idNumber) || (signUuid == item.contractSignId && item.contractSignId)));
            };
          }
          if (Object.keys(signSelected || {}).length && !Object.keys(signatureSelected || {}).length) {
            signatureWidth = signSelected[0].width * this.zoomLevel / 100;
            signatureHeight = signSelected[0].height * this.zoomLevel / 100;
            newDiv.style.width = (signatureWidth + e.clientX - startX) + 'px';
            newDiv.style.height = (signatureHeight + e.clientY - startY) + 'px';
            let widthHeightRatio_Drag = newDiv.offsetWidth / newDiv.offsetHeight;
            if (widthHeightRatio !== widthHeightRatio_Drag) {
              newDiv.style.height = (newDiv.offsetWidth / widthHeightRatio) + 'px';
              newDiv.style.width = (newDiv.offsetHeight * widthHeightRatio) + 'px';
            }
          } else if (Object.keys(signatureSelected || {}).length) {
            signatureWidth = signatureSelected[0].width * this.zoomLevel / 100;
            signatureHeight = signatureSelected[0].height * this.zoomLevel / 100;
            newDiv.style.width = (signatureWidth + e.clientX - startX) + 'px';
            newDiv.style.height = (signatureHeight + e.clientY - startY) + 'px';
          }

          newDiv.style.maxWidth = (element.offsetWidth - wrapperLeft) + 'px';
          newDiv.style.maxHeight = (element.offsetHeight - wrapperTop) + 'px';
          rerenderSign();
        }

        const stopDrag = (e) => {
          e.stopPropagation();
          if (newDiv.offsetWidth / 2 + wrapperLeft < 0 || newDiv.offsetHeight / 2 + wrapperTop < 0) {
            newDiv.style.width = baseWidth + 'px';
            newDiv.style.height = baseHeight + 'px';
          } else {
            baseWidth = newDiv.offsetWidth;
            baseHeight = newDiv.offsetHeight;
          }
          rerenderSign();
          if (this.listSign.length) {
            this.listSign.forEach(item => {
              if ((item.enterpriseId === signId || item.idCustomer === signId) && ((item.idNumber && signUuid == item.idNumber) || (signUuid == item.contractSignId && item.contractSignId))) {
                item.width = newDiv.offsetWidth * 100 / this.zoomLevel;
                item.height = newDiv.offsetHeight * 100 / this.zoomLevel;
              }
            });
          }
          document.documentElement.removeEventListener('mousemove', doDrag);
          document.documentElement.removeEventListener('mouseup', stopDrag);
        }

        const zoomLevel = this.zoomLevel;
        const files = this.mainFiles;
        let id;
        if (files && files.length && files[this.activeFile]) {
          const file = files[this.activeFile] as any;
          id = file.id ? file.id : file.fileId;
        }
        if (this.listSign.length && Object.keys(this.signSelected || {}).length) {
          this.listSign.forEach(item => {
            if (((item.enterpriseId === this.signSelected.enterpriseId && this.signSelected.enterpriseId) ||
            (item.idCustomer === this.signSelected.idCustomer && this.signSelected.idCustomer)) &&
            item.userId === this.signSelected.userId && item.fileId === id  &&
            ((item.contractSignId && this.signSelected.contractSignId === item.contractSignId) || (this.signSelected.idNumber === item.idNumber && item.idNumber))) {

              item.fileId;
              item.stampPositionLeft = eventMouseup.clientX - signatureWidth / 2 - left;
              item.stampPositionTop = eventMouseup.clientY - signatureHeight / 2 - top;
              item.x = Math.round(100 * wrapperLeft / zoomLevel);
              item.y = Math.round(100 * wrapperTop / zoomLevel);
              item.pageIndex = pageIndex;
              item.zoom = this.zoomLevel / 100;
              item.pdfSrc = this.pdfSrc;
              item.pageNumber = Number(pageNumber);
              item.width = Math.round(newDiv.offsetWidth * 100 / this.zoomLevel);
              item.height = Math.round(newDiv.offsetHeight * 100 / this.zoomLevel);
              item.fileName;
            }
          });
          this.signSelected = null;
        }
      }
      this.changeDataToTable()
    })
    element.addEventListener('click', (clickEvent) => {
      if (this.isLocked) return;
      if (!this.isSelectPosition) {
        const target: HTMLElement = clickEvent.target;
        if (target.id && target.id.includes('contract-code-config-') || target.id.includes('sign-') || (target.parentElement && target.parentElement.id && (target.parentElement.id.includes('sign-') || target.parentElement.id.includes('contract-code-config-')))) {
          const id = target.id ? target.id : target.parentElement.id;
          const indexApprover = id.indexOf('-approver-');
          const indexSign = id.indexOf('-sign-');
          const signId = id.slice(indexSign + 6, indexApprover);
          const userId = id.slice(indexApprover + 10);
          const signUuid = id.slice(0, indexSign); // todo
          if (target.className.includes('mat-icon')) {
            this.deleteSign(signId, userId, signUuid,null);
            return;
          }
        }
      }
    });
    element.addEventListener('mouseleave', (mouseoverEvent) => {
      if (this.isLocked) return;
      this.isMouseLeave = true;
      if (this.isSelectPosition) {
        const nodeOther = document.getElementById('show-frames-notification');
        if (nodeOther) {
          nodeOther.remove();
        }
      }
    });
    element.addEventListener('mouseover', () => {
      if (this.isLocked) return;
      this.isMouseLeave = false;
    });
    element.addEventListener('wheel', (wheelEvent) => {
      if (this.isLocked) return;
      if (this.isSelectPosition) {
        let node = element.querySelector('#show-frames-notification');
        const nodeOther = document.getElementById('show-frames-notification');
        if (!node && nodeOther) {
          nodeOther.remove();
        }
        const boundingClient = element.getBoundingClientRect();
        const { top, left } = boundingClient;
        let signatureWidth, signatureHeight;
        if (Object.keys(this.signSelected || {}).length) {
          signatureWidth = this.signSelected.width * this.zoomLevel / 100;
          signatureHeight = this.signSelected.height * this.zoomLevel / 100;
        }
        let signZoom = this.zoomLevel / 100;
        const widthHeightRatio = this.width / this.height;
        if (!node) {
          const stampNode = document.createElement('div');
          if (Object.keys(this.signSelected || {}).length) {
            stampNode.innerHTML = `<div style="font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; text-align: center; height: 100%; color: #00f; cursor: move;">
            <div id="notify_outside" style="position: absolute;top: -${35 * signZoom}px;left: ${(this.signSelected.width / 2 - 150) * signZoom}px;color: red; width: ${300 * signZoom}px">${this.translateService.instant('messages.click_to_select_sign_position')}</div>
              ${this.message.getMessage('signature')} ${this.signSelected && this.signSelected.name ? this.signSelected.name : null} ${this.message.getMessage('number_sign')} ${this.signSelected.row_number}
            </div>`;
            stampNode.style.width = `${signatureWidth}px`;
            stampNode.style.height = `${signatureHeight}px`;
          }
          this.stampWrapper = stampNode;
          stampNode.style.width = `${signatureWidth}px`;
          stampNode.style.height = `${signatureHeight}px`;
          stampNode.style.position = 'absolute';
          stampNode.setAttribute('id', 'show-frames-notification');
          stampNode.style.left = `${(wheelEvent.clientX - signatureWidth / 2 - left)}px`;
          stampNode.style.top = `${(wheelEvent.clientY - signatureHeight / 2 - top)}px`;
          stampNode.style.zIndex = '1';
          stampNode.style.background = 'rgb(0,0,0,0.2)';
          stampNode.style.border = '1px solid';
          stampNode.style.lineHeight = '1.9';
          stampNode.style.color = '#00f';
          stampNode.style.fontFamily = '\"Times New Roman\", Times, serif';
          stampNode.style.padding = `${10 * this.zoomLevel / 100}px`;
          stampNode.style.minWidth = `calc(300px / 10 * 3 * ${this.zoomLevel / 100})`;
          stampNode.style.minHeight = `calc(136px / 10 * 3 * ${this.zoomLevel / 100})`;
          stampNode.className = 'no-user-select';
          //         Thay dổi kích thước chân ký
          const resizer = document.createElement('div');
          resizer.setAttribute('class', 'resize-div-bot-right');
          resizer.style.setProperty('--zoom', (signZoom).toString());
          stampNode.appendChild(resizer);
          element.appendChild(stampNode);

          let startX;
          let startY;
          let signId;
          let indexApprover;
          let userId;
          let idSignature;
          let signUuid;
          resizer.addEventListener('mousedown', (e) => {
            e.stopPropagation();
            startX = e.clientX;
            startY = e.clientY;
            document.documentElement.addEventListener('mousemove', doDrag);
            document.documentElement.addEventListener('mouseup', stopDrag);
            const targetSignId = e.target as Element;
            if (targetSignId.parentElement.id && targetSignId.parentElement.id.includes('contract-code-config-')) {
              idSignature = targetSignId.parentElement.id;
            }
            // indexApprover = targetSignId.parentElement.id.indexOf('-approver-');
            // signId = targetSignId.parentElement.id.slice(5, indexApprover);
            // userId = targetSignId.parentElement.id.slice(indexApprover + 10);

            indexApprover = targetSignId.parentElement.id.indexOf('-approver-');
            const indexSign = targetSignId.parentElement.id.indexOf('-sign-');
            signId = targetSignId.parentElement.id.slice(indexSign + 6, indexApprover);
            userId = targetSignId.parentElement.id.slice(indexApprover + 10);
            signUuid = targetSignId.parentElement.id.slice(0, indexSign);
          });

          let baseWidth = stampNode.offsetWidth;
          let baseHeight = stampNode.offsetHeight;

          const rerenderSign = () => {
            let signSelected, signatureSelected;
            if (userId !== null && userId !== undefined && userId !== 'undefined') {
              signSelected = this.listSign.filter(item => (item.enterpriseId === signId || item.idCustomer === signId ) && item.userId === userId && ((item.idNumber && signUuid == item.idNumber) || signUuid == item.contractSignId));
            } else {
              signSelected = this.listSign.filter(item => (item.enterpriseId === signId || item.idCustomer === signId && ((item.idNumber && signUuid == item.idNumber) || signUuid == item.contractSignId)));
            };
            if (Object.keys(this.signSelected || {}).length) {
              stampNode.innerHTML = `<span class="mat-icon material-icons"style="font-size: ${30 * signZoom}px; position: absolute; top: 0; right: 0; cursor: pointer; height: unset; width: unset; color: red;">close</span>
              <div style="font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; text-align: center; height: 100%; color: #00f; cursor: move;">
                ${this.message.getMessage('signature')} ${signSelected[0].name} ${this.message.getMessage('number_sign')} ${this.signSelected[0].row_number}
              </div>
          `;
            }
            stampNode.appendChild(resizer);
            resizer.style.removeProperty('--zoom');
            resizer.style.setProperty('--zoom', (signZoom).toString());
            return;
          }

          const doDrag = (e) => {
            e.stopPropagation();
            let signSelected, signatureSelected;
            if (userId !== null && userId !== undefined && userId !== 'undefined') {
              signSelected = this.listSign.filter(item => (item.enterpriseId === signId || item.idCustomer === signId ) && item.userId === userId && ((item.idNumber && signUuid == item.idNumber) || signUuid == item.contractSignId));
            } else {
              signSelected = this.listSign.filter(item => (item.enterpriseId === signId || item.idCustomer === signId && ((item.idNumber && signUuid == item.idNumber) || signUuid == item.contractSignId)));
            }
            if (Object.keys(this.signSelected || {}).length) {
              signatureHeight = signSelected[0].height * this.zoomLevel / 100;
              signatureWidth = signSelected[0].width * this.zoomLevel / 100;
            }

            stampNode.style.width = (signatureWidth + e.clientX - startX) + 'px';
            stampNode.style.height = (signatureWidth + e.clientY - startY) + 'px';
            stampNode.style.maxWidth = (element.offsetWidth - stampNode.offsetLeft) + 'px';
            stampNode.style.maxHeight = (element.offsetHeight - stampNode.offsetTop) + 'px';
            rerenderSign();
          }

          const stopDrag = (e) => {
            e.stopPropagation();
            if (stampNode.offsetWidth / 2 + stampNode.offsetLeft < 0 || stampNode.offsetHeight / 2 + stampNode.offsetTop < 0) {
              stampNode.style.width = baseWidth + 'px';
              stampNode.style.height = baseHeight + 'px';
            } else {
              baseWidth = stampNode.offsetWidth;
              baseHeight = stampNode.offsetHeight;
            }

            rerenderSign();
            if (this.listSign.length) {
              this.listSign.forEach(item => {
                if ((item.enterpriseId === signId || item.idCustomer === signId ) && item.userId === userId && ((item.idNumber && signUuid == item.idNumber) || signUuid == item.contractSignId)) {
                  item.width = stampNode.offsetWidth * 100 / this.zoomLevel;
                  item.height = stampNode.offsetHeight * 100 / this.zoomLevel;
                }
              });
            }
            document.documentElement.removeEventListener('mousemove', doDrag);
            document.documentElement.removeEventListener('mouseup', stopDrag);
          }

          element.appendChild(stampNode);
        } else {
          node.style.left = `${(wheelEvent.clientX - signatureWidth / 2 - left)}px`;
          node.style.top = `${(wheelEvent.clientY - signatureHeight / 2 - top)}px`;
        }
      }
    });
    element.addEventListener('mousemove', (mousemoveEvent) => {
      if (this.isLocked) return;
      if (this.isSelectPosition) {
        // xoá dòng chọn vị trí
        const node = element.querySelector('#show-frames-notification');
        const nodeOther = document.getElementById('show-frames-notification');
        if (!node && nodeOther) {
          nodeOther.remove();
        }
        const boundingClient = element.getBoundingClientRect();
        const { top, left } = boundingClient;
        let signatureWidth, signatureHeight;
        if (Object.keys(this.signSelected || {}).length) {
          signatureWidth = this.signSelected.width * this.zoomLevel / 100;
          signatureHeight = this.signSelected.height * this.zoomLevel / 100;
        }

        let signZoom = this.zoomLevel / 100;
        if (!node) {
          const stampNode = document.createElement('div');
          if (Object.keys(this.signSelected || {}).length) {
            stampNode.innerHTML = `<div style="font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; text-align: center; height: 100%; color: red; cursor: move;">
            <div id="notify_outside" style="position: absolute;top: -${35 * signZoom}px;left: ${(this.signSelected.width / 2 - 150) * signZoom}px;color: red; width: ${300 * signZoom}px"></div>
              ${this.message.getMessage('signature')} ${this.signSelected && this.signSelected.name ? this.signSelected.name : null} ${this.message.getMessage('number_sign')} ${this.signSelected.row_number}
            </div>`;
          }
          stampNode.style.width = `${signatureWidth}px`;
          stampNode.style.height = `${signatureHeight}px`;
          stampNode.style.position = 'absolute';
          stampNode.setAttribute('id', 'show-frames-notification');
          stampNode.style.left = `${(mousemoveEvent.clientX - signatureWidth / 2 - left)}px`;
          stampNode.style.top = `${(mousemoveEvent.clientY - signatureHeight / 2 - top)}px`;
          stampNode.style.zIndex = '1';
          stampNode.style.background = 'rgb(0,0,0,0.2)';
          stampNode.style.border = '1px solid';
          stampNode.style.lineHeight = '1.9';
          if (this.documentCodeNull && !this.isOnAutoNumber) {
            stampNode.style.color = 'red';
          } else {
            stampNode.style.color = '#00f';
          }
          stampNode.style.fontFamily = '\"Times New Roman\", Times, serif';
          stampNode.style.padding = `${10 * signZoom}px`;
          stampNode.className = 'no-user-select';

          element.appendChild(stampNode);

        } else {
          node.style.left = `${(mousemoveEvent.clientX - signatureWidth / 2 - left)}px`;
          node.style.top = `${(mousemoveEvent.clientY - signatureHeight / 2 - top)}px`;
        }
      }
    });
    element.style.opacity = '1';
    element.setAttribute('id', `text-pdf-layer-${pageIndex}-${this.activeFile}`);
    this.maxPageCurrent = pageIndex;
    this.changeDataToTable()
  }

  onClickResize(j: number, isCreateSide:boolean){
    this.setFormChanging();
    if (isCreateSide) {
      this.userSigns[j].signConfig.resize = !this.userSigns[j].signConfig.resize;
    } else {
      const isResize = this.enterprises.at(j).get('resize').value;
      this.enterprises.at(j).get('resize').setValue(!isResize);
    }
  }

  // uploadFile(){
  //   this.commonService.uploadFilesDocumentMoha(this.mainFiles).subscribe(rs => {
  //     this.documentMohaService.updateDocumentUpdload(
  //       document,
  //       (rs) => {
  //           this.show = false;
  //           // navigate to list screen.
  //           if(this.isNegotiate || (this.isUpdate && this.createContractMohaService.document.getValue().negotiate && this.isSaveDraft)){
  //             this.saveContractWithNegotiate(document.id)
  //             return;
  //           }
  //           if (this.isSaveDraft) {
  //             this.toastr.success(this.message.getMessage('messages.save_draft_success'));
  //             this.show = false;
  //             // navigate to list screen.
  //             this.router.navigate(['/home-enterprise/new-document-moha/'], {
  //               // queryParams: navigatorParam
  //               queryParams: {}
  //             });
  //           } else {
  //             this.startSignFlow(document.id);
  //           }

  //       },
  //       (err) => {
  //         // reload screen if deprecate version.
  //         // this.getDocumentById(this.document.id);
  //       },
  //       this.documentCodeDuplicateHanlder.bind(this)
  //     );
  //   });
  // }

  signFlowDetail(ele?: any) {
    let message = 'messages.confirm_start_flow';
    // if (this.isAutoSign) {
    //   message = 'messages.confirm_start_flow_auto_sign';
    // }

    let docName = '';
    if (this.document && this.document.name) {
      docName = this.document.name;
    } else if (ele && ele.name) {
      docName = ele.name;
    }

    let docId = null;
    if (this.document && this.document.id) {
      docId = this.document.id;
    } else if (ele && ele.id) {
      docId = ele.id;
    }

    if(this.mode === 'create' || this.mode === 'update'){
      this.documentMohaService.sendStartSignFlow(docId).subscribe(res => {
        this.toastr.success(this.message.getMessage('messages.start_flow_success'));

        // Use output call method onBackClick to navigate list manager document
        this.router.navigateByUrl('/home-enterprise/contract-digitzation-moha');
      });
    }else{
      this.authenticateAndConfirm(
        this.commonService.format(this.message.getMessage(message), docName),
        () => this.sendStartSignFlow(docId)
      );
  }

  }

  onClickBtnSignFlow(){
    this.saveContract(true);
  }


  deleteSign(enterpriseId: string, userId: string, signUuid ,idCustomer) {
    this.setFormChanging();
    this.returnToPrevPosition();
    const files = this.mainFiles;
    let id;
    if (files && files.length && files[this.activeFile]) {
      const file = files[this.activeFile] as any;
      id = file.id ? file.id : file.fileId;
    }
    if (userId === undefined || userId === '' || userId === null || userId === 'undefined') {
      // la khach hang ca nnhan + doannh nghiep
      if(idCustomer){
        this.listSign = this.listSign.filter(sign => {
          return (sign.enterpriseId !== enterpriseId && sign.idCustomer !== idCustomer && sign.fileId === id) || sign.fileId !== id ||
            ((sign.idNumber && signUuid != sign.idNumber) || (signUuid != sign.contractSignId && sign.contractSignId));
        });
      }
      else{
        this.listSign = this.listSign.filter(sign => {
          return (sign.enterpriseId !== enterpriseId && sign.idCustomer !== enterpriseId && sign.fileId === id) || sign.fileId !== id ||
            ((sign.idNumber && signUuid != sign.idNumber) || (signUuid != sign.contractSignId && sign.contractSignId));
        });
      }
    } else {
      this.listSign = this.listSign.filter(sign => {
        return (sign.userId !== userId && sign.fileId === id) || sign.fileId !== id ||  ((sign.idNumber && signUuid != sign.idNumber) || (signUuid != sign.contractSignId && sign.contractSignId));
      });
    }
    if(enterpriseId){
      const nodeOther = document.getElementById(`${signUuid}-sign-${enterpriseId}-approver-${userId}`);

      if (nodeOther) {
        nodeOther.remove();
      }
    }
    if(idCustomer){
      const nodeOther = document.getElementById(`${signUuid}-sign-${idCustomer}-approver-${userId}`);

      if (nodeOther) {
        nodeOther.remove();
      }
    }

    this.changeDataToTable()
  }

  clearAllSigns() {
    // Xóa tất cả các element chữ ký đang render trên DOM
    this.listSign.forEach(sign => {
      const nodeId = `${sign.signUuid || sign.idNumber}-sign-${sign.enterpriseId || sign.idCustomer}-approver-${sign.userId}`;
      const node = document.getElementById(nodeId);
      if (node) {
        node.remove();
      }
    });
    // Reset mảng dữ liệu
    this.listSign = [];
    this.changeDataToTable();
  }

  showFramesNotification(signSelected, position = null, isContractCodeConfig = false) {
    const nodeOther = document.getElementById('show-frames-notification');
    if (nodeOther) {
      nodeOther.remove();
    }
    const element: any = document.getElementById(`text-pdf-layer-${signSelected.pageIndex}-${this.activeFile}`);
    const signatureWidth = signSelected.width * this.zoomLevel / 100;
    const height = signSelected.height * this.zoomLevel / 100;
    const newTop = position.top ? position.top : 0
    const newLeft = position.left ? position.left : 0
    const stampNode = document.createElement('div');
    const signZoom = this.zoomLevel / 100;
    stampNode.setAttribute('id', 'show-frames-notification');
    let contentNode;
    // keo chan ky
    if (!isContractCodeConfig) {
      contentNode = `<div style="font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; text-align: center; height: 100%; color: red; cursor: move;">
      <div id="notify_outside" style="position: absolute;top: -${35 * signZoom}px;left: ${(signSelected.width / 2 - 150) * signZoom}px;color: red; width: ${300 * signZoom}px">${this.translateService.instant('messages.click_to_select_sign_position')}</div>
        ${this.message.getMessage('signature')} ${this.signSelected && this.signSelected.name ? this.signSelected.name : null} ${this.message.getMessage('number_sign')} ${this.signSelected.row_number}
      </div>`;
    } else {
      // stampNode.style.whiteSpace = 'nowrap';
      stampNode.style.wordBreak = 'break-word';
      if (this.documentCodeNull && !this.isOnAutoNumber) {
        contentNode = `
        <div class="text-danger" style="font-size: ${(signSelected.fontSize ? signSelected.fontSize : 12) * (4 / 3) * signZoom}px;display: flex; flex-direction: column; justify-content: start; align-items: start; text-align: left; height: 100%; cursor: move;">
          ${this.isOnAutoNumber ? this.configAutoNumber : this.message.getMessage('headertable.doc_code_required')}
        </div>
      `;
      } else {
        contentNode = `
        <div style="font-size: ${(signSelected.fontSize ? signSelected.fontSize : 12) * (4 / 3) * signZoom}px;display: flex; flex-direction: column; justify-content: start; align-items: start; text-align: left; height: 100%; color: #00f; cursor: move;">
          ${this.isOnAutoNumber ? this.configAutoNumber : this.document.code}
        </div>
      `;
      }

      //stampNode.style.minWidth = (300 / 10 * 3 * signZoom) + 'px';
      stampNode.style.minHeight = (136 / 10 * 3 * signZoom) + 'px';
      // stampNode.style.minWidth ='fit-content';
      stampNode.style.wordBreak = 'break-word';
    }
    stampNode.style.position = 'absolute';
    stampNode.style.background = 'rgb(0,0,0,0.2)';
    stampNode.innerHTML = contentNode;
    stampNode.style.left = `${newLeft}px`;
    stampNode.style.top = `${newTop}px`;
    stampNode.style.width = `${signatureWidth}px`;
    stampNode.style.height = `${height}px`;
    stampNode.style.zIndex = '1';
    stampNode.style.border = '1px solid #999999';
    stampNode.style.lineHeight = '1.9';
    if (this.documentCodeNull && !this.isOnAutoNumber) {
      stampNode.style.color = 'red';
    } else {
      stampNode.style.color = '#00f';
    };
    if (signSelected.fontSize) {
      stampNode.style.fontSize = signSelected.fontSize;
    };
    if (signSelected.fontFamily) {
      stampNode.style.fontFamily = signSelected.fontFamily;
    } else {
      stampNode.style.fontFamily = '\"Times New Roman\", Times, serif';
    };
    if (signSelected.fontStyle && signSelected.fontStyle.includes('bold')) {
      stampNode.style.fontWeight = 'bold';
    }
    if (signSelected.fontStyle && signSelected.fontStyle.includes('italic')) {
      stampNode.style.fontStyle = 'italic';
    }
    if (signSelected.fontStyle && signSelected.fontStyle.includes('underline')) {
      stampNode.style.textDecoration = 'underline';
    }
    stampNode.style.padding = `${10 * signZoom}px`;
    stampNode.className = 'no-user-select';
    this.stampWrapper = stampNode;
    element.appendChild(stampNode);
  }

  deleteUser(user: any): void {
    this.setFormChanging();
    this.userSigns = this.userSigns.filter(d => d.userId !== user.userId);
    if (user) {
     //xoa chan ky cua nguoi ky duyet
    this.listSign.forEach(sign => {
      if (sign.userId === user.userId) {
        sign.isDelete = true
      }
    });
    if(this.isSignRole(user)){
     this.toastr.error(this.message.getMessage('validation.error_user_no_set_up'));
    }
     this.clickSave = true;
     this.changeDataToTable();
    }
    this.listSign = this.listSign.filter(d => d.userId !== user.userId);
  }

  onPdfLoaded() {
    setTimeout(() => {
      const win = window as any;
      if (win.PDFViewerApplication && win.PDFViewerApplication.pdfCursorTools) {
        win.PDFViewerApplication.pdfCursorTools.switchTool(0); // 0 = SELECT, ép tắt Hand Tool
      }
    }, 2000);
    this.blockUI.stop();
  }

  shouldRenderSignaturePlaceholders(): boolean {
    return this.mode !== 'view' || Number(this.contractStatus) === EnumContractStatus.DRAFT;
  }

  hasRoleOneSelected(): boolean {
    if (!this.userSigns) {
      return false;
    }
    return this.userSigns.some(user => this.isSignRole(user));
  }

  openDialogProcedure(type: number, $event) {
    $event.stopPropagation();
    const dialogRef = this.dialog.open(ProcedureComponent, {
      width: '70%',
      data: {
        type: type,
        internalFlowNotEdit: this.selectedServiceType ? this.selectedServiceType.internalFlowNotEdit : null
      }
    })

    dialogRef.afterClosed().subscribe(rs => {
      if (rs) {
        this.userSigns = [];
        this.clearAllSigns();
        this.subscribeData();
        this.setFormChanging();
      }
    });
  }

  subscribeData() {
    this.subscriptions.add(
      this.createContractService.recordsPartySign.asObservable().subscribe(res => {
        if (res.length) {
          this.enterprises.clear();
          this.enterpriseSign = res.filter(e => e.isCreatedSide);
          const customerSigns = res.filter(e => !e.isCreatedSide);
          if (customerSigns.length > 0) {
            customerSigns.forEach(item => {
              const group = this.fb.group({
                order: [item.order],
                certificateNo: [item.certificateNo, [Validators.required, Validators.pattern(this.certificateNoPattern)]],
                name: [item.name, [Validators.required]],
                customerType: [item.customerType == '10000' ? '10000' : '10001', [Validators.required]],
                email: [item.email, [Validators.pattern(this.emailPattern)]],
                phone: [item.phone, [Validators.required, Validators.pattern(this.phonePattern2)]],
                enterpriseId: [item.enterpriseId],
                enterpriseName: [item.enterpriseName],
                customerId: [item.customerId],
                status: [item.status],
                isCreatedSide: [item.isCreatedSide],
                useDataForTemplate: [item.useDataForTemplate],
                isSignNoLogin: [item.isSignNoLogin],
                resize: [item.resize],
                inputPartyValue: [item.inputPartyValue],
                idCustomer: [uuid.v4()],
                isLoading: [false],
              });
              this.enterprises.push(group);
            });
          }
          this.listSign = this.listSign.map(sign => {
            return {
              ...sign,
              isDelete: true
            }
          });
          this.changeDataToTable();
        }
      })
    );

    this.subscriptions.add(
      this.createContractService.recordsUserPerformSign.asObservable().subscribe(res => {
        this.userSigns = res.map(e => {
          let signConfig = e.signConfig;
          // if (e.role == '2') {
          //   signConfig.showImage = false;
          // }
          return {
            ...e,
            enterpriseId: e.enterpriseSignId,
            //isSignDigitalCertificate: false,
            signConfig: signConfig
          }
        });
        const userSign = this.userSigns.find(user => user.role == '1');
        if (userSign) {
          this.listSign.forEach(sign => {
            if (userSign.enterpriseId === sign.enterpriseSignId) {
              sign.isDelete = true
            }
          })
        }
        this.changeDataToTable();
      })
    );
    this.subscriptions.add(
      this.commonService.getCurrentLanguage().subscribe((lang) => {
        if (lang !== this.language) {
          location.reload();
        }
      })
    );
  }

  onPageRendered(event: any) {
    if (event.pageNumber === 1) {
      this.blockUI.stop();
    }
  }


  changeCTS(user: any) {
    // this.createContractMohaService.recordsUserPerformSign.next(this.RECORD_USER_PERFORM_SIGN);
    this.setFormChangingCTS(true);
    this.filterSignPositionApprove(user);
  }

  filterSignPositionApprove(user: any) {
    const positions = this.createContractMohaService.signPositions.getValue();
    const positionDataChange = positions.filter(position => !(position.enterpriseId === user.enterpriseId && position.userId === user.userId));
    this.createContractMohaService.signPositions.next(positionDataChange);
    this.changePosition.emit(user);
  }

  setFormChangingCTS(changingStatus: boolean): void {
    this.isFormChanging = changingStatus;
    this.hasChange.emit(changingStatus);
  }

  changeDisplaySignature(user: any) {
    // this.createContractMohaService.recordsUserPerformSign.next(this.RECORD_USER_PERFORM_SIGN);
    this.setFormChangingCTS(true);
    this.filterSignPositionApprove(user);
  }

  async upLoadFilepdf(fileOld: any){
    let document: DocumentDTO = DocumentDTO.build();
  // if (this.createContractMohaService.createContractType.getValue() == 1) {
    const fileNeedSave = this.filesUpload;
    if (fileNeedSave.length > 0) {
        if (fileNeedSave.length > 0) {
          if (this.mainFiles != null && this.mainFiles.length > 0){
            const dataMainAttachmentNew = [];
            fileNeedSave.forEach(mainAttachmentNew => {
              var checkExit = false;
              for (const mainAttachment of this.mainFiles) {
                if (mainAttachment.fileName === mainAttachmentNew.fileName) {
                    checkExit = true;
                    break;
                }
              }
              if(checkExit == false){
                dataMainAttachmentNew.push({
                  ...mainAttachmentNew
              });
              }

            });
            //this.filepdfNew = [...this.filepdfNew, ...dataMainAttachmentNew]; //
            this.mainFiles = [...this.mainFiles, ...dataMainAttachmentNew];
            document.mainContractAttachments = this.mainFiles;
          }else{
            document.mainContractAttachments = this.mainFiles;
          }
        } else {
          let mainContractAttachmentsNew = document.mainContractAttachments.filter(att => {
            const findInFileUpload = this.createContractMohaService.fileUploadArray.getValue().find((file: any) => file.id === att.id);
            if(!att.src)
              return findInFileUpload;
          });
          const dataMainAttachmentNew = [];
          // mainContractAttachmentsNew = mainContractAttachmentsNew.concat(rs.data);
          document.filePath = mainContractAttachmentsNew[0].path;
          document.fileNameUpdate = mainContractAttachmentsNew[0].fileName;
          document.fileSizeUpdate = mainContractAttachmentsNew[0].fileSize;
          document.mainContractAttachments.forEach((mainAttachment, index) => {
            mainContractAttachmentsNew.forEach((mainAttachmentNew2) => {
              if(mainAttachment.fileName === mainAttachmentNew2.fileName) {
                dataMainAttachmentNew.push({
                  attachmentOrder: index,
                  ...mainAttachmentNew2
                });
              }
            })
          });
          document.mainContractAttachments = [...dataMainAttachmentNew];
          this.mainContractAttachments = document.mainContractAttachments;
          this.mainFiles = this.mainContractAttachments;
        }
        document.signPositions = document.signPositions ? document.signPositions.map(sign => {
          const fileDoc = document.mainContractAttachments.find(file => encodeURIComponent(file.fileName) === sign.fileId);
          if (fileDoc && fileDoc.id) {
            sign.fileId = fileDoc.id;
          }
          return sign;
        }) : [];
        if (document.enterpriseSign) {
          document.enterpriseSign.forEach(ele => {
            if(ele.isSetupSignFlow){
              ele.customerApproves.forEach(ala =>{
                ala.positions = ala.positions.map(sign => {
                  const fileDoc = document.mainContractAttachments.find(file => encodeURIComponent(file.fileName) === sign.fileId);
                  if (fileDoc && fileDoc.id) {
                    sign.fileId = fileDoc.id;
                  }
                  return sign;
                });
              })
            }
          })
        }
    } else {
      let mainContractAttachmentsNew = document.mainContractAttachments.filter(att => {
        const findInFileUpload = this.createContractMohaService.fileUploadArray.getValue().find((file: any) => file.id === att.id);
        return findInFileUpload;
      });
      const dataMainAttachmentNew = [];
      document.filePath = mainContractAttachmentsNew.length ? mainContractAttachmentsNew[0].path : null;
      document.fileNameUpdate = mainContractAttachmentsNew.length ? mainContractAttachmentsNew[0].fileName : null;
      document.fileSizeUpdate = mainContractAttachmentsNew.length ? mainContractAttachmentsNew[0].fileSize : null;
      document.mainContractAttachments.forEach((mainAttachment, index) => {
        mainContractAttachmentsNew.forEach(mainAttachmentNew3 => {
          if(mainAttachment.fileName === mainAttachmentNew3.fileName) {
            dataMainAttachmentNew.push({
              attachmentOrder: index,
              ...mainAttachmentNew3
            });
          }
        });
      });
      document.mainContractAttachments = [...dataMainAttachmentNew];
      document.enterpriseSign.forEach(ele => {
        if(ele.isSetupSignFlow){
          ele.customerApproves.forEach(ala =>{
            ala.positions = ala.positions.map(sign => {
              const fileDoc = document.mainContractAttachments.find(file => encodeURIComponent(file.fileName) === sign.fileId);
              if (fileDoc && fileDoc.id) {
                sign.fileId = fileDoc.id;
              }
              return sign;
            });
          })
        }
      })
    }
  }

  checkAuthenVneid(callback?: () => void, onCancel?: () => void) {
    this.documentMohaService.getCheckVneidConfirm(null, true).subscribe(res => {
      if (res && res.success === false) {
        this.toastr.error(res.message);
        return;
      }
      // API có thể trả envelope {success, data} hoặc data trực tiếp
      this.dataCheckVneid = (res && res.data) ? res.data : res;
      if (this.dataCheckVneid && this.dataCheckVneid.typeVerify) {
        switch (this.dataCheckVneid.typeVerify) {
          case 'SHARE_INFO':
            this.openRequestConfirmIdentity(callback, onCancel);
            break;
          case 'FACE_MATCH':
            this.openRequestConfirmIdentity(callback, onCancel);
            break;
          case 'VERIFIED':
            if (callback) callback();
            break;
        }
      }
    })
  }

  private openRequestConfirmIdentity(callback?: () => void, onCancel?: () => void): void {
    const dialogRef = this.dialog.open(RequestConfirmIdentityComponent, {
      width: this.deviceService.isMobile() ? '100%' : '640px',
      panelClass: 'scontract-overlay-dialog',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.openEnterIdentityVneid(callback, onCancel);
      } else {
        if (onCancel) onCancel();
      }
    });
  }

  private openEnterIdentityVneid(callback?: () => void, onCancel?: () => void): void {
    const dialogRef = this.dialog.open(EnterIdentityVneidComponent, {
      panelClass: 'sign-authentication',
      width: '1080px',
      maxWidth: '90vw',
      height: 'auto',
      disableClose: true,
      data: {
        documentId: null,
        dataCheckVneid: this.dataCheckVneid,
        onCancel: onCancel,
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!result) {
        if (onCancel) {
          onCancel();
          return;
        }
        this.openRequestConfirmIdentity(callback);
        return;
      } else {
        callback();
      }
    });
  }

  // startSignFlow(element) {
  //   this.checkAuthenVneid(() => {
  //     this.checkTindy(() => {
  //       this.signFlow(element);
  //     });
  //   });
  // }

  // signFlow(element) {
  //             const documentId = element.id;
  //             const documentName = element.name;
  //             const documentStatus = element.status;
  //             const autoSign = element.autoSign;
  //             let message = 'messages.confirm_start_flow';
  //             if (autoSign) {
  //               message = 'messages.confirm_start_flow_auto_sign';
  //             }
  //             const dialogRe = this.dialog.open(WarningComponent, {
  //               width: '500px',
  //               data: this.commonService.format(this.message.getMessage(message), documentName)
  //             });
  //             dialogRe.afterClosed().subscribe(rs => {
  //               if (rs) {
  //                 this.documentMohaService.sendStartSignFlow(documentId).subscribe(res => {
  //                   if(res.success) {
  //                     this.toastr.success(this.message.getMessage('messages.start_flow_success'));
  //                     // bind datasource again
  //                     //this.dataSelected = this.dataSelected.filter(id => id !== documentId);
  //                     //this.onFilterData(this.paginate.currentPage, this.paginate.pageSize);
  //                   } else {
  //                     this.toastr.error(res.message);
  //                   }
  //                 });
  //               }
  //      });
  //  }

   downloadEvidentFile(contractId: string) {
    this.documentMohaService.downloadFileEvident(contractId).subscribe({
      next: (res: Blob) => {
        // Trường hợp server trả status 200 nhưng body thực chất là JSON lỗi
        if (res.type && res.type.indexOf('application/json') !== -1) {
          (res as any).text().then((text: string) => {
            try {
              const err = JSON.parse(text);
              this.toastr.error(err.message || this.message.getMessage('messages.download_evident_fail'));
            } catch (e) {
              console.error('Response text is not valid JSON:', text);
              this.toastr.error(this.message.getMessage('messages.download_evident_fail'));
            }
          });
          return;
        }

        // Trường hợp thành công, res là file XML thật
        const fileName = `CERTIFICATION_Viettel_${this.document.code}_evident.xml`;
        this.downLoadFile(res, 'application/octet-stream', fileName);
        this.toastr.success(this.message.getMessage('messages.download_evident_success'));
      },
      error: (err) => {
        // Trường hợp lỗi HTTP (4xx/5xx), body có thể là Blob chứa JSON
        if (err.error instanceof Blob) {
          err.error.text().then((text: string) => {
            try {
              const parsed = JSON.parse(text);
              this.toastr.error(parsed.message || this.message.getMessage('messages.download_evident_fail'));
            } catch (e) {
              console.error('Error response text is not valid JSON:', text);
              this.toastr.error(this.message.getMessage('messages.download_evident_fail'));
            }
          });
        } else {
          const errMessage = (err.error && err.error.message) || err.message || this.message.getMessage('messages.download_evident_fail');
          this.toastr.error(errMessage);
        }
      }
    });
  }

  checkTindy(callback?: () => void, onCancel?: () => void, showPopup: boolean = true) {
    const handleFalse = () => {
      this.checkTindyStatus = false;
      if (onCancel) onCancel();
    };
  
    this.contractService.checkTindyUser().subscribe(ref => {
      if (ref && typeof ref === 'object' && ref.success === false) {
        this.toastr.error(ref.message);
        handleFalse();
        return;
      }
      // API có thể trả envelope {success, data} hoặc data trực tiếp
      const tindyStatus = (ref && typeof ref === 'object' && ref.data !== undefined) ? ref.data : ref;
      if (tindyStatus == 0 || tindyStatus == 2) {
        if (!showPopup) {
          handleFalse();
          return;
        }
  
        //Popup anthention data
        let message = "";
        if (tindyStatus == 2) {
          message = this.message.getMessage('notifyTindy.notify');
        } else if (tindyStatus == 0) {
          message = this.message.getMessage('notifyTindy.notify_2');
        }
        const confirmDialog = this.dialog.open(WarningDataAuthenticationComponent, {
          width: '469px',
          height: '348px',
          data: {
            message
          }
        });
        confirmDialog.afterClosed().subscribe(ref => {
          if (ref) {
            this.dialog.open(SignAuthenticationPopupComponent, {
              panelClass: 'sign-authentication',
              width: '791px',
              height: 'auto',
              data: {
                message,
                onAuthenSuccess: () => {
                  this.checkTindyStatus = true;
                  if (callback) callback();
                },
                onAuthenCancel: handleFalse,
              }
            });
          } else {
            handleFalse();
          }
        });
      } else if (tindyStatus == 1) {
        this.checkTindyStatus = true;
        if (callback) callback();
      }
    });
  }

  private async initAppendixFromOriginal(id: string) {
    this.blockUI.start();
    try {
  
      // 2. Lấy dữ liệu hợp đồng gốc
      const res = await this.digitalContractService.getContractMohaById(id).toPromise();
      if (!res || !res.success || !res.data) {
        this.toastr.error(res && res.message);
        this.router.navigateByUrl('/home-enterprise/contract-digitzation-moha');
        return;
      }
      const data = res.data;

      const listUser = [];
        if(res.data.contractEnterprise && res.data.contractEnterprise.length > 0){
          res.data.contractEnterprise.forEach(ele =>{
            listUser.push({
              enterpriseId: ele.enterpriseId || "",
              order: ele.order|| "",
              email: ele.enterpriseEmail|| "",
              enterpriseName: "",
              phone: ele.enterprisePhone || "",
              status: 1,
              isCreatedSide: ele.createdSide || "",
              customerId: ele.customerId || "",
              customerCode:ele.customerCode || "",
              name: ele.enterpriseName || "",
              certificateNo: ele.certificateNo || "",
              useDataForTemplate: false,
              isSignNoLogin: ele.isSignNoLogin || "",
              signConfig: ele.signConfig || "",
              customerType : ele.customerType})
          })
        }

        this.RECORD_PARTY_SIGN = listUser;
        this.createContractMohaService.recordsPartySign.next(this.RECORD_PARTY_SIGN);

        if(res.data.customerMohaId){
          this.createContractMohaService.customerMohaId= res.data.customerMohaId;
          this.createContractMohaService.idCustomerDefault = this.createContractMohaService.customerMohaId;
         }
      // 3. Ghi nhận hợp đồng gốc
      this.originalContractId = id;
        this.originalContract = { id: data.id, code: data.code, name: data.name };
        this.listOriginalContact = [{
          id: data.id,
          code: data.code,
          name: data.name,
          typeId: data.typeId        
        }];
        this.isAppendix = true;
        this.filesAttachment = [];
        this.filesAttachmentOld = [];

        this.mainFormAdd.controls['editProperty'].setValidators([Validators.required]);
        this.mainFormAdd.controls['editProperty'].updateValueAndValidity();
        this.getAdjustedContents();
      // 4. Điền sẵn dữ liệu (giống getInfoPl: giữ customerMohaId, fields; bỏ code, name, ngày, file...)
      this.createContractMohaService.customerMohaId = data.customerMohaId ? data.customerMohaId : null;
      this.createContractMohaService.contractMohaFields = data.contractMohaFields || [];
      
      await this.fillCustomerParties(data);      // 1. Bên ký kết (khách hàng)
      this.fillInternalUserSigns(data);          // 2. Bên lập: người ký + người phê duyệt
      this.fillLinkedContracts(data);            // 3. Hợp đồng/văn bản liên kết
    } finally {
      this.blockUI.stop();
    }
  }

  private async fillCustomerParties(data: any) {
    let listUser: any[] = [];
    const enterprises = data.contractEnterprise;
  
    if (Array.isArray(enterprises) && enterprises.length > 0) {
      // ...giữ nguyên đoạn map như trước
    } else if (data.customerMohaId) {
      // Dự phòng: dựng từ khách hàng theo customerMohaId
      const rs = await this.customerService.getCustomer(data.customerMohaId).toPromise();
      if (rs && rs.data) {
        const c = rs.data;
        listUser = [{
          enterpriseId: c.enterpriseId || '',
          order: 1,
          email: c.email || '',
          enterpriseName: '',
          phone: c.phone || '',
          status: this.enumContractEnterpriseStatus.NO_PROCESS,
          isCreatedSide: false,
          customerId: data.customerMohaId,
          customerCode: c.customerCode || '',
          name: c.name || '',
          certificateNo: c.taxCode || c.certificateNo || '',
          useDataForTemplate: false,
          isSignNoLogin: false,
          customerType: c.customerType
        }];
      }
    }
    if (listUser.length === 0) return;
  
    this.RECORD_PARTY_SIGN = listUser;
    this.createContractMohaService.recordsPartySign.next(listUser);
    this.createContractMohaService.createContractType.next(1);
    this.mainFormAdd.controls.checkUser.setValue(JSON.stringify(listUser));
  }

  private fillInternalUserSigns(data: any) {
    this.userSigns = [];
  const list = (data.userSign || []).filter(ele => ele.isCreatedSide === true);
  
  list.forEach(ele => {
      let signConfig: any = {};
      try {
        signConfig = ele.signConfig
          ? (typeof ele.signConfig === 'string' ? JSON.parse(ele.signConfig) : ele.signConfig)
          : {};
      } catch (e) { signConfig = {}; }
  
      this.userSigns.push({
        order: ele.order || '',
        userId: ele.userId || '',
        enterpriseId: ele.enterpriseId || '',
        enterpriseSignId: ele.enterpriseSignId || '',
        name: ele.name || '',
        userName: ele.userName || '',
        phone: ele.phone || '',
        userPhone: ele.userPhone || '',
        email: ele.email || '',
        userEmail: ele.userEmail || '',
        role: String(ele.role || ''),                 // template so sánh '1' / '2'
        isCreatedSide: ele.isCreatedSide || false,
        departmentName: ele.departmentName || null,
        departmentId: ele.departmentId || null,
        isSignDigitalCertificate: ele.isSignDigitalCertificate || false,
        signConfig: signConfig,
        userPosition: ele.userPosition || '',
        createdBy: localStorage.getItem('userId'),     // người lập phụ lục
        status: 1,                                     // reset về chưa xử lý
        contractUserId: String(Math.floor(1000000 + Math.random() * 9000000))  // id mới, giống autocompleteUserSelected
      });
    });
  }

  private fillLinkedContracts(data: any) {
    const parents = Array.isArray(data.parents) ? data.parents : [];
    this.dataDocumentParent = parents.map(p => ({
      code: p.code,
      name: p.name,
      id: p.id,
      typeId: p.typeId,
      contractTerminationStatus: p.contractTerminationStatus,
      status: p.status
    }));
    this.mainFormAdd.controls.checkParent.setValue(JSON.stringify(this.dataDocumentParent));
  }


  private async fillAttachments(data: any) {
    const attachments = (data.contractAttachments || []).filter(item => item.AttachmentType !== 40000);
    if (attachments.length === 0) return;
  
    const files: File[] = [];
    for (const att of attachments) {
      try {
        const blob = await this.digitalContractService.getContractFiles(att.id).toPromise();
        files.push(new File([blob], att.fileName, { type: (blob as any).type || '' }));
      } catch (e) {
        this.toastr.error(this.message.getMessage('messages.notGetPdf') /* hoặc message phù hợp */);
      }
    }
    this.filesAttachment = files;
    // filesAttachmentOld giữ rỗng vì đây là phụ lục mới, không phải file cũ của chính nó
  }

  selectedAdjustChange(event) {
    const selectedEditContent = this.adjustedContents.find(item => item.type === event.value);
    if (selectedEditContent) {
      this.adjustedContentSelected = selectedEditContent;
      this.createContractMohaService.adjustedContentSelected.next(this.adjustedContentSelected);
      this.createContractMohaService.contractMohaUpdateFields = [];
    }
  }

  getAdjustedContents() {
    this.contractService.getPropertiesForUpdate().subscribe(response => {
      if (response && response.data) {
        this.adjustedContents = response.data.map(content => ({
          ...content,
          title: this.createContractMohaService.convertTitleContent(content.type)
        }));
      }
    });
  }

  goToContractLiquidated(id){
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/home-enterprise/view-document-moha-digital/' + id],  {queryParams: {goFrom: this.goFrom, isOnlyView: true}})
    );
    window.open(url, '_blank')
  }

  private async initAppendixForUpdateOrView(data: any) {
    this.isAppendix = true;

    if(data.contractOriginalDTO){
    const orig = data.contractOriginalDTO;
    this.originalContractId = orig.id;
    this.originalContract = { id: orig.id, code: orig.code, name: orig.name };
    this.listOriginalContact = [{ id: orig.id, code: orig.code, name: orig.name, typeId: orig.typeId }];

    const objectServiceType = this.serviceTypes.find(item => item.id == data.serviceType);
    this.createContractMohaService.selectedServiceType.next(objectServiceType);
    this.isOnAutoNumber = objectServiceType.isOnAutoNumber;
    if (this.isOnAutoNumber) {
      this.mainFormAdd.controls['docCode'].setValue('');
      this.mainFormAdd.controls['docCode'].disable();
    } else {
      this.mainFormAdd.controls['docCode'].enable();
    }
  
    // Service cho bước 3
    this.createContractMohaService.originalContract.next(orig.id);
    }
    this.createContractMohaService.createContractType.next(1);
    this.createContractMohaService.contractMohaUpdateFields = data.contractMohaUpdateFields || [];
    
    // Lấy danh sách nội dung điều chỉnh rồi chọn sẵn
    const rs = await this.contractService.getPropertiesForUpdate().toPromise();
    if (rs && rs.data) {
      this.adjustedContents = rs.data.map(c => ({
        ...c,
        title: this.createContractMohaService.convertTitleContent(c.type)
      }));
    }
    const selected = this.adjustedContents.find(i => i.type === data.editProperty);
    if (selected) {
      this.adjustedContentSelected = selected;
      this.createContractMohaService.adjustedContentSelected.next(selected);
    }
    this.mainFormAdd.controls['editProperty'].setValidators([Validators.required]);
    this.mainFormAdd.controls['editProperty'].setValue(data.editProperty, { emitEvent: false });
    this.mainFormAdd.controls['editProperty'].updateValueAndValidity();
  }

  onChangeZoom(event: any) {
    this.zoomLevel = event * 100;
  }

  private handleCreateContract(isCreate: boolean, formContract: any, isSign: boolean, controls: any) {
    const action = () =>
      isCreate
        ? this.createContract(formContract, isSign, controls)
        : this.updateContract(formContract, isSign);
  
    // Không ký -> chạy thẳng, không cần xác thực
    if (!isSign) {
      action();
      return;
    }
  
    // Ký -> xác thực (Tindy / VneID) + xác nhận rồi mới chạy
    this.authenticateAndConfirm(
      this.commonService.format(
        this.message.getMessage('messages.confirm_start_flow'),
        this.mainFormAdd.controls.docName.value
      ),
      action
    );
  }

  private authenticateAndConfirm(confirmData: string, onConfirmed: () => void) {
    const confirmAndRun = () => {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '500px',
        data: confirmData
      });
  
      dialogRe.afterClosed().subscribe(rs => {
        if (rs) {
          onConfirmed();
        }
      });
    };
  
    this.checkTindy(
      () => confirmAndRun(),
      () => {
        this.checkAuthenVneid(() => {
          this.checkTindy(
            () => confirmAndRun(),
            () => { /* Tindy lần 2 bị hủy/lỗi -> dừng luồng */ }
          );
        });
      },
      false
    );
  }

  private sendStartSignFlow(docId: any) {
    this.documentMohaService.sendStartSignFlow(docId).subscribe(res => {
      this.toastr.success(this.message.getMessage('messages.start_flow_success'));
      this.router.navigateByUrl('/home-enterprise/contract-digitzation-moha');
    });
  }

  private authenticateTindyVneid(onSuccess: () => void, onCancel: () => void = () => {}) {
    this.checkTindy(
      () => onSuccess(),
      () => {
        this.checkAuthenVneid(
          () => this.checkTindy(() => onSuccess(), onCancel),
          onCancel
        );
      },
      false
    );
  }

  protected readonly enumContractUserRole = EnumContractUserRole;
  protected readonly roleUser = EnumContractUserRole;
  protected readonly enumSignMethod = EnumSignMethod;
  protected readonly enumContractUserStatus = EnumContractUserStatus;
  protected readonly enumContractDetailType = EnumContractDetailType;
  protected readonly enumContractStatus = EnumContractStatus;
  protected readonly enumApproverStatus = EnumApproverStatus;
}
